// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advisory_panel_panel {
  position: absolute;
  top: 0;
  right: 0;
  width: 260px;
  height: 100%;
  z-index: 50;
  background: var(--vnsc-bg-primary);
  border-left: 1px solid var(--vnsc-border-primary);
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: var(--vnsc-text-primary);
  overflow: hidden;
}
.advisory_panel_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px 8px;
  border-bottom: 1px solid var(--vnsc-border-primary);
  background: var(--vnsc-bg-secondary);
}
.advisory_panel_title {
  font-weight: 700;
  font-size: 13px;
}
.advisory_panel_headerActions {
  display: flex;
  gap: 6px;
}
.advisory_panel_refreshBtn {
  background: none;
  border: 1px solid var(--vnsc-border-secondary);
  color: var(--vnsc-text-secondary);
  border-radius: 4px;
  cursor: pointer;
  padding: 2px 6px;
  font-size: 11px;
  transition:
    background-color 0.15s ease,
    color 0.15s ease,
    border-color 0.15s ease;
}
.advisory_panel_refreshBtn:hover:not(:disabled) {
  background: var(--vnsc-bg-hover);
  color: var(--vnsc-text-primary);
  border-color: var(--vnsc-text-disabled);
}
.advisory_panel_refreshBtn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.advisory_panel_closeBtn {
  background: none;
  border: none;
  color: var(--vnsc-text-tertiary);
  cursor: pointer;
  font-size: 14px;
  padding: 0 4px;
  transition: color 0.15s ease;
}
.advisory_panel_closeBtn:hover {
  color: var(--vnsc-text-primary);
}
.advisory_panel_body {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}
.advisory_panel_skeletonRow {
  height: 40px;
  background: var(--vnsc-bg-tertiary);
  border-radius: 4px;
  margin-bottom: 8px;
  animation: advisory_panel_pulse 1.2s ease-in-out infinite;
}
@keyframes advisory_panel_pulse {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}
.advisory_panel_decisionBadge {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.advisory_panel_decisionLabel {
  flex: 1;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  letter-spacing: 0.5px;
}
.advisory_panel_decisionStrongBuy {
  background: var(--vnsc-color-success-hover);
  color: var(--vnsc-text-on-primary);
}
.advisory_panel_decisionBuy {
  background: var(--vnsc-color-success);
  color: var(--vnsc-text-on-primary);
}
.advisory_panel_decisionHold {
  background: var(--vnsc-color-neutral);
  color: var(--vnsc-text-on-primary);
}
.advisory_panel_decisionSell {
  background: var(--vnsc-color-warning);
  color: var(--vnsc-text-on-primary);
}
.advisory_panel_decisionStrongSell {
  background: var(--vnsc-color-error);
  color: var(--vnsc-text-on-primary);
}
.advisory_panel_confidence {
  text-align: center;
}
.advisory_panel_confidenceLabel {
  color: var(--vnsc-text-tertiary);
  font-size: 10px;
}
.advisory_panel_confidenceValue {
  font-weight: 700;
  font-size: 13px;
}
.advisory_panel_agentRows {
  margin-bottom: 8px;
}
.advisory_panel_agentRow {
  border-bottom: 1px solid var(--vnsc-border-primary);
  padding-bottom: 8px;
  margin-bottom: 8px;
}
.advisory_panel_agentHeader {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}
.advisory_panel_agentName {
  flex: 1;
  font-size: 12px;
  color: var(--vnsc-text-primary);
  font-weight: 500;
}
.advisory_panel_agentWeight {
  color: var(--vnsc-text-tertiary);
  font-size: 11px;
  margin-left: 4px;
}
.advisory_panel_agentSignal {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  background: var(--vnsc-color-neutral);
  color: var(--vnsc-text-on-primary);
  letter-spacing: 0.5px;
}
.advisory_panel_agentSignalBuy {
  background: var(--vnsc-color-success);
}
.advisory_panel_agentSignalSell {
  background: var(--vnsc-color-error);
}
.advisory_panel_agentSignalHold {
  background: var(--vnsc-color-neutral);
}
.advisory_panel_agentExpand {
  color: var(--vnsc-text-tertiary);
  font-size: 10px;
}
.advisory_panel_agentScoreBar {
  height: 4px;
  background: var(--vnsc-border-primary);
  border-radius: 2px;
  margin-top: 6px;
  overflow: hidden;
}
.advisory_panel_agentScoreFill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.3s ease;
}
.advisory_panel_agentExplanation {
  margin-top: 8px;
  font-size: 11px;
  color: var(--vnsc-text-secondary);
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}
.advisory_panel_explanationToggle {
  background: none;
  border: none;
  color: var(--vnsc-text-link);
  cursor: pointer;
  font-size: 11px;
  padding: 0;
  text-decoration: underline;
  transition: color 0.15s ease;
}
.advisory_panel_explanationToggle:hover {
  color: var(--vnsc-text-link-hover);
}
.advisory_panel_explanationContent {
  margin-top: 8px;
  font-size: 11px;
  color: var(--vnsc-text-secondary);
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}
.advisory_panel_timestamp {
  margin-top: 10px;
  font-size: 10px;
  color: var(--vnsc-text-tertiary);
  text-align: right;
}
.advisory_panel_emptyState {
  text-align: center;
  color: var(--vnsc-text-placeholder);
  padding-top: 24px;
  font-size: 12px;
}
.advisory_panel_emptyIcon {
  font-size: 24px;
  margin-bottom: 8px;
}
@media (max-width: 480px) {
  .advisory_panel_panel {
    width: 100%;
    height: auto;
    max-height: 50%;
    bottom: 0;
    top: auto;
    border-left: none;
    border-top: 1px solid var(--vnsc-border-primary);
  }
}

.drawing_dock_dock {
  position: absolute;
  z-index: 50;
  width: 360px;
  min-height: 200px;
  max-height: 500px;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: var(--vnsc-radius-lg, 6px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  font-family: var(--gc-font, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
  font-size: var(--vnsc-font-sm, 11px);
  color: var(--vnsc-text-primary, #e0e0e0);
}
.drawing_dock_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-primary, #0a0e14);
  border-radius: var(--vnsc-radius-lg, 6px) var(--vnsc-radius-lg, 6px) 0 0;
}
.drawing_dock_titleBlock {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.drawing_dock_titleBlock strong {
  font-size: 12px;
  font-weight: 600;
  color: var(--vnsc-text-primary);
}
.drawing_dock_titleBlock span {
  font-size: 10px;
  color: var(--vnsc-text-secondary);
}
.drawing_dock_headerActions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.drawing_dock_icon {
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.drawing_dock_icon:hover {
  background-color: var(--vnsc-bg-tertiary, #f1f5f9);
  color: var(--vnsc-text-primary);
}
.drawing_dock_tabs {
  display: flex;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-primary, #0a0e14);
}
.drawing_dock_tab {
  flex: 1;
  padding: 8px 12px;
  border: none;
  background: transparent;
  color: var(--vnsc-text-secondary);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
}
.drawing_dock_tab:hover {
  color: var(--vnsc-text-primary);
  background-color: var(--vnsc-bg-tertiary, #f1f5f9);
}
.drawing_dock_tabActive {
  color: var(--vnsc-accent, #2962ff);
  border-bottom-color: var(--vnsc-accent, #2962ff);
}
.drawing_dock_body {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}
.drawing_dock_empty {
  color: var(--vnsc-text-secondary);
  font-style: italic;
  text-align: center;
  padding: 20px;
}
.drawing_dock_resizeHandle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 18px;
  height: 18px;
  cursor: nwse-resize;
  background:
    linear-gradient(
      135deg,
      transparent 0%,
      transparent 40%,
      var(--vnsc-text-secondary, #888) 40%,
      var(--vnsc-text-secondary, #888) 44%,
      transparent 44%,
      transparent 56%,
      var(--vnsc-text-secondary, #888) 56%,
      var(--vnsc-text-secondary, #888) 60%,
      transparent 60%);
  opacity: 0.4;
  transition: opacity 0.15s ease;
  border-radius: 0 0 var(--vnsc-radius-lg, 6px) 0;
  z-index: 1;
}
.drawing_dock_resizeHandle:hover {
  opacity: 0.8;
}
@media (max-width: 480px) {
  .drawing_dock_dock {
    width: calc(100vw - 32px);
    max-width: 360px;
  }
}
.drawing_dock_templateManager {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.drawing_dock_templateGroup {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.drawing_dock_templateLabel {
  font-size: 11px;
  font-weight: bold;
  color: var(--vnsc-text-secondary, #888);
}
.drawing_dock_templateRow {
  display: flex;
  gap: 6px;
}
.drawing_dock_templateSelect,
.drawing_dock_templateInput {
  flex: 0 1 200px;
  min-width: 120px;
  background: var(--vnsc-surface-raised, rgba(30, 41, 59, 0.9));
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.1));
  border-radius: 4px;
  padding: 6px 8px;
  color: var(--vnsc-text-primary, #fff);
  font-size: 12px;
}
.drawing_dock_templateButton {
  background: var(--vnsc-accent, #0891b2);
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  color: var(--vnsc-text-primary, #fff);
  font-size: 12px;
  cursor: pointer;
}
.drawing_dock_templateButtonDanger {
  background: var(--vnsc-danger, #ef5350);
}
.drawing_dock_templateButton:disabled,
.drawing_dock_templateButtonDanger:disabled {
  background: var(--vnsc-surface-muted, rgba(255, 255, 255, 0.05));
  color: var(--vnsc-text-disabled, #666);
  cursor: default;
}
.drawing_dock_templateDivider {
  height: 1px;
  background: var(--vnsc-border-subtle, rgba(255, 255, 255, 0.08));
  margin: 4px 0;
}

.floating_chart_bar_bar {
  position: absolute;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
  max-width: 320px;
  overflow: hidden;
  box-sizing: border-box;
  transition:
    max-width 0.2s ease,
    height 0.2s ease,
    opacity 0.2s ease,
    border-radius 0.2s ease,
    padding 0.2s ease;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 8px;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  font-family:
    Helvetica Neue,
    Helvetica,
    Arial,
    sans-serif;
  user-select: none;
  white-space: nowrap;
}
.floating_chart_bar_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 3px;
  background: transparent;
  color: var(--vnsc-text-secondary, #a0a0a0);
  cursor: pointer;
  flex-shrink: 0;
}
.floating_chart_bar_btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--vnsc-text-primary, #e0e0e0);
}
.floating_chart_bar_btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.floating_chart_bar_btnActive {
  color: var(--vnsc-primary, #2962ff);
}
.floating_chart_bar_separator {
  width: 1px;
  height: 18px;
  background: var(--vnsc-border, #2a2a2a);
  margin: 0 4px;
  flex-shrink: 0;
}
.floating_chart_bar_grip {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 24px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  flex-shrink: 0;
}
@media (hover: hover) {
  .floating_chart_bar_bar:not(:hover):not(:focus-within) {
    max-width: 40px;
    height: 18px;
    padding: 1px 8px;
    border-radius: 13px;
    opacity: 0.85;
  }
  .floating_chart_bar_bar:not(:hover):not(:focus-within) > :not(.floating_chart_bar_grip) {
    opacity: 0;
  }
  .floating_chart_bar_bar:not(:hover):not(:focus-within) > .floating_chart_bar_grip {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 14px;
  }
  .floating_chart_bar_bar:not(:hover):not(:focus-within) > .floating_chart_bar_grip svg {
    width: 12px;
    height: 12px;
  }
}

.fork_overlays_forkXAxisOverlay {
  position: absolute;
  inset: 0;
  z-index: 32;
  pointer-events: none;
}
.fork_overlays_forkXAxisTick {
  position: absolute;
  transform: translateX(-50%);
  z-index: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.fork_overlays_forkXAxisTickLeftEdge {
  transform: translateX(0);
}
.fork_overlays_forkXAxisTickRightEdge {
  transform: translateX(-100%);
}
.fork_overlays_forkXAxisTickLine {
  width: 1px;
  height: 6px;
  margin: 0 auto 2px;
}
.fork_overlays_forkXAxisTickLabel {
  font-family:
    Inter,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  white-space: nowrap;
  padding: 0;
  background: none;
  border: none;
}
.fork_overlays_forkXAxisHoverLabel {
  position: absolute;
  transform: translateX(-50%);
  z-index: 2;
}
.fork_overlays_forkXAxisHoverLine {
  width: 1px;
  height: 8px;
  margin: 0 auto 2px;
}
.fork_overlays_forkXAxisHoverLabelText {
  font-family:
    Inter,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  white-space: nowrap;
  padding: 2px 6px;
  border-radius: 3px;
  background: var(--vnsc-bg-secondary);
  border: none;
  color: var(--vnsc-text-primary);
}
.fork_overlays_forkPaneTooltip {
  position: absolute;
  left: 8px;
  z-index: 18;
  pointer-events: none;
  font-family: var(--gc-mono, monospace);
  font-size: 11px;
  line-height: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 2px 8px;
}
.fork_overlays_forkPaneTooltipDark {
  background: none;
  border: none;
}
.fork_overlays_forkPaneTooltipLight {
  background: none;
  border: none;
}
.fork_overlays_forkPaneTooltipLabel {
  color: var(--vnsc-text-secondary, #64748b);
}
.fork_overlays_forkPaneTooltipValue {
  color: var(--vnsc-text-primary, #1e2a3b);
}
.fork_overlays_forkPaneTooltipDark .fork_overlays_forkPaneTooltipLabel {
  color: var(--vnsc-text-primary);
}
.fork_overlays_forkPaneTooltipDark .fork_overlays_forkPaneTooltipValue {
  color: var(--vnsc-text-on-primary);
}
.fork_overlays_forkYAxisLabel {
  position: absolute;
  z-index: 22;
  pointer-events: none;
  font-family:
    Inter,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    monospace;
  font-size: 9px;
  font-weight: 500;
  line-height: 12px;
  white-space: nowrap;
  padding: 1px 3px;
  border-radius: 3px;
  transform: translateY(-50%);
  font-variant-numeric: tabular-nums;
}
.fork_overlays_forkPaneSeparator {
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--vnsc-border, rgba(255, 255, 255, 0.08));
  z-index: 15;
  pointer-events: none;
}
.fork_overlays_forkYAxisLabelIndicator {
  background: var(--vnsc-bg-secondary, rgba(17, 24, 32, 0.85));
}
.fork_overlays_forkRubberBand {
  position: absolute;
  border: 1px dashed var(--vnsc-accent, rgba(56, 189, 248, 0.9));
  background: color-mix(in srgb, var(--vnsc-accent, rgba(56, 189, 248, 1)) 12%, transparent);
  pointer-events: none;
  z-index: 21;
}
.fork_overlays_forkLoadingOverlay {
  position: absolute;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--vnsc-bg-overlay, rgba(10, 14, 20, 0.85));
}
.fork_overlays_forkBottomPanel {
  height: var(--vnsc-bottom-panel-height, 260px);
  max-height: 60dvh;
  border-top: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-secondary, #111820);
  position: relative;
  z-index: 40;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
@media (max-width: 480px) {
  .fork_overlays_forkXAxisTickLabel,
  .fork_overlays_forkXAxisHoverLabelText {
    font-size: 9px;
    padding: 0 2px;
  }
  .fork_overlays_forkPaneTooltip {
    font-size: 10px;
    left: 4px;
    padding: 3px 6px;
  }
}

.multicharts_layout_multichartsLayout {
  display: grid;
  grid-template-rows: 40px 1fr 32px;
  grid-template-columns: 1fr;
  grid-template-areas: "header" "charts" "footer";
  height: 100%;
  height: 100dvh;
  width: 100%;
  overflow: hidden;
  background: var(--vnsc-bg-primary, #131722);
  color: var(--vnsc-text-primary, #d1d4dc);
  font-family: var(--vnsc-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
}
.multicharts_layout_header {
  grid-area: header;
  z-index: 100;
  flex-shrink: 0;
}
.multicharts_layout_headerWorkspaceMode {
  cursor: pointer;
}
.multicharts_layout_toolbar {
  position: absolute;
  left: 0;
  top: 40px;
  bottom: 32px;
  width: 0px;
  z-index: 500;
  display: flex;
  flex-direction: column;
  overflow: visible;
  pointer-events: none;
}
.multicharts_layout_toolbarLocked .multicharts_layout_toolbar {
  width: 44px;
  pointer-events: auto;
}
.multicharts_layout_toolbarLocked .multicharts_layout_charts {
  margin-left: 44px;
}
.multicharts_layout_toolbarLocked [data-vnsc-bottom-panel=host] {
  margin-left: 44px;
}
.multicharts_layout_charts {
  grid-area: charts;
  z-index: 10;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  position: relative;
}
.multicharts_layout_workspaceBody {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  min-width: 0;
  position: relative;
  z-index: 10;
}
.multicharts_layout_workspaceMainCol {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 0;
}
.multicharts_layout_workspaceBody .multicharts_layout_charts {
  flex: 1;
  min-height: 0;
}
.multicharts_layout_footer {
  grid-area: footer;
  z-index: 100;
  flex-shrink: 0;
  transition:
    height 0.2s ease,
    opacity 0.2s ease,
    padding 0.2s ease;
}
.multicharts_layout_footer.multicharts_layout_hidden {
  height: 0;
  padding: 0 16px;
  opacity: 0;
  pointer-events: none;
  border-top: none;
}
@media (min-width: 769px) {
  .multicharts_layout_toolbar {
    display: flex;
  }
}
@media (max-width: 768px) {
  .multicharts_layout_multichartsLayout {
    grid-template-columns: 1fr;
    grid-template-rows: 40px 1fr 0px;
    grid-template-areas: "header" "charts" "footer";
  }
  .multicharts_layout_toolbar {
    display: none;
  }
  .multicharts_layout_toolbar.multicharts_layout_mobileVisible {
    display: flex;
    position: fixed;
    top: 40px;
    left: 0;
    bottom: 32px;
    width: 280px;
    max-width: 85vw;
    height: auto;
    max-height: calc(100vh - 72px);
    z-index: 1000;
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.3);
    border-right: 1px solid var(--vnsc-border, #2a2e39);
    min-width: 280px;
    max-width: 280px;
    width: 280px;
  }
  .multicharts_layout_footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0px;
    min-height: 0px;
    padding: 0;
    border-top: none;
    overflow: visible;
    pointer-events: none;
    background: transparent;
    z-index: 100;
  }
}
.multicharts_layout_toolbar .unifiedDrawingToolbar {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.multicharts_layout_toolbar.multicharts_layout_expanded .unifiedDrawingToolbar {
  overflow-y: auto;
}
.multicharts_layout_toolbar.multicharts_layout_collapsed .toolbarContent {
  display: none;
}
.multicharts_layout_toolbar.multicharts_layout_collapsed .toolbarHeader {
  padding: 8px;
  justify-content: center;
}
.multicharts_layout_toolbar.multicharts_layout_collapsed .toolbarHeader .toolbarTitle,
.multicharts_layout_toolbar.multicharts_layout_collapsed .toolbarHeader .lockToggle,
.multicharts_layout_toolbar.multicharts_layout_collapsed .toolbarHeader .collapseToggle {
  display: none;
}
.multicharts_layout_toolbar.multicharts_layout_collapsed .toolbarHeader .expandToggle {
  display: flex;
}
.multicharts_layout_chartsContainer {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  position: relative;
}
.multicharts_layout_gridContainer {
  flex: 1;
  display: grid;
  gap: 8px;
  padding: 8px;
  min-height: 0;
  overflow: auto;
}
.multicharts_layout_gridContainer[data-layout="1x1"] {
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
}
.multicharts_layout_gridContainer[data-layout="1x2"] {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
}
.multicharts_layout_gridContainer[data-layout="2x1"] {
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
}
.multicharts_layout_gridContainer[data-layout="2x2"] {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}
.multicharts_layout_gridContainer[data-layout="1x4"] {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr;
}
.multicharts_layout_gridContainer[data-layout="4x1"] {
  grid-template-columns: 1fr;
  grid-template-rows: repeat(4, 1fr);
}
.multicharts_layout_gridContainer[data-layout="2x4"] {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr 1fr;
}
.multicharts_layout_gridContainer[data-layout="3x3"] {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
}
.multicharts_layout_chartSlot {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border: 1px solid var(--vnsc-border, #2a2e39);
  border-radius: 8px;
  overflow: hidden;
  background: var(--vnsc-bg-primary, #131722);
  position: relative;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.multicharts_layout_chartSlot:hover {
  border-color: var(--vnsc-border-hover, #3a3e49);
}
.multicharts_layout_chartSlot.multicharts_layout_active {
  border: 1px solid var(--vnsc-primary, #2962ff);
}
.multicharts_layout_chartSlot.multicharts_layout_empty {
  border: 2px dashed var(--vnsc-border, #2a2e39);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--vnsc-bg-secondary, #1e222d);
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.multicharts_layout_chartSlot.multicharts_layout_empty:hover {
  background: var(--vnsc-bg-tertiary, #262b36);
  border-color: var(--vnsc-primary, #2962ff);
}
.multicharts_layout_chartSlot.multicharts_layout_empty:focus {
  outline: none;
  box-shadow: 0 0 0 2px var(--vnsc-primary, #2962ff);
}
.multicharts_layout_chartSlot.multicharts_layout_empty span {
  color: var(--vnsc-text-muted, #787b86);
  font-size: 14px;
  pointer-events: none;
}
.multicharts_layout_slotHeader {
  position: absolute;
  top: 4px;
  left: 8px;
  right: 8px;
  display: flex;
  justify-content: space-between;
  z-index: 10;
  pointer-events: none;
}
.multicharts_layout_slotHeader > * {
  pointer-events: auto;
}
.multicharts_layout_symbolBadge {
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.multicharts_layout_groupBadge {
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
}
.multicharts_layout_groupBadgeA {
  background-color: #e74c3c;
}
.multicharts_layout_groupBadgeB {
  background-color: #3498db;
}
.multicharts_layout_groupBadgeC {
  background-color: #2ecc71;
}
.multicharts_layout_groupBadgeD {
  background-color: #f39c12;
}
.multicharts_layout_charts .ohlcTooltip {
  pointer-events: none;
  z-index: 200;
}
.multicharts_layout_header .menu,
.multicharts_layout_toolbar .menu {
  z-index: 1000;
}
@media (prefers-contrast: high) {
  .multicharts_layout_multichartsLayout {
    border: 2px solid currentColor;
  }
  .multicharts_layout_toolbar {
    border-right-width: 2px;
  }
  .multicharts_layout_chartSlot {
    border-width: 2px;
  }
  .multicharts_layout_chartSlot.multicharts_layout_active {
    border-width: 3px;
  }
  .multicharts_layout_footer {
    border-top-width: 2px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .multicharts_layout_multichartsLayout,
  .multicharts_layout_toolbar,
  .multicharts_layout_footer,
  .multicharts_layout_chartSlot,
  .multicharts_layout_slotHeader,
  .multicharts_layout_toolbar .unifiedDrawingToolbar {
    transition: none;
  }
}
@media print {
  .multicharts_layout_toolbar,
  .multicharts_layout_footer,
  .multicharts_layout_slotHeader,
  .multicharts_layout_header .menu {
    display: none !important;
  }
  .multicharts_layout_multichartsLayout {
    grid-template-rows: auto 1fr auto;
    grid-template-columns: 1fr;
    grid-template-areas: "header" "charts" "footer";
  }
  .multicharts_layout_chartSlot {
    break-inside: avoid;
    border: 1px solid #000 !important;
  }
}
@media (prefers-color-scheme: dark) {
  .vnsc-root {
    --vnsc-bg-primary: #131722;
    --vnsc-bg-secondary: #1e222d;
    --vnsc-bg-tertiary: #262b36;
    --vnsc-bg-hover: #232838;
    --vnsc-bg-input: #0d1117;
    --vnsc-border: #2a2e39;
    --vnsc-border-hover: #3a3e49;
    --vnsc-text-primary: #d1d4dc;
    --vnsc-text-secondary: #787b86;
    --vnsc-text-muted: #787b86;
    --vnsc-primary: #2962ff;
    --vnsc-primary-hover: #1a52e0;
    --vnsc-success: #0ecb81;
    --vnsc-danger-bg: #2a1a1a;
    --vnsc-danger-border: #442222;
    --vnsc-danger-text: #f87171;
    --vnsc-danger-hover: #3a2a2a;
    --vnsc-accent: #2962ff;
    --vnsc-accent-hover: #1a52e0;
    --vnsc-accent-subtle: rgba(41, 98, 255, 0.15);
    --vnsc-font-family:
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      Roboto,
      sans-serif;
    --vnsc-font-mono:
      ui-monospace,
      SFMono-Regular,
      monospace;
  }
}
@media (max-width: 768px) {
  .multicharts_layout_multichartsLayout [role=menuitem],
  .multicharts_layout_multichartsLayout [role=option] {
    min-height: 44px;
    display: flex;
    align-items: center;
    padding: 8px 16px;
  }
  .multicharts_layout_multichartsLayout footer button {
    min-height: 44px;
    padding: 0 16px;
  }
  .multicharts_layout_multichartsLayout .multicharts_layout_vnsc-symbol-search-dropdown-container li {
    min-height: 44px;
    display: flex;
    align-items: center;
  }
}

.ohlc_header_ohlcHeader {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  background: var(--vnsc-bg-secondary, #111820);
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  font-family: var(--vnsc-font-family-base);
  font-size: 12px;
  color: var(--vnsc-text-primary, #e0e0e0);
  z-index: 30;
  min-height: 32px;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
}
.ohlc_header_ohlcHeader::-webkit-scrollbar {
  display: none;
}
.ohlc_header_leftGroup {
  display: flex;
  align-items: center;
  gap: 8px;
}
.ohlc_header_symbol {
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}
.ohlc_header_timeframe {
  background: var(--vnsc-accent-strong, #2563eb);
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}
.ohlc_header_timeframeGroup {
  display: flex;
  gap: 2px;
  align-items: center;
}
.ohlc_header_timeframeBtn {
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--vnsc-text-secondary, #787b86);
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}
.ohlc_header_timeframeBtn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--vnsc-text-primary, #e0e0e0);
}
.ohlc_header_timeframeBtnActive {
  background: var(--vnsc-accent-strong, #2563eb);
  color: #fff;
  font-weight: 600;
}
.ohlc_header_selectorGroup {
  position: relative;
}
.ohlc_header_selectorBtn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 4px;
  color: var(--vnsc-text-secondary, #787b86);
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}
.ohlc_header_selectorBtn:hover,
.ohlc_header_selectorBtnOpen {
  background: rgba(255, 255, 255, 0.06);
  color: var(--vnsc-text-primary, #e0e0e0);
  border-color: var(--vnsc-accent, #2962ff);
}
.ohlc_header_selectorArrow {
  font-size: 8px;
  margin-left: 2px;
}
.ohlc_header_dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background: var(--vnsc-bg-primary, #1e293b);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  list-style: none;
  padding: 4px;
  z-index: 100;
  min-width: 120px;
}
.ohlc_header_dropdownFloating {
  position: fixed;
  top: auto;
  left: auto;
  margin-top: 0;
  z-index: 9999;
}
.ohlc_header_dropdownItem {
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: var(--vnsc-text-secondary, #787b86);
  transition: background 0.15s ease;
}
.ohlc_header_dropdownItem:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--vnsc-text-primary, #e0e0e0);
}
.ohlc_header_dropdownItemSelected {
  background: rgba(41, 98, 255, 0.15);
  color: var(--vnsc-primary, #2962ff);
  font-weight: 600;
}
.ohlc_header_dropdownItemDisabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.ohlc_header_dropdownItemDisabled:hover {
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
}
.ohlc_header_comingSoonBadge {
  margin-left: 8px;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--vnsc-primary, #2962ff);
  background: rgba(41, 98, 255, 0.15);
  white-space: nowrap;
}
.ohlc_header_replayControl {
  display: flex;
  align-items: center;
  gap: 2px;
}
.ohlc_header_replayToggleBtn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 4px;
  color: var(--vnsc-text-secondary, #787b86);
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  line-height: 1;
}
.ohlc_header_replayToggleBtn:hover {
  background: rgba(255, 255, 255, 0.06);
  color: var(--vnsc-text-primary, #e0e0e0);
  border-color: var(--vnsc-accent, #2962ff);
}
.ohlc_header_replayToggleBtnActive {
  background: rgba(41, 98, 255, 0.2);
  color: var(--vnsc-primary, #2962ff);
  font-weight: 600;
  border-color: var(--vnsc-primary, #2962ff);
}
.ohlc_header_replayBar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 4px;
}
.ohlc_header_replayBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: 10px;
  transition: all 0.15s ease;
}
.ohlc_header_replayBtn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--vnsc-text-primary, #e0e0e0);
}
.ohlc_header_replayBtnActive {
  color: var(--vnsc-primary, #2962ff);
}
.ohlc_header_replaySlider {
  width: 80px;
  height: 4px;
  accent-color: var(--vnsc-accent, #2962ff);
  cursor: pointer;
}
.ohlc_header_replayProgress {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
  min-width: 50px;
}
.ohlc_header_replayPnl {
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  margin: 0 4px;
}
.ohlc_header_replayPnl[data-pnl-positive=true] {
  color: #22bb5c;
}
.ohlc_header_replayPnl[data-pnl-positive=false] {
  color: #d7324b;
}
.ohlc_header_replayAnalytics {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  font-size: 10px;
  white-space: nowrap;
  margin: 0 4px;
}
.ohlc_header_replayAnalyticsItem {
  padding: 0 4px;
  color: var(--vnsc-text-secondary, #787b86);
  border-right: 1px solid var(--vnsc-border, rgba(148,163,184,0.2));
}
.ohlc_header_replayAnalyticsItem:last-child {
  border-right: none;
}
.ohlc_header_replayAnalyticsItem[data-positive=true] {
  color: #22bb5c;
}
.ohlc_header_replayAnalyticsItem[data-positive=false] {
  color: #d7324b;
}
.ohlc_header_replaySpeed {
  background: transparent;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 4px;
  color: var(--vnsc-text-secondary, #787b86);
  font-size: 10px;
  padding: 1px 4px;
  cursor: pointer;
}
.ohlc_header_menu {
  display: flex;
  gap: 2px;
  margin-left: auto;
}
.ohlc_header_menuBtn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.ohlc_header_menuBtn:hover {
  background-color: rgba(255, 255, 255, 0.08);
  color: var(--vnsc-text-primary);
}
.ohlc_header_menuBtnActive {
  background-color: var(--vnsc-accent, #2962ff);
  color: #fff;
}
.ohlc_header_menuBtnActive:hover {
  background-color: #1a52d6;
  color: #fff;
}
.ohlc_header_upgradeBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 26px;
  padding: 0 10px;
  border: 1px solid rgba(41, 98, 255, 0.45);
  border-radius: 4px;
  background: rgba(41, 98, 255, 0.14);
  color: #dbe4ff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.15s ease;
  white-space: nowrap;
  box-shadow: none;
}
.ohlc_header_upgradeBtn:hover {
  background: rgba(41, 98, 255, 0.24);
  box-shadow: none;
}
.ohlc_header_logoBadge {
  background:
    linear-gradient(
      135deg,
      #3b82f6,
      #1d4ed8);
  color: #ffffff;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 11px;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
  display: inline-flex;
  align-items: center;
  user-select: none;
}
.ohlc_header_logoBadgeMobile {
  background:
    linear-gradient(
      135deg,
      var(--vnsc-accent, #22d3ee),
      #0891b2);
  color: #0a0e17;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 800;
  font-size: 11px;
  letter-spacing: 0.5px;
  display: inline-flex;
  align-items: center;
  user-select: none;
}
.ohlc_header_rightGroupMobile {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
}
.ohlc_header_dropdownContainerMobile {
  position: relative;
}
.ohlc_header_mobileChartSystemMenu {
  position: absolute;
  top: 32px;
  right: 0;
  min-width: 220px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  padding: 8px;
  background-color: var(--vnsc-bg-secondary, #0f172a);
  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));
  border-radius: 8px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 250;
  scrollbar-width: thin;
}
.ohlc_header_menuActionBtn {
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: var(--vnsc-text-secondary, #94a3b8);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: all 0.12s ease;
}
.ohlc_header_menuActionBtn:hover,
.ohlc_header_menuActionBtn.ohlc_header_active {
  background-color: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));
  color: var(--vnsc-text-primary, #e2e8f0);
}
.ohlc_header_replayBarMobile {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  padding: 6px 10px;
  position: absolute;
  top: 36px;
  left: 6px;
  right: 6px;
  z-index: 220;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  box-sizing: border-box;
}
.ohlc_header_ohlcCluster {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
  font-size: 11px;
  font-family: var(--vnsc-font-mono, monospace);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ohlc_header_ohlcItem {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}
.ohlc_header_ohlcLabel {
  color: inherit;
  opacity: 0.75;
  font-weight: 600;
}
.ohlc_header_ohlcValue {
  color: inherit;
}
.ohlc_header_ohlcChange {
  font-weight: 600;
  margin-left: 4px;
}
.ohlc_header_ohlcUp {
  color: var(--vnsc-color-bullish, #26a69a);
}
.ohlc_header_ohlcDown {
  color: var(--vnsc-color-bearish, #ef5350);
}
@media (max-width: 640px) {
  .ohlc_header_ohlcHeader {
    padding: 3px 6px;
    gap: 4px;
  }
  .ohlc_header_symbol {
    font-size: 12px;
  }
  .ohlc_header_replaySlider {
    width: 60px;
    flex: 1;
  }
  .ohlc_header_menuBtn {
    width: 24px;
    height: 24px;
  }
}
.ohlc_header_envPopover {
  position: fixed;
  top: auto;
  left: auto;
  z-index: 9999;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  background: var(--vnsc-bg-primary, #1e293b);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  font-size: 12px;
}
.ohlc_header_envRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.ohlc_header_liveBadgeDot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--vnsc-accent, #22d3ee);
  margin-right: 6px;
}

.pine_editor_panel {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  color: var(--vnsc-text-primary, #e0e0e0);
  background: var(--vnsc-bg-primary, #0c1017);
}
.pine_editor_toolbar {
  display: flex;
  gap: 8px;
  align-items: center;
  border-bottom: 1px solid var(--vnsc-border-divider, #202b3c);
  padding: 8px 12px;
  flex-shrink: 0;
}
.pine_editor_title {
  font-weight: bold;
  margin-right: 4px;
}
.pine_editor_body {
  display: flex;
  flex: 1;
  min-height: 0;
}
.pine_editor_sidebar {
  width: 220px;
  border-right: 1px solid var(--vnsc-border-divider, #202b3c);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
}
.pine_editor_sidebarHeader {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 10px;
  font-weight: 600;
  font-size: 11px;
  color: var(--vnsc-text-secondary, #9aa3b8);
  border-bottom: 1px solid var(--vnsc-border-divider, #202b3c);
}
.pine_editor_scriptList {
  flex: 1;
  overflow-y: auto;
  padding: 4px 0;
}
.pine_editor_scriptItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  cursor: pointer;
  border-left: 3px solid transparent;
  transition: background 0.15s;
  gap: 4px;
}
.pine_editor_scriptItem:hover {
  background: var(--vnsc-bg-hover, #1a2030);
}
.pine_editor_scriptItemActive {
  background: var(--vnsc-bg-selected, #1a2744);
  border-left-color: var(--vnsc-accent, #6366f1);
}
.pine_editor_scriptName {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}
.pine_editor_renameInput {
  flex: 1;
  background: var(--vnsc-bg-input, #090d14);
  border: 1px solid var(--vnsc-accent, #6366f1);
  border-radius: 3px;
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 12px;
  padding: 2px 6px;
  outline: none;
}
.pine_editor_scriptActions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.pine_editor_compileBtn {
  padding: 5px 12px;
  background: var(--vnsc-color-success, #089981);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  margin-left: auto;
  transition: background-color 0.2s ease;
}
.pine_editor_compileBtn:hover {
  background: var(--vnsc-color-success-hover, #067a68);
}
.pine_editor_toolBtn {
  padding: 4px 10px;
  background: var(--vnsc-bg-input, #1e2a3a);
  border: 1px solid var(--vnsc-border-input, #2a3a4e);
  border-radius: 4px;
  color: var(--vnsc-text-primary, #c0c8d8);
  font-size: 11px;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
}
.pine_editor_toolBtn:hover {
  background: var(--vnsc-bg-input-hover, #2a3a4e);
}
.pine_editor_smallBtn {
  padding: 2px 6px;
  background: transparent;
  border: 1px solid var(--vnsc-border-input, #2a3a4e);
  border-radius: 3px;
  color: var(--vnsc-text-secondary, #9aa3b8);
  font-size: 10px;
  cursor: pointer;
  white-space: nowrap;
}
.pine_editor_smallBtn:hover {
  background: var(--vnsc-bg-input-hover, #1e2a3a);
  color: var(--vnsc-text-primary, #c0c8d8);
}
.pine_editor_smallBtnDanger {
  padding: 2px 6px;
  background: transparent;
  border: 1px solid var(--vnsc-border-error, #4a1a1a);
  border-radius: 3px;
  color: var(--vnsc-color-bearish, #f23645);
  font-size: 10px;
  cursor: pointer;
  white-space: nowrap;
}
.pine_editor_smallBtnDanger:hover {
  background: var(--vnsc-bg-hover, #2a1010);
}
.pine_editor_editorContainer {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.pine_editor_errorBox {
  padding: 8px 12px;
  background: rgba(242, 54, 69, 0.1);
  border-top: 1px solid #f23645;
  color: #f23645;
  flex-shrink: 0;
}
.pine_editor_successBox {
  padding: 8px 12px;
  background: rgba(8, 153, 129, 0.1);
  border-top: 1px solid #089981;
  color: #089981;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .pine_editor_sidebar {
    width: 160px;
  }
  .pine_editor_scriptActions {
    flex-direction: column;
  }
}
@media (max-width: 480px) {
  .pine_editor_toolbar {
    flex-wrap: wrap;
  }
  .pine_editor_sidebar {
    display: none;
  }
  .pine_editor_compileBtn {
    margin-left: 0;
    width: 100%;
  }
}

.right_dock_rail_workspaceDock {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 10px;
  z-index: var(--vnsc-z-sidebar, 48);
  pointer-events: auto;
}
.right_dock_rail_workspaceDock::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3px;
  height: 3px;
  border-radius: 999px;
  background: var(--vnsc-text-secondary);
  box-shadow: 0 -6px 0 var(--vnsc-text-secondary), 0 6px 0 var(--vnsc-text-secondary);
  transform: translate(-50%, -50%);
  pointer-events: none;
}
.right_dock_rail_workspaceDockFlyout {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  transform: translateX(100%);
  visibility: hidden;
  transition: transform 0.2s ease, visibility 0s linear 0.2s;
}
.right_dock_rail_workspaceDock:hover .right_dock_rail_workspaceDockFlyout,
.right_dock_rail_workspaceDock:focus-within .right_dock_rail_workspaceDockFlyout,
.right_dock_rail_workspaceDockOpen .right_dock_rail_workspaceDockFlyout {
  transform: translateX(0);
  visibility: visible;
  transition: transform 0.2s ease, visibility 0s;
}
.right_dock_rail_workspaceDock * {
  pointer-events: auto;
}
.right_dock_rail_workspaceDockPinned {
  position: static;
  width: auto;
  flex-shrink: 0;
  display: flex;
}
.right_dock_rail_workspaceDockPinned::before {
  display: none;
}
.right_dock_rail_workspaceDockPinned .right_dock_rail_workspaceDockFlyout {
  display: contents;
  visibility: visible;
}
@media (max-width: 767px) {
  .right_dock_rail_workspaceDock {
    left: 0;
    right: 0;
    top: auto;
    bottom: 0;
    width: auto;
    z-index: 20;
  }
  .right_dock_rail_workspaceDock::before {
    display: none;
  }
  .right_dock_rail_workspaceDockFlyout {
    position: static;
    transform: none;
    visibility: visible;
  }
}

.right_sidebar_dock_dock {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 100%;
  border-left: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-secondary, #111820);
  position: relative;
  z-index: 48;
  min-width: 150px;
  overflow: hidden;
  transition: width 0.18s ease;
}
.right_sidebar_dock_dockClosed {
  min-width: 40px;
}
@media (max-width: 767px) {
  .right_sidebar_dock_dock {
    transition: none;
  }
  .right_sidebar_dock_dockClosed {
    height: auto;
    min-height: 0;
    border-top: none;
  }
}
.right_sidebar_dock_splitter {
  width: 4px;
  cursor: col-resize;
  z-index: 49;
  background: transparent;
  transition: background 0.2s;
  flex-shrink: 0;
}
.right_sidebar_dock_splitterActive {
  background: var(--vnsc-accent, #2962ff);
}
.right_sidebar_dock_stacked {
  flex-shrink: 0;
  overflow-y: auto;
}
.right_sidebar_dock_body {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
}
.right_sidebar_dock_panel {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.right_sidebar_dock_panelHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border-bottom: 1px solid var(--vnsc-border-divider, #2a2a2a);
  flex-shrink: 0;
}
.right_sidebar_dock_panelTitle {
  font-size: 11px;
  font-weight: 600;
  color: var(--vnsc-text-secondary, #787b86);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.right_sidebar_dock_panelActions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.right_sidebar_dock_panelClose {
  background: transparent;
  border: none;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 2px;
  border-radius: 4px;
}
.right_sidebar_dock_panelClose:hover {
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
  color: var(--vnsc-text-primary, #d1d4dc);
}
.right_sidebar_dock_panelBody {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.right_sidebar_dock_strip {
  width: 40px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 6px 0;
  border-left: 1px solid var(--vnsc-border-divider, #2a2a2a);
  background: var(--vnsc-bg-primary, #131722);
  overflow-y: auto;
}
.right_sidebar_dock_stripBtn {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
}
.right_sidebar_dock_stripBtn:hover {
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
  color: var(--vnsc-text-primary, #d1d4dc);
}
.right_sidebar_dock_stripBtnDisabled {
  opacity: 0.38;
  cursor: not-allowed;
}
.right_sidebar_dock_stripPin {
  margin-bottom: 4px;
  flex-shrink: 0;
}
.right_sidebar_dock_stripBtn:focus {
  outline: none;
}
.right_sidebar_dock_stripBtn:focus-visible {
  outline: 2px solid var(--vnsc-accent-strong, #2563eb);
  outline-offset: -2px;
}
.right_sidebar_dock_stripBtnActive {
  background: var(--vnsc-bg-selected, rgba(59, 130, 246, 0.15));
  color: var(--vnsc-accent, #2962ff);
}
@media (max-width: 767px) {
  .right_sidebar_dock_splitter {
    display: none;
  }
  .right_sidebar_dock_dock {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: auto;
    height: 45%;
    min-height: 220px;
    min-width: 0;
    width: auto !important;
    border-left: none;
    border-top: 1px solid var(--vnsc-border, #2a2a2a);
    z-index: 20;
  }
  .right_sidebar_dock_stripBtn {
    min-width: 44px;
    min-height: 44px;
  }
  .right_sidebar_dock_panelClose {
    min-width: 44px;
    min-height: 44px;
  }
}
.right_sidebar_dock_dw {
  padding: 8px 10px;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}
.right_sidebar_dock_dwHead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}
.right_sidebar_dock_dwSymbol {
  font-weight: 700;
  font-size: 13px;
  color: var(--vnsc-text-primary, #d1d4dc);
}
.right_sidebar_dock_dwTime {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
}
.right_sidebar_dock_dwRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 0;
  border-bottom: 1px solid var(--vnsc-border-divider, #2a2a2a);
}
.right_sidebar_dock_dwRow:last-child {
  border-bottom: none;
}
.right_sidebar_dock_dwLabel {
  color: var(--vnsc-text-secondary, #787b86);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
}
.right_sidebar_dock_dwValue {
  font-weight: 600;
  color: var(--vnsc-text-primary, #d1d4dc);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  flex-shrink: 0;
}
.right_sidebar_dock_dwUp {
  color: var(--vnsc-color-bullish, rgb(38, 166, 154));
}
.right_sidebar_dock_dwDown {
  color: var(--vnsc-color-bearish, rgb(239, 83, 80));
}
.right_sidebar_dock_dwSection {
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid var(--vnsc-border-divider, #2a2a2a);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--vnsc-text-secondary, #787b86);
}
.right_sidebar_dock_dwEmpty {
  padding: 16px 12px;
  font-size: 12px;
  color: var(--vnsc-text-secondary, #787b86);
  text-align: center;
}

.strategy_tester_panel {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding: 12px;
  gap: 12px;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  color: var(--vnsc-text-primary, #e0e0e0);
  background: var(--vnsc-bg-primary, #0c1017);
}
.strategy_tester_header {
  display: flex;
  gap: 12px;
  align-items: center;
  border-bottom: 1px solid var(--vnsc-border-divider, #202b3c);
  padding-bottom: 10px;
}
.strategy_tester_title {
  font-weight: bold;
}
.strategy_tester_select {
  padding: 4px 8px;
  background: var(--vnsc-bg-input, #131b26);
  border: 1px solid var(--vnsc-border-input, #202b3c);
  border-radius: 4px;
  color: var(--vnsc-text-primary, #fff);
}
.strategy_tester_runBtn {
  padding: 5px 12px;
  background: var(--vnsc-accent, #2962ff);
  border: none;
  border-radius: 4px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  margin-left: auto;
  transition: background-color 0.2s ease;
}
.strategy_tester_runBtn:hover {
  background: var(--vnsc-accent-hover, #1a52d6);
}
.strategy_tester_saveRunBtn {
  align-self: flex-start;
  padding: 6px 14px;
  background: transparent;
  border: 1px solid var(--vnsc-accent, #2962ff);
  border-radius: 4px;
  color: var(--vnsc-accent, #2962ff);
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.strategy_tester_saveRunBtn:hover {
  background: rgba(41, 98, 255, 0.12);
}
.strategy_tester_hintMark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border: 1px solid var(--vnsc-text-secondary, #888);
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  color: var(--vnsc-text-secondary, #888);
  cursor: help;
  margin-left: 4px;
  vertical-align: middle;
}
.strategy_tester_statsGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.strategy_tester_statCard {
  padding: 10px;
  background: var(--vnsc-bg-secondary, #131b26);
  border-radius: 4px;
  border: 1px solid var(--vnsc-border-divider, #202b3c);
}
.strategy_tester_statLabel {
  color: var(--vnsc-text-secondary, #888);
  font-size: 11px;
  margin-bottom: 4px;
}
.strategy_tester_statValue {
  font-size: 16px;
  font-weight: bold;
}
.strategy_tester_statValuePositive {
  color: var(--vnsc-color-bullish, #089981);
}
.strategy_tester_statValueNegative {
  color: var(--vnsc-color-bearish, #f23645);
}
.strategy_tester_tradeLog {
  flex: 1;
  overflow-y: auto;
  border: 1px solid var(--vnsc-border-divider, #202b3c);
  border-radius: 4px;
}
.strategy_tester_tradeTable {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}
.strategy_tester_tradeTable th {
  padding: 8px;
  border-bottom: 1px solid var(--vnsc-border-divider, #202b3c);
  color: var(--vnsc-text-secondary, #888);
  background: var(--vnsc-bg-secondary, #131b26);
  position: sticky;
  top: 0;
}
.strategy_tester_tradeTable td {
  padding: 8px;
  border-bottom: 1px solid var(--vnsc-border-divider, #1c2430);
}
.strategy_tester_tradeTypeLong {
  text-transform: uppercase;
  color: var(--vnsc-accent, #2962ff);
  font-weight: bold;
}
.strategy_tester_tradeTypeShort {
  text-transform: uppercase;
  color: var(--vnsc-color-warning, #ff6d00);
  font-weight: bold;
}
.strategy_tester_tradePnlPositive {
  color: var(--vnsc-color-bullish, #089981);
  font-weight: bold;
}
.strategy_tester_tradePnlNegative {
  color: var(--vnsc-color-bearish, #f23645);
  font-weight: bold;
}
.strategy_tester_tradeDate {
  color: var(--vnsc-text-secondary, #888);
}
.strategy_tester_emptyState {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--vnsc-text-muted, #555);
  font-style: italic;
}
@media (max-width: 480px) {
  .strategy_tester_panel {
    padding: 8px;
    gap: 8px;
  }
  .strategy_tester_statsGrid {
    grid-template-columns: repeat(2, 1fr);
  }
  .strategy_tester_header {
    flex-wrap: wrap;
  }
  .strategy_tester_runBtn {
    margin-left: 0;
    margin-top: 8px;
    width: 100%;
  }
}

.symbol_search_wrapper {
  position: relative;
  min-width: min(380px, 100%);
  flex: 1 1 380px;
}
.symbol_search_input {
  width: 100%;
  box-sizing: border-box;
  border: 1.5px solid var(--vnsc-border, #3a3e49);
  background: var(--vnsc-surface, #1e222d);
  color: var(--vnsc-text, #f8fafc);
  font: inherit;
  font-size: 12px;
  line-height: 1.4;
  padding: 8px 10px;
  border-radius: 6px;
  outline: none;
  transition: border-color 100ms ease, box-shadow 100ms ease;
}
.symbol_search_input::placeholder {
  color: var(--vnsc-text-secondary, #787b86);
  opacity: 0.85;
}
.symbol_search_input:focus {
  border-color: var(--vnsc-accent, #6366f1);
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
}
.symbol_search_dropdown {
  position: absolute;
  z-index: 1000;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--vnsc-accent, #6366f1);
  border-radius: 10px;
  background: var(--vnsc-bg-primary, #1e222d);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6), 0 0 0 2px rgba(99, 102, 241, 0.15);
  max-height: min(60vh, 600px);
  overflow: auto;
}
.symbol_search_dropdown ul {
  margin: 0;
  padding: 6px;
  list-style: none;
}
.symbol_search_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  color: var(--vnsc-text-secondary);
  font-size: 12px;
  transition: background 100ms ease, color 100ms ease;
}
.symbol_search_item:hover,
.symbol_search_itemHighlighted {
  background: var(--vnsc-bg-tertiary);
  color: var(--vnsc-text-primary);
}
.symbol_search_itemDisabled,
.symbol_search_itemDisabled:hover {
  opacity: 0.45;
  cursor: not-allowed;
  background: transparent;
}
.symbol_search_currentBadge {
  margin-left: auto;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid var(--vnsc-border, #3a3e49);
  color: var(--vnsc-text-secondary);
  white-space: nowrap;
}
.symbol_search_symbol {
  font-weight: 700;
  color: inherit;
}
.symbol_search_name {
  font-size: 11px;
  color: inherit;
}
.symbol_search_exchangeBar {
  display: flex;
  gap: 4px;
  padding: 6px 8px 4px;
  border-bottom: 1px solid var(--vnsc-border);
}
.symbol_search_exBtn {
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid var(--vnsc-border);
  background: transparent;
  color: var(--vnsc-text-secondary);
  font-size: 11px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.symbol_search_exBtn:hover {
  background: var(--vnsc-bg-tertiary);
  color: var(--vnsc-text-primary);
}
.symbol_search_exBtnActive {
  background: var(--vnsc-accent, #2962ff);
  border-color: var(--vnsc-accent, #2962ff);
  color: #fff;
}
.symbol_search_exBadge {
  font-size: 9px;
  font-weight: 700;
  padding: 1px 4px;
  border-radius: 3px;
  background: var(--vnsc-bg-tertiary);
  color: var(--vnsc-text-secondary);
  flex-shrink: 0;
}
.symbol_search_exBadgeHose {
  background: color-mix(in srgb, var(--vnsc-color-success) 18%, transparent);
  color: var(--vnsc-color-success);
}
.symbol_search_exBadgeHnx {
  background: color-mix(in srgb, var(--vnsc-color-info) 18%, transparent);
  color: var(--vnsc-color-info);
}
.symbol_search_exBadgeUpcom {
  background: color-mix(in srgb, var(--vnsc-color-warning) 18%, transparent);
  color: var(--vnsc-color-warning);
}
.symbol_search_section {
  padding: 6px 8px 4px;
}
.symbol_search_section + .symbol_search_section {
  border-top: 1px solid var(--vnsc-border);
}
.symbol_search_sectionLabel {
  font-size: 10px;
  font-weight: 700;
  color: var(--vnsc-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 5px;
}
.symbol_search_chipRow {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}
.symbol_search_chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 0 8px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid var(--vnsc-border);
  background: rgba(255, 255, 255, 0.03);
  color: var(--vnsc-text-primary);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
}
.symbol_search_chip:hover {
  background: var(--vnsc-bg-tertiary);
}
.symbol_search_chipVn30 {
  border-color: color-mix(in srgb, var(--vnsc-color-success) 35%, transparent);
  color: var(--vnsc-color-success);
}
.symbol_search_chipVn30:hover {
  background: color-mix(in srgb, var(--vnsc-color-success) 12%, transparent);
}
.symbol_search_chipFutures {
  border-color: color-mix(in srgb, var(--vnsc-color-info) 35%, transparent);
  color: var(--vnsc-color-info);
}
.symbol_search_chipFutures:hover {
  background: color-mix(in srgb, var(--vnsc-color-info) 12%, transparent);
}
.symbol_search_chipCrypto {
  border-color: color-mix(in srgb, var(--vnsc-color-warning) 35%, transparent);
  color: var(--vnsc-color-warning);
}
.symbol_search_chipCrypto:hover {
  background: color-mix(in srgb, var(--vnsc-color-warning) 12%, transparent);
}
.symbol_search_vn30Grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 6px;
  margin-top: 4px;
}
.symbol_search_emptyState {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 12px;
}
.symbol_search_emptyText,
.symbol_search_loadingText {
  font-size: 12px;
  color: var(--vnsc-text-secondary);
}
.symbol_search_colorDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}
.symbol_search_overlayRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}
.symbol_search_overlayRowLeft {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.symbol_search_addBtn {
  padding: 2px 8px;
  border: 1px solid color-mix(in srgb, var(--vnsc-color-success) 40%, transparent);
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-color-success);
  font-size: 11px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}
.symbol_search_addBtn:hover {
  background: color-mix(in srgb, var(--vnsc-color-success) 10%, transparent);
}
.symbol_search_removeBtn {
  padding: 2px 8px;
  border: 1px solid color-mix(in srgb, var(--vnsc-color-bearish) 40%, transparent);
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-color-bearish);
  font-size: 11px;
  cursor: pointer;
  flex-shrink: 0;
}
.symbol_search_removeBtn:hover {
  background: color-mix(in srgb, var(--vnsc-color-bearish) 10%, transparent);
}
.symbol_search_divider {
  margin: 0;
  border: none;
  border-top: 1px solid var(--vnsc-border, #3a3e49);
}
@media (max-width: 480px) {
  .symbol_search_wrapper {
    min-width: 100%;
  }
  .symbol_search_dropdown {
    left: 0;
    right: 0;
    max-height: 50vh;
  }
}
.symbol_search_modalBackdrop {
  position: fixed;
  inset: 0;
  z-index: 5000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 12vh 16px 16px;
  background: var(--vnsc-bg-overlay, rgba(10, 14, 20, 0.85));
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}
.symbol_search_modalPanel {
  width: min(640px, 100%);
  max-height: 70vh;
  overflow: auto;
  border: 1px solid var(--vnsc-accent, #6366f1);
  border-radius: 12px;
  background: var(--vnsc-bg-modal, #1e222d);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6), 0 0 0 2px rgba(99, 102, 241, 0.15);
}
.symbol_search_dropdownFlat {
  position: static;
  z-index: auto;
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  max-height: none;
  overflow: visible;
}
.symbol_search_dropdownFlat ul {
  margin: 0;
  padding: 6px 0 0;
  list-style: none;
}
.symbol_search_unifiedRowActions {
  display: inline-flex;
  gap: 4px;
  margin-left: auto;
  flex-shrink: 0;
}
.symbol_search_switchBtn {
  color: #fff;
  border-color: var(--vnsc-accent, #6366f1);
  background: rgba(99, 102, 241, 0.15);
}
.symbol_search_switchBtn:hover {
  background: rgba(99, 102, 241, 0.3);
}

.tape_panel_panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 240px;
  z-index: var(--vnsc-z-dock, 51);
  background: var(--vnsc-bg-primary);
  border-left: 1px solid var(--vnsc-border-primary);
  display: flex;
  flex-direction: column;
  font-size: var(--vnsc-font-size-xs);
  color: var(--vnsc-text-primary);
  overflow: hidden;
}
.tape_panel_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--vnsc-space-2);
  border-bottom: 1px solid var(--vnsc-border-divider);
  background: var(--vnsc-bg-secondary);
  flex-shrink: 0;
}
.tape_panel_title {
  font-weight: 700;
  font-size: var(--vnsc-font-size-sm);
}
.tape_panel_closeBtn {
  background: none;
  border: none;
  color: var(--vnsc-text-secondary);
  cursor: pointer;
  font-size: var(--vnsc-font-size-md);
  padding: 0 4px;
  transition: color 0.15s ease;
}
.tape_panel_closeBtn:hover {
  color: var(--vnsc-text-primary);
}
.tape_panel_filterBar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-bottom: 1px solid var(--vnsc-border-divider);
  flex-shrink: 0;
}
.tape_panel_filterLabel {
  color: var(--vnsc-text-secondary);
  white-space: nowrap;
}
.tape_panel_filterSlider {
  flex: 1;
  cursor: pointer;
}
.tape_panel_filterValue {
  width: 38px;
  text-align: right;
  color: var(--vnsc-text-primary);
  flex-shrink: 0;
}
.tape_panel_columnHeaders {
  display: grid;
  grid-template-columns: 52px 70px 52px 44px 22px;
  padding: 2px 4px;
  color: var(--vnsc-text-secondary);
  font-size: var(--vnsc-font-size-2xs);
  border-bottom: 1px solid var(--vnsc-border-divider);
  flex-shrink: 0;
}
.tape_panel_entriesList {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
.tape_panel_loading,
.tape_panel_empty {
  text-align: center;
  color: var(--vnsc-text-secondary);
  padding-top: 20px;
}
.tape_panel_row {
  display: grid;
  grid-template-columns: 52px 70px 52px 44px 22px;
  height: 22px;
  align-items: center;
  padding: 0 4px;
  background: transparent;
  border-bottom: 1px solid var(--vnsc-border-divider);
}
.tape_panel_rowWhale {
  background: color-mix(in srgb, var(--vnsc-color-warning) 15%, transparent);
  border-bottom: 1px solid color-mix(in srgb, var(--vnsc-color-warning) 60%, transparent);
}
.tape_panel_rowTime {
  color: var(--vnsc-text-secondary);
  font-size: var(--vnsc-font-size-2xs);
}
.tape_panel_rowPrice {
  text-align: right;
  font-weight: 400;
}
.tape_panel_rowPriceBuy {
  color: var(--vnsc-color-bullish);
}
.tape_panel_rowPriceSell {
  color: var(--vnsc-color-bearish);
}
.tape_panel_rowPriceWhale {
  font-weight: 700;
}
.tape_panel_rowVolume {
  text-align: right;
  color: var(--vnsc-text-secondary);
}
.tape_panel_rowValue {
  text-align: right;
  color: var(--vnsc-text-secondary);
}
.tape_panel_rowValueWhale {
  color: var(--vnsc-color-warning);
}
.tape_panel_rowSide {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 14px;
  width: 16px;
  border-radius: 2px;
  font-size: var(--vnsc-font-size-2xs);
  font-weight: 700;
}
.tape_panel_rowSideBuy {
  background: color-mix(in srgb, var(--vnsc-color-bullish) 35%, transparent);
  color: var(--vnsc-text-on-primary);
}
.tape_panel_rowSideSell {
  background: var(--vnsc-color-bearish);
  color: var(--vnsc-text-on-primary);
}
.tape_panel_rowSideUnknown {
  background: color-mix(in srgb, var(--vnsc-text-secondary) 30%, transparent);
  color: var(--vnsc-text-primary);
}
.tape_panel_footer {
  padding: 4px 8px;
  border-top: 1px solid var(--vnsc-border-divider);
  color: var(--vnsc-text-secondary);
  font-size: var(--vnsc-font-size-2xs);
  flex-shrink: 0;
}
@media (max-width: 480px) {
  .tape_panel_panel {
    width: 100%;
    height: auto;
    max-height: 40%;
    bottom: 0;
    top: auto;
    right: 0;
    border-left: none;
    border-top: 1px solid var(--vnsc-border-primary);
  }
}

.timeframe_footer_timeframeFooter {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 8px;
  background: var(--vnsc-bg-secondary, transparent);
  border-top: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  z-index: 30;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: none;
  font-family: var(--vnsc-font-family-base, "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--vnsc-text-secondary, #787b86);
}
.timeframe_footer_timeframeChips {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.timeframe_footer_tfChip {
  padding: 2px 6px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  transition:
    color 0.15s ease,
    border-color 0.15s ease,
    background 0.15s ease;
}
.timeframe_footer_tfChip:hover {
  color: var(--vnsc-text-primary, #d1d4dc);
  border-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.12));
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
}
.timeframe_footer_tfChipActive {
  background: var(--vnsc-accent-strong, #2563eb);
  color: #fff;
  font-weight: 600;
  border-color: var(--vnsc-accent-strong, #2563eb);
  box-shadow: none;
}
.timeframe_footer_tfChipActive:hover {
  background: var(--vnsc-accent-strong, #2563eb);
  color: #fff;
  border-color: var(--vnsc-accent-hover, #1e4bd8);
}
.timeframe_footer_separator {
  width: 1px;
  height: 14px;
  background: var(--vnsc-border, rgba(255, 255, 255, 0.08));
}
.timeframe_footer_rangeChips {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.timeframe_footer_rangeChip {
  padding: 2px 6px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  transition:
    color 0.15s ease,
    border-color 0.15s ease,
    background 0.15s ease;
}
.timeframe_footer_rangeChip:hover {
  color: var(--vnsc-text-primary, #d1d4dc);
  border-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.12));
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
}
.timeframe_footer_rangeChipActive {
  background: var(--vnsc-accent-strong, #2563eb);
  color: #fff;
  font-weight: 600;
  border-color: var(--vnsc-accent-strong, #2563eb);
  box-shadow: none;
}
.timeframe_footer_rangeChipActive:hover {
  background: var(--vnsc-accent-strong, #2563eb);
  color: #fff;
  border-color: var(--vnsc-accent-hover, #1e4bd8);
}
.timeframe_footer_footerChildren {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.timeframe_footer_groupCaption {
  font-size: 10px;
  font-weight: 600;
  color: var(--vnsc-text-muted, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  align-self: center;
  margin-right: 2px;
  white-space: nowrap;
  flex-shrink: 0;
}
@media (max-width: 1280px) {
  .timeframe_footer_groupCaption {
    display: none;
  }
}
.timeframe_footer_rightCluster {
  margin-left: auto;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
}
.timeframe_footer_footerChildren + .timeframe_footer_rightCluster {
  margin-left: 0;
}
.timeframe_footer_scaleGroup {
  display: flex;
  gap: 2px;
  padding: 2px;
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  background: transparent;
}
.timeframe_footer_scaleBtn {
  padding: 2px 6px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  font-variant-numeric: tabular-nums;
}
.timeframe_footer_scaleBtn:hover {
  color: var(--vnsc-text-primary, #d1d4dc);
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
}
.timeframe_footer_scaleBtnActive {
  background: var(--vnsc-accent-strong, #2563eb);
  color: var(--vnsc-text-on-primary, #ffffff);
  font-weight: 600;
}
.timeframe_footer_tzBadge {
  padding: 2px 6px;
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  color: var(--vnsc-text-secondary, #787b86);
  background: var(--vnsc-bg-hover, transparent);
  white-space: nowrap;
}
.timeframe_footer_clockText {
  font-size: 11px;
  font-weight: 500;
  font-family: var(--vnsc-font-family-mono, ui-monospace, monospace);
  color: var(--vnsc-text-primary, #d1d4dc);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.timeframe_footer_countdownText {
  font-variant-numeric: tabular-nums;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  font-weight: 600;
  font-family: var(--vnsc-font-family-mono, ui-monospace, monospace);
  color: var(--vnsc-accent, #2962ff);
  white-space: nowrap;
}
.timeframe_footer_countdownGlyph {
  font-size: 10px;
  opacity: 0.7;
}
.timeframe_footer_trademark {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
  color: var(--vnsc-text-muted, #6b7280);
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  opacity: 0.9;
}
.timeframe_footer_trademark:hover {
  color: var(--vnsc-text-secondary, #787b86);
  opacity: 1;
}
.timeframe_footer_trademarkIcon {
  font-size: 11px;
  color: var(--vnsc-accent, #2962ff);
  opacity: 0.7;
}
.timeframe_footer_trademarkIcon:hover {
  color: var(--vnsc-accent, #2962ff);
  opacity: 1;
}
@media (max-width: 480px) {
  .timeframe_footer_timeframeFooter {
    padding: 4px 8px;
    gap: 8px;
  }
  .timeframe_footer_tfChip,
  .timeframe_footer_rangeChip {
    padding: 2px 6px;
    font-size: 10px;
  }
  .timeframe_footer_separator {
    height: 12px;
  }
}

.watchlist_panel_root {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.watchlist_panel_colHead {
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: var(--vnsc-bg-primary, #131722);
  border-bottom: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
  font-variant-numeric: tabular-nums;
}
.watchlist_panel_colHeadName {
  flex: 1;
  min-width: 0;
}
.watchlist_panel_col {
  flex-shrink: 0;
  width: 50px;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.watchlist_panel_list {
  display: flex;
  flex-direction: column;
  padding: 4px 4px 12px;
  gap: 1px;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--vnsc-border, #2a3550) transparent;
}
.watchlist_panel_list::-webkit-scrollbar {
  width: 8px;
}
.watchlist_panel_list::-webkit-scrollbar-thumb {
  background: var(--vnsc-border, #2a3550);
  border-radius: 8px;
}
.watchlist_panel_list::-webkit-scrollbar-corner {
  background: transparent;
}
.watchlist_panel_row {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-height: 34px;
  padding: 3px 8px;
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));
  border-radius: 0;
  cursor: pointer;
  text-align: left;
  font-variant-numeric: tabular-nums;
}
.watchlist_panel_row:last-child {
  border-bottom: none;
}
.watchlist_panel_row:hover {
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
}
.watchlist_panel_row:focus {
  outline: none;
}
.watchlist_panel_row:focus-visible {
  outline: 2px solid var(--vnsc-accent-strong, #2563eb);
  outline-offset: -2px;
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));
}
.watchlist_panel_rowActive {
  background: var(--vnsc-bg-selected, rgba(59, 130, 246, 0.15));
}
.watchlist_panel_symBlock {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}
.watchlist_panel_sym {
  font-size: 12px;
  font-weight: 700;
  color: var(--vnsc-text-primary, #d1d4dc);
  white-space: nowrap;
}
.watchlist_panel_name {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.watchlist_panel_spark {
  flex-shrink: 0;
  color: var(--vnsc-text-secondary, #787b86);
}
.watchlist_panel_cell {
  flex-shrink: 0;
  width: 50px;
  min-width: 0;
  text-align: right;
  font-size: 11px;
  color: var(--vnsc-text-primary, #d1d4dc);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.watchlist_panel_up {
  color: var(--vnsc-color-bullish, rgb(38, 166, 154));
}
.watchlist_panel_down {
  color: var(--vnsc-color-bearish, rgb(239, 83, 80));
}
.watchlist_panel_empty {
  padding: 16px 12px;
  font-size: 12px;
  color: var(--vnsc-text-secondary, #787b86);
  text-align: center;
}
.watchlist_panel_details {
  position: sticky;
  bottom: 0;
  z-index: 1;
  margin-top: auto;
  padding: 8px;
  background: var(--vnsc-bg-primary, #131722);
  border-top: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));
}
.watchlist_panel_detailsHead {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.watchlist_panel_detailsSymBlock {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.watchlist_panel_detailsSym {
  font-size: 12px;
  font-weight: 700;
  color: var(--vnsc-text-primary, #d1d4dc);
  white-space: nowrap;
}
.watchlist_panel_detailsName {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.watchlist_panel_detailsQuote {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
}
.watchlist_panel_detailsLast {
  font-size: 12px;
  font-weight: 600;
  color: var(--vnsc-text-primary, #d1d4dc);
}
.watchlist_panel_detailsChg,
.watchlist_panel_detailsPct {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
}
.watchlist_panel_detailGrid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 4px;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));
}
.watchlist_panel_detailCell {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.watchlist_panel_detailLabel {
  font-size: 9px;
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.watchlist_panel_detailValue {
  font-size: 10px;
  color: var(--vnsc-text-primary, #d1d4dc);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.watchlist_panel_detailsEmpty {
  padding-top: 6px;
  font-size: 10px;
  color: var(--vnsc-text-secondary, #787b86);
  text-align: center;
}

.whale_panel_panel {
}
.whale_panel_title {
}
.whale_panel_net {
}
.whale_panel_netPositive {
}
.whale_panel_netNegative {
}
.whale_panel_table {
  width: 100%;
  border-collapse: collapse;
}
.whale_panel_table th {
  padding: 8px;
  text-align: left;
  color: var(--vnsc-text-secondary);
  font-size: 11px;
  font-weight: 600;
  border-bottom: 1px solid var(--vnsc-border);
}
.whale_panel_table td {
  padding: 8px;
  border-bottom: 1px solid var(--vnsc-border);
}
.whale_panel_rowLabel {
  font-weight: 500;
  color: var(--vnsc-text-primary);
}
.whale_panel_buy {
  color: #089981;
  font-weight: 600;
  text-align: right;
}
.whale_panel_sell {
  color: #f23645;
  font-weight: 600;
  text-align: right;
}
@media (max-width: 480px) {
  .whale_panel_panel {
  }
}

/* src/widget/styles/tokens/colors.css */
.vnsc-root {
  --vnsc-color-primary: #3b82f6;
  --vnsc-color-primary-hover: #2563eb;
  --vnsc-color-primary-active: #1d4ed8;
  --vnsc-color-primary-muted: rgba(59, 130, 246, 0.15);
  --vnsc-color-accent: #2962ff;
  --vnsc-color-accent-hover: #1e4bd8;
  --vnsc-primary: #2962ff;
  --vnsc-primary-hover: #1a52e0;
  --vnsc-color-success: #22a85e;
  --vnsc-color-success-hover: #1e8a49;
  --vnsc-color-warning: #e67e22;
  --vnsc-color-warning-hover: #d46e1a;
  --vnsc-color-error: #c0392b;
  --vnsc-color-error-hover: #a93226;
  --vnsc-color-info: #3b82f6;
  --vnsc-bg: var(--vnsc-bg-primary);
  --vnsc-bg-primary: #131722;
  --vnsc-bg-primary-rgba: rgba(19, 23, 34, 0.85);
  --vnsc-bg-secondary: #1e222d;
  --vnsc-bg-tertiary: #131722;
  --vnsc-bg-elevated: #1f2937;
  --vnsc-bg-overlay: rgba(10, 14, 20, 0.85);
  --vnsc-bg-modal: #1e222d;
  --vnsc-bg-popover: #1a1f2e;
  --vnsc-bg-tooltip: #1f2937;
  --vnsc-bg-input: #1a1f2e;
  --vnsc-bg-input-hover: #1f2937;
  --vnsc-bg-input-focus: #1f2937;
  --vnsc-bg-disabled: #1a1f2e;
  --vnsc-bg-hover: rgba(255, 255, 255, 0.04);
  --vnsc-bg-active: rgba(255, 255, 255, 0.08);
  --vnsc-bg-selected: rgba(59, 130, 246, 0.15);
  --vnsc-bg-focus: rgba(59, 130, 246, 0.2);
  --vnsc-text-primary: #d1d4dc;
  --vnsc-text-secondary: #787b86;
  --vnsc-text-tertiary: #50535e;
  --vnsc-text-muted: #4e5263;
  --vnsc-text-inverse: #0a0e14;
  --vnsc-text-link: #3b82f6;
  --vnsc-text-link-hover: #60a5fa;
  --vnsc-text-disabled: #4a4a4a;
  --vnsc-text-placeholder: #606060;
  --vnsc-text-on-primary: #ffffff;
  --vnsc-text-on-accent: #ffffff;
  --vnsc-surface: var(--vnsc-bg-secondary);
  --vnsc-text: var(--vnsc-text-primary);
  --vnsc-border-primary: #2a2a2a;
  --vnsc-border-secondary: #3a3a3a;
  --vnsc-border-focus: #3b82f6;
  --vnsc-border-error: #c0392b;
  --vnsc-border-success: #22a85e;
  --vnsc-border-warning: #e67e22;
  --vnsc-border-input: #2a2a2a;
  --vnsc-border-input-hover: #3a3a3a;
  --vnsc-border-input-focus: #3b82f6;
  --vnsc-border-divider: #2a2a2a;
  --vnsc-border-overlay: rgba(255, 255, 255, 0.1);
  --vnsc-color-bullish: rgb(38, 166, 154);
  --vnsc-color-bearish: rgb(239, 83, 80);
  --vnsc-color-neutral: #6c757d;
  --vnsc-color-volume: rgba(59, 130, 246, 0.3);
  --vnsc-color-grid: rgba(255, 255, 255, 0.05);
  --vnsc-color-grid-subtle: rgba(255, 255, 255, 0.025);
  --vnsc-color-crosshair: #2962ff;
  --vnsc-color-selection: rgba(41, 98, 255, 0.2);
  --vnsc-grid-dash: "";
  --vnsc-grid-width: 1;
  --vnsc-accent: var(--vnsc-color-accent);
  --vnsc-accent-hover: var(--vnsc-color-accent-hover);
  --vnsc-accent-strong: #2563eb;
  --vnsc-border: var(--vnsc-border-primary);
  --vnsc-up: var(--vnsc-color-bullish);
  --vnsc-down: var(--vnsc-color-bearish);
  --vnsc-color-whale-buy: var(--vnsc-color-bullish);
  --vnsc-color-whale-sell: var(--vnsc-color-bearish);
  --vnsc-color-cvd-positive: var(--vnsc-color-bullish);
  --vnsc-color-cvd-negative: var(--vnsc-color-bearish);
  --vnsc-color-darkflow-strong: #7c3aed;
  --vnsc-color-darkflow-weak: #a855f7;
  --vnsc-drawing-color-default: #3b82f6;
  --vnsc-drawing-color-selected: #fbbf24;
  --vnsc-drawing-color-hover: #60a5fa;
  --vnsc-drawing-color-locked: #6c757d;
  --vnsc-drawing-color-hidden: #4a4a4a;
  --vnsc-scrollbar-track: transparent;
  --vnsc-scrollbar-thumb: #3a3a3a;
  --vnsc-scrollbar-thumb-hover: #4a4a4a;
  --vnsc-scrollbar-corner: transparent;
  --vnsc-accent-subtle: rgba(41, 98, 255, 0.15);
  --vnsc-focus-ring: 0 0 0 3px rgba(96, 165, 250, 0.6);
  --vnsc-focus-ring-offset: 2px;
}
.vnsc-root[data-chart-mode=light] {
  --vnsc-bg: var(--vnsc-bg-primary);
  --vnsc-bg-primary: #ffffff;
  --vnsc-bg-primary-rgba: rgba(255, 255, 255, 0.85);
  --vnsc-bg-secondary: #f8fafc;
  --vnsc-bg-tertiary: #f1f5f9;
  --vnsc-bg-elevated: #ffffff;
  --vnsc-bg-overlay: rgba(255, 255, 255, 0.95);
  --vnsc-bg-modal: #ffffff;
  --vnsc-bg-popover: #f8fafc;
  --vnsc-bg-tooltip: #1e293b;
  --vnsc-bg-input: #ffffff;
  --vnsc-bg-input-hover: #f8fafc;
  --vnsc-bg-input-focus: #ffffff;
  --vnsc-bg-disabled: #f1f5f9;
  --vnsc-bg-hover: rgba(0, 0, 0, 0.04);
  --vnsc-bg-active: rgba(0, 0, 0, 0.08);
  --vnsc-bg-selected: rgba(59, 130, 246, 0.1);
  --vnsc-bg-focus: rgba(59, 130, 246, 0.15);
  --vnsc-text: #1e293b;
  --vnsc-text-primary: #0f172a;
  --vnsc-text-secondary: #475569;
  --vnsc-text-tertiary: #94a3b8;
  --vnsc-text-muted: #64748b;
  --vnsc-text-inverse: #ffffff;
  --vnsc-text-link: #2563eb;
  --vnsc-text-link-hover: #1d4ed8;
  --vnsc-text-disabled: #cbd5e1;
  --vnsc-text-placeholder: #94a3b8;
  --vnsc-text-on-primary: #ffffff;
  --vnsc-text-on-accent: #ffffff;
  --vnsc-surface: #ffffff;
  --vnsc-accent: #2563eb;
  --vnsc-accent-hover: #1d4ed8;
  --vnsc-accent-strong: #2563eb;
  --vnsc-border: var(--vnsc-border-primary);
  --vnsc-border-primary: #e2e8f0;
  --vnsc-border-secondary: #cbd5e1;
  --vnsc-border-focus: #2563eb;
  --vnsc-border-input: #e2e8f0;
  --vnsc-border-input-hover: #cbd5e1;
  --vnsc-border-input-focus: #2563eb;
  --vnsc-border-divider: #e2e8f0;
  --vnsc-border-overlay: rgba(0, 0, 0, 0.1);
  --vnsc-color-grid: rgba(150, 160, 180, 0.07);
  --vnsc-color-grid-subtle: rgba(150, 160, 180, 0.035);
  --vnsc-color-crosshair: #2563eb;
  --vnsc-color-selection: rgba(37, 99, 235, 0.15);
  --vnsc-scrollbar-track: transparent;
  --vnsc-scrollbar-thumb: #cbd5e1;
  --vnsc-scrollbar-thumb-hover: #94a3b8;
  --vnsc-focus-ring: 0 0 0 3px rgba(37, 99, 235, 0.55);
  --vnsc-focus-ring-offset: 2px;
}
.vnsc-root[data-chart-theme=classic-dark] {
  --vnsc-bg-primary: #0F1720;
  --vnsc-bg-primary-rgba: rgba(15, 23, 32, 0.85);
  --vnsc-bg-secondary: #07101A;
  --vnsc-bg-tertiary: #0F1925;
  --vnsc-bg-elevated: #122433;
  --vnsc-bg-overlay: rgba(7, 16, 26, 0.9);
  --vnsc-bg-modal: #07101A;
  --vnsc-bg-popover: #0F1720;
  --vnsc-bg-tooltip: #122433;
  --vnsc-bg-input: #0F1720;
  --vnsc-bg-input-hover: #122433;
  --vnsc-bg-hover: rgba(77, 166, 255, 0.06);
  --vnsc-bg-active: rgba(77, 166, 255, 0.1);
  --vnsc-bg-selected: rgba(77, 166, 255, 0.15);
  --vnsc-text-primary: #B8C7D6;
  --vnsc-text-secondary: #7A8B9E;
  --vnsc-text-muted: #4E6273;
  --vnsc-accent: #4DA6FF;
  --vnsc-accent-hover: #3690E8;
  --vnsc-accent-strong: #2B7CD4;
  --vnsc-border-primary: #122433;
  --vnsc-border-divider: #122433;
  --vnsc-border-overlay: rgba(77, 166, 255, 0.15);
  --vnsc-color-grid: rgba(255, 255, 255, 0.05);
  --vnsc-color-grid-subtle: rgba(255, 255, 255, 0.025);
  --vnsc-color-crosshair: #4DA6FF;
  --vnsc-color-selection: rgba(77, 166, 255, 0.15);
  --vnsc-accent-subtle: rgba(77, 166, 255, 0.15);
}
.vnsc-root[data-chart-theme=trading-night] {
  --vnsc-bg-primary: #071226;
  --vnsc-bg-primary-rgba: rgba(7, 18, 38, 0.85);
  --vnsc-bg-secondary: #041022;
  --vnsc-bg-tertiary: #071A30;
  --vnsc-bg-elevated: #083044;
  --vnsc-bg-overlay: rgba(4, 16, 34, 0.9);
  --vnsc-bg-modal: #041022;
  --vnsc-bg-popover: #071226;
  --vnsc-bg-tooltip: #083044;
  --vnsc-bg-input: #071226;
  --vnsc-bg-input-hover: #083044;
  --vnsc-bg-hover: rgba(0, 163, 255, 0.07);
  --vnsc-bg-active: rgba(0, 163, 255, 0.12);
  --vnsc-bg-selected: rgba(0, 163, 255, 0.18);
  --vnsc-text-primary: #A9D6FF;
  --vnsc-text-secondary: #6B9BC0;
  --vnsc-text-muted: #3E6E91;
  --vnsc-accent: #00A3FF;
  --vnsc-accent-hover: #0090E0;
  --vnsc-accent-strong: #0284C7;
  --vnsc-border-primary: #083044;
  --vnsc-border-divider: #083044;
  --vnsc-border-overlay: rgba(0, 163, 255, 0.15);
  --vnsc-color-grid: rgba(255, 255, 255, 0.05);
  --vnsc-color-grid-subtle: rgba(255, 255, 255, 0.025);
  --vnsc-color-crosshair: #00A3FF;
  --vnsc-color-selection: rgba(0, 163, 255, 0.15);
  --vnsc-color-bullish: #00C48C;
  --vnsc-color-bearish: #FF4D6D;
  --vnsc-accent-subtle: rgba(0, 163, 255, 0.15);
}
.vnsc-root[data-chart-theme=modern-light] {
  --vnsc-accent: #0B74DE;
  --vnsc-accent-hover: #095BB8;
  --vnsc-accent-strong: #0B74DE;
  --vnsc-color-crosshair: #0B74DE;
  --vnsc-color-selection: rgba(11, 116, 222, 0.12);
  --vnsc-color-bullish: #1E8A3A;
  --vnsc-color-bearish: #D64545;
  --vnsc-accent-subtle: rgba(11, 116, 222, 0.12);
}
.vnsc-root[data-chart-theme=neutral-pro] {
  --vnsc-bg-primary: #FAFBFC;
  --vnsc-bg-primary-rgba: rgba(250, 251, 252, 0.85);
  --vnsc-bg-secondary: #F4F6F8;
  --vnsc-bg-tertiary: #EEF0F2;
  --vnsc-bg-elevated: #FFFFFF;
  --vnsc-bg-overlay: rgba(244, 246, 248, 0.95);
  --vnsc-bg-modal: #FFFFFF;
  --vnsc-bg-popover: #F4F6F8;
  --vnsc-bg-input: #FFFFFF;
  --vnsc-bg-input-hover: #F4F6F8;
  --vnsc-bg-hover: rgba(43, 108, 176, 0.05);
  --vnsc-bg-active: rgba(43, 108, 176, 0.1);
  --vnsc-bg-selected: rgba(43, 108, 176, 0.15);
  --vnsc-text-primary: #2C3E50;
  --vnsc-text-secondary: #64748B;
  --vnsc-text-muted: #94A3B8;
  --vnsc-accent: #2B6CB0;
  --vnsc-accent-hover: #234F86;
  --vnsc-accent-strong: #2B6CB0;
  --vnsc-border-primary: #E6EDF5;
  --vnsc-border-divider: #E6EDF5;
  --vnsc-border-overlay: rgba(43, 108, 176, 0.1);
  --vnsc-color-grid: rgba(150, 160, 180, 0.07);
  --vnsc-color-grid-subtle: rgba(150, 160, 180, 0.035);
  --vnsc-color-crosshair: #2B6CB0;
  --vnsc-color-selection: rgba(43, 108, 176, 0.12);
  --vnsc-accent-subtle: rgba(43, 108, 176, 0.12);
}
.vnsc-root[data-chart-theme=high-contrast] {
  --vnsc-bg-primary: #000000;
  --vnsc-bg-secondary: #0d0d0d;
  --vnsc-bg-tertiary: #000000;
  --vnsc-bg-elevated: #1a1a1a;
  --vnsc-bg-overlay: rgba(0, 0, 0, 0.95);
  --vnsc-bg-modal: #0d0d0d;
  --vnsc-bg-popover: #0d0d0d;
  --vnsc-bg-tooltip: #1a1a1a;
  --vnsc-bg-input: #000000;
  --vnsc-bg-hover: rgba(255, 255, 255, 0.12);
  --vnsc-bg-active: rgba(255, 255, 255, 0.2);
  --vnsc-bg-selected: rgba(255, 255, 255, 0.18);
  --vnsc-bg-focus: rgba(59, 130, 246, 0.35);
  --vnsc-text-primary: #ffffff;
  --vnsc-text-secondary: #e0e0e0;
  --vnsc-text-tertiary: #b0b0b0;
  --vnsc-text-muted: #c0c0c0;
  --vnsc-text-link: #FFD700;
  --vnsc-text-link-hover: #FFC700;
  --vnsc-text-disabled: #808080;
  --vnsc-text-placeholder: #909090;
  --vnsc-text-on-primary: #000000;
  --vnsc-text-on-accent: #000000;
  --vnsc-border-primary: #ffffff;
  --vnsc-border-secondary: #e0e0e0;
  --vnsc-border-divider: #ffffff;
  --vnsc-border-focus: #FFD700;
  --vnsc-border-overlay: rgba(255, 255, 255, 0.3);
  --vnsc-color-primary: #FFD700;
  --vnsc-color-primary-hover: #FFC700;
  --vnsc-color-primary-active: #FFE033;
  --vnsc-color-accent: #FFD700;
  --vnsc-color-accent-hover: #FFC700;
  --vnsc-accent-strong: #7A6200;
  --vnsc-accent-subtle: rgba(255, 215, 0, 0.15);
  --vnsc-color-bullish: #00ff66;
  --vnsc-color-bearish: #ff3333;
  --vnsc-color-neutral: #cccccc;
  --vnsc-color-grid: rgba(255, 255, 255, 0.15);
  --vnsc-color-grid-subtle: rgba(255, 255, 255, 0.08);
  --vnsc-color-crosshair: #FFD700;
  --vnsc-color-selection: rgba(255, 215, 0, 0.35);
  --vnsc-color-whale-buy: #00ff66;
  --vnsc-color-whale-sell: #ff3333;
  --vnsc-color-success: #00ff66;
  --vnsc-color-success-hover: #33ff88;
  --vnsc-color-warning: #ffcc00;
  --vnsc-color-warning-hover: #ffdd33;
  --vnsc-color-error: #ff3333;
  --vnsc-color-error-hover: #ff6666;
  --vnsc-color-info: #60a5fa;
  --vnsc-scrollbar-thumb: #606060;
  --vnsc-scrollbar-thumb-hover: #909090;
  --vnsc-focus-ring: 0 0 0 3px rgba(96, 165, 250, 0.6);
  --vnsc-focus-ring-offset: 2px;
}

/* src/widget/styles/tokens/spacing.css */
.vnsc-root {
  --vnsc-space-0: 0;
  --vnsc-space-1: 4px;
  --vnsc-space-2: 8px;
  --vnsc-space-3: 12px;
  --vnsc-space-4: 16px;
  --vnsc-space-5: 20px;
  --vnsc-space-6: 24px;
  --vnsc-space-8: 32px;
  --vnsc-space-10: 40px;
  --vnsc-space-12: 48px;
  --vnsc-space-16: 64px;
  --vnsc-space-xs: 4px;
  --vnsc-space-sm: 8px;
  --vnsc-space-md: 16px;
  --vnsc-space-lg: 24px;
  --vnsc-space-xl: 32px;
  --vnsc-space-2xl: 40px;
  --vnsc-space-3xl: 48px;
  --vnsc-space-toolbar-gap: 8px;
  --vnsc-space-toolbar-padding: 8px;
  --vnsc-space-panel-padding: 16px;
  --vnsc-space-modal-padding: 24px;
  --vnsc-space-drawing-gap: 4px;
  --vnsc-space-dock-padding: 12px;
  --vnsc-space-splitter-size: 4px;
  --vnsc-space-header-height: 36px;
  --vnsc-space-footer-height: 28px;
  --vnsc-space-panel-height: 300px;
  --vnsc-radius-none: 0;
  --vnsc-radius-xs: 2px;
  --vnsc-radius-sm: 4px;
  --vnsc-radius-md: 6px;
  --vnsc-radius-lg: 8px;
  --vnsc-radius-xl: 12px;
  --vnsc-radius-2xl: 16px;
  --vnsc-radius-full: 9999px;
  --vnsc-radius-button: 4px;
  --vnsc-radius-input: 4px;
  --vnsc-radius-card: 8px;
  --vnsc-radius-modal: 12px;
  --vnsc-radius-popover: 8px;
  --vnsc-radius-tooltip: 6px;
  --vnsc-size-xs: 16px;
  --vnsc-size-sm: 24px;
  --vnsc-size-md: 32px;
  --vnsc-size-lg: 40px;
  --vnsc-size-xl: 48px;
  --vnsc-size-2xl: 56px;
  --vnsc-size-3xl: 64px;
  --vnsc-icon-xs: 12px;
  --vnsc-icon-sm: 16px;
  --vnsc-icon-md: 20px;
  --vnsc-icon-lg: 24px;
  --vnsc-icon-xl: 28px;
  --vnsc-btn-height-sm: 24px;
  --vnsc-btn-height-md: 32px;
  --vnsc-btn-height-lg: 40px;
  --vnsc-btn-padding-x-sm: 8px;
  --vnsc-btn-padding-x-md: 12px;
  --vnsc-btn-padding-x-lg: 16px;
  --vnsc-input-height-sm: 24px;
  --vnsc-input-height-md: 32px;
  --vnsc-input-height-lg: 40px;
  --vnsc-input-padding-x: 10px;
  --vnsc-chart-margin-top: 8px;
  --vnsc-chart-margin-right: 12px;
  --vnsc-chart-margin-bottom: 32px;
  --vnsc-chart-margin-left: 12px;
  --vnsc-pane-min-height: 60px;
  --vnsc-pane-handle-size: 4px;
  --vnsc-tooltip-padding: 8px 12px;
  --vnsc-tooltip-gap: 4px;
}

/* src/widget/styles/tokens/typography.css */
.vnsc-root {
  --vnsc-font-family-base:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    "Helvetica Neue",
    Arial,
    sans-serif;
  --vnsc-font-family-mono:
    "JetBrains Mono",
    "Fira Code",
    "Consolas",
    "Monaco",
    monospace;
  --vnsc-font-family-display:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
  --vnsc-font-family-ui: var(--vnsc-font-family-base);
  --vnsc-font-family: var(--vnsc-font-family-base);
  --vnsc-font-mono: var(--vnsc-font-family-mono);
  --vnsc-font-size-2xs: 10px;
  --vnsc-font-size-xs: 11px;
  --vnsc-font-size-sm: 12px;
  --vnsc-font-size-base: 13px;
  --vnsc-font-size-md: 14px;
  --vnsc-font-size-lg: 16px;
  --vnsc-font-size-xl: 18px;
  --vnsc-font-size-2xl: 20px;
  --vnsc-font-size-3xl: 24px;
  --vnsc-font-size-4xl: 30px;
  --vnsc-font-2xs: var(--vnsc-font-size-2xs);
  --vnsc-font-xs: var(--vnsc-font-size-xs);
  --vnsc-font-sm: var(--vnsc-font-size-sm);
  --vnsc-font-base: var(--vnsc-font-size-base);
  --vnsc-font-md: var(--vnsc-font-size-md);
  --vnsc-font-lg: var(--vnsc-font-size-lg);
  --vnsc-font-xl: var(--vnsc-font-size-xl);
  --vnsc-font-size-caption: 10px;
  --vnsc-font-size-overline: 10px;
  --vnsc-font-size-body-sm: 12px;
  --vnsc-font-size-body: 13px;
  --vnsc-font-size-body-lg: 14px;
  --vnsc-font-size-heading-sm: 14px;
  --vnsc-font-size-heading: 16px;
  --vnsc-font-size-heading-lg: 18px;
  --vnsc-font-size-display: 24px;
  --vnsc-font-weight-light: 300;
  --vnsc-font-weight-normal: 400;
  --vnsc-font-weight-medium: 500;
  --vnsc-font-weight-semibold: 600;
  --vnsc-font-weight-bold: 700;
  --vnsc-font-weight-extrabold: 800;
  --vnsc-font-weight-regular: 400;
  --vnsc-font-weight-body: 400;
  --vnsc-font-weight-heading: 600;
  --vnsc-font-weight-button: 500;
  --vnsc-line-height-none: 1;
  --vnsc-line-height-tight: 1.25;
  --vnsc-line-height-snug: 1.375;
  --vnsc-line-height-normal: 1.5;
  --vnsc-line-height-relaxed: 1.625;
  --vnsc-line-height-loose: 2;
  --vnsc-line-height-heading: 1.25;
  --vnsc-line-height-body: 1.5;
  --vnsc-line-height-code: 1.6;
  --vnsc-letter-spacing-tight: -0.02em;
  --vnsc-letter-spacing-normal: 0;
  --vnsc-letter-spacing-wide: 0.02em;
  --vnsc-letter-spacing-wider: 0.04em;
  --vnsc-letter-spacing-widest: 0.1em;
  --vnsc-letter-spacing-heading: -0.02em;
  --vnsc-letter-spacing-button: 0.02em;
  --vnsc-letter-spacing-caption: 0.04em;
  --vnsc-typography-toolbar: var(--vnsc-font-size-sm) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);
  --vnsc-typography-panel-title: var(--vnsc-font-size-base) / var(--vnsc-line-height-tight) var(--vnsc-font-family-ui);
  --vnsc-typography-panel-body: var(--vnsc-font-size-sm) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);
  --vnsc-typography-modal-title: var(--vnsc-font-size-lg) / var(--vnsc-line-height-tight) var(--vnsc-font-family-display);
  --vnsc-typography-modal-body: var(--vnsc-font-size-base) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);
  --vnsc-typography-tooltip: var(--vnsc-font-size-xs) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);
  --vnsc-typography-button: var(--vnsc-font-size-sm) / var(--vnsc-line-height-none) var(--vnsc-font-family-ui);
  --vnsc-typography-input: var(--vnsc-font-size-sm) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);
  --vnsc-typography-label: var(--vnsc-font-size-xs) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);
  --vnsc-typography-chart-axis: var(--vnsc-font-size-xs) / var(--vnsc-line-height-normal) var(--vnsc-font-family-mono);
  --vnsc-typography-chart-tooltip: var(--vnsc-font-size-sm) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);
  --vnsc-typography-chart-price: var(--vnsc-font-size-base) / var(--vnsc-line-height-tight) var(--vnsc-font-family-mono);
  --vnsc-typography-drawing-label: var(--vnsc-font-size-xs) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);
}

/* src/widget/styles/tokens/shadows.css */
.vnsc-root {
  --vnsc-shadow-none: none;
  --vnsc-shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.05);
  --vnsc-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  --vnsc-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --vnsc-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --vnsc-shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --vnsc-shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --vnsc-shadow-inner: inset 0 2px 4px rgba(0, 0, 0, 0.06);
  --vnsc-shadow-primary: 0 4px 14px rgba(59, 130, 246, 0.4);
  --vnsc-shadow-primary-lg: 0 10px 25px rgba(59, 130, 246, 0.3);
  --vnsc-shadow-success: 0 4px 14px rgba(34, 168, 94, 0.4);
  --vnsc-shadow-error: 0 4px 14px rgba(192, 57, 43, 0.4);
  --vnsc-shadow-warning: 0 4px 14px rgba(230, 126, 34, 0.4);
  --vnsc-shadow-focus: 0 0 0 3px rgba(59, 130, 246, 0.4);
  --vnsc-shadow-focus-error: 0 0 0 3px rgba(192, 57, 43, 0.4);
  --vnsc-shadow-focus-success: 0 0 0 3px rgba(34, 168, 94, 0.4);
  --vnsc-elevation-0: var(--vnsc-shadow-none);
  --vnsc-elevation-1: var(--vnsc-shadow-sm);
  --vnsc-elevation-2: var(--vnsc-shadow-md);
  --vnsc-elevation-3: var(--vnsc-shadow-lg);
  --vnsc-elevation-4: var(--vnsc-shadow-xl);
  --vnsc-elevation-5: var(--vnsc-shadow-2xl);
  --vnsc-shadow-toolbar: var(--vnsc-elevation-2);
  --vnsc-shadow-panel: var(--vnsc-elevation-3);
  --vnsc-shadow-modal: var(--vnsc-elevation-4);
  --vnsc-shadow-popover: var(--vnsc-elevation-3);
  --vnsc-shadow-tooltip: var(--vnsc-elevation-2);
  --vnsc-shadow-dropdown: var(--vnsc-elevation-3);
  --vnsc-shadow-dock: 0 10px 30px rgba(0, 0, 0, 0.3);
  --vnsc-shadow-drawing: 0 2px 8px rgba(0, 0, 0, 0.2);
  --vnsc-shadow-splitter: none;
  --vnsc-shadow-chart-container: var(--vnsc-elevation-1);
}
.vnsc-root[data-chart-mode=light] {
  --vnsc-shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.05);
  --vnsc-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
  --vnsc-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -1px rgba(0, 0, 0, 0.04);
  --vnsc-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.03);
  --vnsc-shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.03);
  --vnsc-shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
  --vnsc-shadow-inner: inset 0 2px 4px rgba(0, 0, 0, 0.04);
  --vnsc-shadow-focus: 0 0 0 3px rgba(37, 99, 235, 0.4);
  --vnsc-shadow-focus-error: 0 0 0 3px rgba(192, 57, 43, 0.4);
  --vnsc-shadow-focus-success: 0 0 0 3px rgba(34, 168, 94, 0.4);
  --vnsc-shadow-dock: 0 10px 30px rgba(0, 0, 0, 0.15);
  --vnsc-shadow-drawing: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* src/widget/styles/tokens/motion.css */
.vnsc-root {
  --vnsc-transition-duration-instant: 0ms;
  --vnsc-transition-duration-fast: 100ms;
  --vnsc-transition-duration-normal: 200ms;
  --vnsc-transition-duration-slow: 300ms;
  --vnsc-transition-duration-slower: 500ms;
  --vnsc-transition-duration-hover: 150ms;
  --vnsc-transition-duration-focus: 100ms;
  --vnsc-transition-duration-press: 50ms;
  --vnsc-transition-duration-enter: 200ms;
  --vnsc-transition-duration-exit: 150ms;
  --vnsc-transition-duration-modal: 200ms;
  --vnsc-transition-duration-tooltip: 100ms;
  --vnsc-transition-duration-panel: 300ms;
  --vnsc-transition-easing-linear: linear;
  --vnsc-transition-easing-ease-in: cubic-bezier(0.4, 0, 1, 1);
  --vnsc-transition-easing-ease-out: cubic-bezier(0, 0, 0.2, 1);
  --vnsc-transition-easing-ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
  --vnsc-transition-easing-spring: cubic-bezier(0.34, 1.56, 0.64, 1);
  --vnsc-transition-easing-bounce: cubic-bezier(0.68, -0.55, 0.265, 1.55);
  --vnsc-transition-easing-default: var(--vnsc-transition-easing-ease-out);
  --vnsc-transition-easing-enter: var(--vnsc-transition-easing-ease-out);
  --vnsc-transition-easing-exit: var(--vnsc-transition-easing-ease-in);
  --vnsc-transition-easing-spring: var(--vnsc-transition-easing-spring);
  --vnsc-transition-property-all: all;
  --vnsc-transition-property-colors:
    color,
    background-color,
    border-color,
    fill,
    stroke;
  --vnsc-transition-property-transform: transform;
  --vnsc-transition-property-opacity: opacity;
  --vnsc-transition-property-shadow: box-shadow;
  --vnsc-transition-property-visibility: visibility;
  --vnsc-transition-fast: var(--vnsc-transition-duration-fast) var(--vnsc-transition-easing-default);
  --vnsc-transition-normal: var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-default);
  --vnsc-transition-slow: var(--vnsc-transition-duration-slow) var(--vnsc-transition-easing-default);
  --vnsc-transition-colors-fast: var(--vnsc-transition-property-colors) var(--vnsc-transition-duration-fast) var(--vnsc-transition-easing-default);
  --vnsc-transition-colors-normal: var(--vnsc-transition-property-colors) var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-default);
  --vnsc-transition-transform-fast: var(--vnsc-transition-property-transform) var(--vnsc-transition-duration-fast) var(--vnsc-transition-easing-spring);
  --vnsc-transition-transform-normal: var(--vnsc-transition-property-transform) var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-spring);
  --vnsc-transition-opacity-fast: var(--vnsc-transition-property-opacity) var(--vnsc-transition-duration-fast) var(--vnsc-transition-easing-default);
  --vnsc-transition-opacity-normal: var(--vnsc-transition-property-opacity) var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-default);
  --vnsc-transition-shadow-fast: var(--vnsc-transition-property-shadow) var(--vnsc-transition-duration-fast) var(--vnsc-transition-easing-default);
  --vnsc-transition-shadow-normal: var(--vnsc-transition-property-shadow) var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-default);
  --vnsc-transition-button: var(--vnsc-transition-colors-fast), var(--vnsc-transition-transform-fast);
  --vnsc-transition-input: var(--vnsc-transition-colors-fast), var(--vnsc-transition-shadow-fast);
  --vnsc-transition-panel: var(--vnsc-transition-transform-normal), var(--vnsc-transition-opacity-normal);
  --vnsc-transition-modal: var(--vnsc-transition-transform-normal), var(--vnsc-transition-opacity-normal);
  --vnsc-transition-tooltip: var(--vnsc-transition-opacity-fast), var(--vnsc-transition-transform-fast);
  --vnsc-transition-dropdown: var(--vnsc-transition-transform-normal), var(--vnsc-transition-opacity-normal);
  --vnsc-transition-drawing: var(--vnsc-transition-transform-fast), var(--vnsc-transition-opacity-fast);
  --vnsc-transition-splitter: var(--vnsc-transition-transform-fast);
  --vnsc-transition-chart: var(--vnsc-transition-transform-normal);
  --vnsc-animation-duration-spin: 1000ms;
  --vnsc-animation-duration-pulse: 2000ms;
  --vnsc-animation-duration-bounce: 1000ms;
  --vnsc-animation-duration-shimmer: 1500ms;
  --vnsc-animation-spin: spin var(--vnsc-animation-duration-spin) linear infinite;
  --vnsc-animation-pulse: pulse var(--vnsc-animation-duration-pulse) ease-in-out infinite;
  --vnsc-animation-bounce: bounce var(--vnsc-animation-duration-bounce) var(--vnsc-transition-easing-bounce) infinite;
  --vnsc-animation-shimmer: shimmer var(--vnsc-animation-duration-shimmer) ease-in-out infinite;
  --vnsc-animation-fade-in: fadeIn var(--vnsc-transition-duration-enter) var(--vnsc-transition-easing-enter);
  --vnsc-animation-fade-out: fadeOut var(--vnsc-transition-duration-exit) var(--vnsc-transition-easing-exit);
  --vnsc-animation-slide-up: slideUp var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-enter);
  --vnsc-animation-slide-down: slideDown var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-enter);
  --vnsc-animation-slide-left: slideLeft var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-enter);
  --vnsc-animation-slide-right: slideRight var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-enter);
  --vnsc-animation-scale-in: scaleIn var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-spring);
  --vnsc-animation-scale-out: scaleOut var(--vnsc-transition-duration-exit) var(--vnsc-transition-easing-exit);
}
@media (prefers-reduced-motion: reduce) {
  .vnsc-root {
    --vnsc-transition-duration-instant: 0ms;
    --vnsc-transition-duration-fast: 0ms;
    --vnsc-transition-duration-normal: 0ms;
    --vnsc-transition-duration-slow: 0ms;
    --vnsc-transition-duration-slower: 0ms;
    --vnsc-transition-duration-hover: 0ms;
    --vnsc-transition-duration-focus: 0ms;
    --vnsc-transition-duration-press: 0ms;
    --vnsc-transition-duration-enter: 0ms;
    --vnsc-transition-duration-exit: 0ms;
    --vnsc-transition-duration-modal: 0ms;
    --vnsc-transition-duration-tooltip: 0ms;
    --vnsc-transition-duration-panel: 0ms;
    --vnsc-animation-duration-spin: 0ms;
    --vnsc-animation-duration-pulse: 0ms;
    --vnsc-animation-duration-bounce: 0ms;
    --vnsc-animation-duration-shimmer: 0ms;
  }
  .vnsc-root *,
  .vnsc-root *::before,
  .vnsc-root *::after {
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes slideUp {
  from {
    transform: translateY(10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slideDown {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slideLeft {
  from {
    transform: translateX(10px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slideRight {
  from {
    transform: translateX(-10px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes scaleIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes scaleOut {
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(0.95);
    opacity: 0;
  }
}

/* src/widget/styles/tokens/z-index.css */
.vnsc-root {
  --vnsc-z-0: 0;
  --vnsc-z-1: 1;
  --vnsc-z-2: 2;
  --vnsc-z-3: 3;
  --vnsc-z-4: 4;
  --vnsc-z-5: 5;
  --vnsc-z-10: 10;
  --vnsc-z-20: 20;
  --vnsc-z-30: 30;
  --vnsc-z-40: 40;
  --vnsc-z-50: 50;
  --vnsc-z-background: 0;
  --vnsc-z-content: 1;
  --vnsc-z-raised: 10;
  --vnsc-z-overlay: 20;
  --vnsc-z-modal: 30;
  --vnsc-z-popover: 40;
  --vnsc-z-tooltip: 50;
  --vnsc-z-toast: 60;
  --vnsc-z-maximum: 9999;
  --vnsc-z-chart-canvas: 1;
  --vnsc-z-chart-overlay: 10;
  --vnsc-z-chart-crosshair: 15;
  --vnsc-z-chart-tooltip: 20;
  --vnsc-z-chart-drawing: 25;
  --vnsc-z-chart-selection: 30;
  --vnsc-z-chart-measurement: 35;
  --vnsc-z-chart-x-axis: 40;
  --vnsc-z-chart-pane-tooltip: 45;
  --vnsc-z-toolbar: 50;
  --vnsc-z-header: 55;
  --vnsc-z-footer: 55;
  --vnsc-z-dock: 60;
  --vnsc-z-dock-flyout: 65;
  --vnsc-z-drawing-toolbar: 70;
  --vnsc-z-drawing-inspector: 75;
  --vnsc-z-drawing-list: 75;
  --vnsc-z-drawing-context-menu: 80;
  --vnsc-z-panel: 85;
  --vnsc-z-panel-content: 90;
  --vnsc-z-modal-backdrop: 95;
  --vnsc-z-modal: 100;
  --vnsc-z-modal-content: 105;
  --vnsc-z-popover: 110;
  --vnsc-z-popover-content: 115;
  --vnsc-z-tooltip: 120;
  --vnsc-z-tooltip-content: 125;
  --vnsc-z-toast: 130;
  --vnsc-z-toast-content: 135;
  --vnsc-z-ads-banner: 95;
  --vnsc-z-ads-popup: 99;
  --vnsc-z-trademark: 100;
  --vnsc-z-sidebar: 48;
  --vnsc-z-sidebar-splitter: 49;
  --vnsc-z-sidebar-content: 50;
  --vnsc-z-bottom-panel: 40;
  --vnsc-z-bottom-panel-content: 41;
  --vnsc-z-drawing-dock: 50;
  --vnsc-z-drawing-dock-header: 51;
  --vnsc-z-drawing-dock-content: 52;
  --vnsc-z-drawing-dock-flyout: 55;
  --vnsc-z-settings-modal: 100;
  --vnsc-z-settings-modal-content: 101;
  --vnsc-z-settings-modal-tabs: 102;
  --vnsc-z-snapshot-modal: 100;
  --vnsc-z-snapshot-modal-content: 101;
  --vnsc-z-alerts-modal: 100;
  --vnsc-z-alerts-modal-content: 101;
  --vnsc-z-symbol-search: 80;
  --vnsc-z-symbol-search-results: 81;
  --vnsc-z-whale-panel: 60;
  --vnsc-z-whale-panel-content: 61;
  --vnsc-z-context-rail: 55;
  --vnsc-z-context-rail-content: 56;
  --vnsc-z-pat-modal: 100;
  --vnsc-z-pat-modal-content: 101;
}

/* src/widget/styles/tokens/opacity.css */
.vnsc-root {
  --vnsc-opacity-disabled: 0.38;
  --vnsc-opacity-hover: 0.04;
  --vnsc-opacity-focus: 0.12;
  --vnsc-opacity-pressed: 0.16;
  --vnsc-opacity-dragging: 0.08;
  --vnsc-opacity-overlay: 0.5;
  --vnsc-opacity-backdrop: 0.85;
  --vnsc-opacity-watermark: 0.05;
  --vnsc-opacity-skeleton-base: 0.08;
  --vnsc-opacity-skeleton-highlight: 0.15;
}

/* src/widget/styles/tokens/focus.css */
.vnsc-root {
  --vnsc-ring-width: 2px;
  --vnsc-ring-offset: 2px;
  --vnsc-ring-color: var(--vnsc-color-primary);
  --vnsc-ring-opacity: 0.4;
}

/* src/widget/styles/tokens/surfaces.css */
.vnsc-root {
  --vnsc-surface-0: var(--vnsc-bg-primary);
  --vnsc-surface-1: var(--vnsc-bg-secondary);
  --vnsc-surface-2: var(--vnsc-bg-tertiary);
  --vnsc-surface-3: var(--vnsc-bg-elevated);
  --vnsc-surface-4: var(--vnsc-bg-elevated);
}
.vnsc-root[data-chart-mode=light] {
  --vnsc-surface-4: #e2e8f0;
}

/* src/widget/styles/tokens/states.css */
.vnsc-root {
  --vnsc-state-hover: var(--vnsc-bg-hover);
  --vnsc-state-active: var(--vnsc-bg-active);
  --vnsc-state-pressed: rgba(255, 255, 255, 0.12);
  --vnsc-state-dragging: rgba(59, 130, 246, 0.08);
  --vnsc-state-loading: var(--vnsc-bg-disabled);
  --vnsc-state-selected: var(--vnsc-bg-selected);
  --vnsc-state-focus-within: var(--vnsc-bg-focus);
}
.vnsc-root[data-chart-mode=light] {
  --vnsc-state-pressed: rgba(0, 0, 0, 0.12);
  --vnsc-state-dragging: rgba(37, 99, 235, 0.08);
}

/* src/widget/styles/tokens/backdrop.css */
.vnsc-root {
  --vnsc-backdrop-blur-sm: 4px;
  --vnsc-backdrop-blur-md: 8px;
  --vnsc-backdrop-blur-lg: 16px;
  --vnsc-backdrop-blur-xl: 24px;
  --vnsc-backdrop-saturate: 1.8;
  --vnsc-backdrop-brightness: 0.7;
}

/* src/widget/styles/tokens/indicators.css */
.vnsc-root {
  --vnsc-indicator-1: #2962ff;
  --vnsc-indicator-2: #ff6d00;
  --vnsc-indicator-3: #e040fb;
  --vnsc-indicator-4: #00bcd4;
  --vnsc-indicator-5: #ffeb3b;
  --vnsc-indicator-6: #4caf50;
  --vnsc-indicator-7: #ff5252;
  --vnsc-indicator-8: #7c4dff;
  --vnsc-indicator-9: #00e676;
  --vnsc-indicator-10: #ff9100;
  --vnsc-macd-signal: #ff6d00;
  --vnsc-macd-histogram-positive: var(--vnsc-color-bullish);
  --vnsc-macd-histogram-negative: var(--vnsc-color-bearish);
  --vnsc-bb-upper: #2962ff;
  --vnsc-bb-lower: #2962ff;
  --vnsc-bb-fill: rgba(41, 98, 255, 0.06);
}

/* src/widget/styles/tokens/gradients.css */
.vnsc-root {
  --vnsc-gradient-area-fill:
    linear-gradient(
      180deg,
      rgba(41,98,255,0.28) 0%,
      rgba(41,98,255,0) 100%);
  --vnsc-gradient-volume-fade:
    linear-gradient(
      180deg,
      var(--vnsc-color-volume),
      transparent);
  --vnsc-gradient-shimmer:
    linear-gradient(
      90deg,
      transparent 0%,
      rgba(255,255,255,0.05) 50%,
      transparent 100%);
}

/* src/widget/styles/tokens/breakpoints.css */
.vnsc-root {
  --vnsc-breakpoint-compact: 480px;
  --vnsc-breakpoint-medium: 768px;
  --vnsc-breakpoint-wide: 1200px;
  --vnsc-breakpoint-ultra: 1920px;
}

/* src/widget/styles/tokens/presets/midnight-blue.css */
.vnsc-root[data-chart-theme=midnight-blue] {
  --vnsc-bg-primary: #0d1117;
  --vnsc-bg-secondary: #161b22;
  --vnsc-bg-tertiary: #0d1117;
  --vnsc-bg-elevated: #1c2333;
  --vnsc-bg-overlay: rgba(13, 17, 23, 0.9);
  --vnsc-bg-modal: #161b22;
  --vnsc-bg-popover: #161b22;
  --vnsc-bg-tooltip: #1c2333;
  --vnsc-bg-input: #0d1117;
  --vnsc-bg-input-hover: #161b22;
  --vnsc-bg-hover: rgba(88, 166, 255, 0.08);
  --vnsc-bg-active: rgba(88, 166, 255, 0.14);
  --vnsc-bg-selected: rgba(88, 166, 255, 0.2);
  --vnsc-bg-focus: rgba(88, 166, 255, 0.25);
  --vnsc-text-primary: #c9d1d9;
  --vnsc-text-secondary: #8b949e;
  --vnsc-text-tertiary: #484f58;
  --vnsc-text-link: #58a6ff;
  --vnsc-text-link-hover: #79c0ff;
  --vnsc-border-primary: #21262d;
  --vnsc-border-secondary: #30363d;
  --vnsc-border-divider: #21262d;
  --vnsc-color-primary: #58a6ff;
  --vnsc-color-primary-hover: #79c0ff;
  --vnsc-color-primary-active: #79c0ff;
  --vnsc-color-accent: #58a6ff;
  --vnsc-color-accent-hover: #79c0ff;
  --vnsc-color-grid: rgba(255, 255, 255, 0.07);
  --vnsc-color-grid-subtle: rgba(255, 255, 255, 0.03);
  --vnsc-color-crosshair: #58a6ff;
  --vnsc-color-selection: rgba(88, 166, 255, 0.2);
  --vnsc-scrollbar-thumb: #30363d;
  --vnsc-scrollbar-thumb-hover: #484f58;
}

/* src/widget/styles/tokens/index.css */

/* src/widget/styles/pane-overlays.css */
.vnsc-pane-label,
.rsc-pane-label {
  position: absolute;
  left: 0;
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--vnsc-text-micro, #7c8798);
  pointer-events: none;
  user-select: none;
  z-index: 10;
}
.vnsc-pane-header,
.rsc-pane-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  padding: 0;
  background: transparent;
  border-bottom: none;
  opacity: 0;
  pointer-events: none;
  transition: opacity 150ms ease;
  z-index: 50;
  min-width: 0;
}
.vnsc-pane-wrap:hover .vnsc-pane-header,
.vnsc-pane-wrap:focus-within .vnsc-pane-header,
.vnsc-pane-wrap--active .vnsc-pane-header,
.rsc-pane-wrap:hover .rsc-pane-header,
.rsc-pane-wrap:focus-within .rsc-pane-header,
.rsc-pane-wrap--active .rsc-pane-header {
  opacity: 1;
  pointer-events: auto;
}
.vnsc-pane-header__label,
.rsc-pane-header__label {
  display: inline-flex;
  align-items: center;
  min-height: 16px;
  padding: 0 6px;
  border-radius: 3px;
  background: color-mix(in srgb, var(--vnsc-surface, var(--vnsc-bg, #131722)) 90%, transparent);
  border: 1px solid color-mix(in srgb, var(--vnsc-border, rgba(148, 163, 184, 0.24)) 100%, transparent);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: var(--vnsc-text-secondary, #787b86);
  flex-shrink: 0;
}
.vnsc-pane-header__content,
.rsc-pane-header__content {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
}
.vnsc-pane-header__actions,
.rsc-pane-header__actions {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  min-height: 16px;
  padding: 0 4px;
  border-radius: 4px;
  background: color-mix(in srgb, var(--vnsc-surface, var(--vnsc-bg, #131722)) 90%, transparent);
  border: 1px solid color-mix(in srgb, var(--vnsc-border, rgba(148, 163, 184, 0.24)) 100%, transparent);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  margin-left: auto;
  margin-right: 0;
  flex-shrink: 0;
}
.vnsc-pane-btn,
.rsc-pane-btn {
  border: 1px solid transparent;
  background: transparent;
  color: var(--vnsc-text-secondary, #787b86);
  padding: 1px 4px;
  border-radius: 3px;
  cursor: pointer;
  font: inherit;
  line-height: 1;
  font-size: 12px;
  transition: color 0.15s ease, border-color 0.15s ease;
}
.vnsc-pane-btn:hover,
.rsc-pane-btn:hover {
  color: var(--vnsc-text-primary, #d1d4dc);
  border-color: rgba(255, 255, 255, 0.12);
}
.vnsc-pane-btn:disabled,
.rsc-pane-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  border-color: transparent;
}
.vnsc-pane-wrap,
.rsc-pane-wrap {
  overflow: visible;
}
.vnsc-series-picker,
.rsc-series-picker {
  position: absolute;
  min-width: 340px;
  max-width: min(480px, calc(100vw - 24px));
  box-sizing: border-box;
  padding: 6px;
  border-radius: 10px;
  background: var(--vnsc-surface, rgba(255, 255, 255, 0.98));
  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.24));
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.18);
  z-index: 70;
}
.vnsc-series-picker__search,
.rsc-series-picker__search {
  padding: 4px 6px 8px;
}
.vnsc-series-picker__search-input,
.rsc-series-picker__search-input {
  width: 100%;
  padding: 6px 10px;
  border-radius: var(--vnsc-radius-sm, 4px);
  border: 1px solid var(--vnsc-border-input, #2a2a2a);
  background: var(--vnsc-bg-input, #1a1f2e);
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: var(--vnsc-font-sm, 12px);
  outline: none;
  box-sizing: border-box;
}
.vnsc-series-picker__search-input:focus,
.rsc-series-picker__search-input:focus {
  border-color: var(--vnsc-accent, #2962ff);
}
.vnsc-series-picker__search-input::placeholder,
.rsc-series-picker__search-input::placeholder {
  color: var(--vnsc-text-muted, #64748b);
}
.vnsc-series-picker__list,
.rsc-series-picker__list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 320px;
  overflow: auto;
}
.vnsc-series-picker__item,
.rsc-series-picker__item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--vnsc-text, #1e2a3b);
  text-align: left;
  cursor: pointer;
  font-size: 13px;
  font-family: inherit;
  line-height: 1.4;
}
.vnsc-series-picker__item:hover,
.rsc-series-picker__item:hover {
  background: rgba(45, 156, 219, 0.12);
}
.vnsc-series-picker__item--active,
.rsc-series-picker__item--active {
  background: rgba(45, 156, 219, 0.16);
}
.vnsc-series-picker__label,
.rsc-series-picker__label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vnsc-series-picker__check,
.rsc-series-picker__check {
  font-size: 12px;
  color: #2d9cdb;
  flex-shrink: 0;
}
.vnsc-series-picker__empty,
.rsc-series-picker__empty {
  padding: 16px 10px;
  text-align: center;
  color: var(--vnsc-text-muted, #64748b);
  font-size: 13px;
}
.vnsc-series-picker__footer,
.rsc-series-picker__footer {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid rgba(148, 163, 184, 0.18);
  font-size: 11px;
  color: var(--vnsc-text-muted, #64748b);
}
.vnsc-indicator-legend,
.rsc-indicator-legend {
  position: absolute;
  top: 24px;
  left: 80px;
  right: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px 0;
  opacity: 0;
  pointer-events: none;
  transition: opacity 150ms ease;
  z-index: 15;
}
.vnsc-pane-header__legend,
.rsc-pane-header__legend {
  display: flex;
  position: static;
  top: auto;
  left: auto;
  right: auto;
  flex: 1 1 auto;
  min-width: 0;
  max-height: 16px;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 3px;
  padding: 0;
  opacity: 1;
  pointer-events: auto;
  transition: none;
  z-index: auto;
  scrollbar-width: none;
}
.vnsc-pane-header__legend::-webkit-scrollbar,
.rsc-pane-header__legend::-webkit-scrollbar {
  display: none;
}
.vnsc-pane-wrap:hover .vnsc-indicator-legend,
.vnsc-pane-wrap:focus-within .vnsc-indicator-legend,
.vnsc-pane-wrap--active .vnsc-indicator-legend,
.rsc-pane-wrap:hover .rsc-indicator-legend,
.rsc-pane-wrap:focus-within .rsc-indicator-legend,
.rsc-pane-wrap--active .rsc-indicator-legend {
  opacity: 1;
  pointer-events: auto;
}
.vnsc-indicator-chip,
.rsc-indicator-chip {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 0 5px;
  height: 16px;
  line-height: 1;
  box-sizing: border-box;
  border-radius: 4px;
  background: var(--vnsc-surface, rgba(255, 255, 255, 0.92));
  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.24));
  font-size: 9px;
  font-weight: 500;
  color: var(--vnsc-text, #1e2a3b);
  cursor: default;
  user-select: none;
  white-space: nowrap;
}
.vnsc-indicator-chip--hidden,
.rsc-indicator-chip--hidden {
  opacity: 0.45;
}
.vnsc-indicator-chip__dot,
.rsc-indicator-chip__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--chip-color, #2962ff);
  flex-shrink: 0;
}
.vnsc-indicator-chip__name,
.rsc-indicator-chip__name {
  white-space: nowrap;
}
.vnsc-indicator-chip__suffix,
.rsc-indicator-chip__suffix {
  margin-left: 3px;
  font-size: 8px;
  font-weight: 600;
  color: var(--chip-color, #2962ff);
}
.vnsc-indicator-chip__btn,
.rsc-indicator-chip__btn {
  border: 0;
  background: transparent;
  color: inherit;
  padding: 0 1px;
  cursor: pointer;
  font-size: 10px;
  line-height: 1;
  border-radius: 2px;
  display: flex;
  align-items: center;
}
.vnsc-indicator-chip__btn:hover,
.rsc-indicator-chip__btn:hover {
  background: rgba(148, 163, 184, 0.18);
}
.vnsc-indicator-chip__btn--remove,
.rsc-indicator-chip__btn--remove {
  opacity: 0.5;
}
.vnsc-indicator-chip__btn--remove:hover,
.rsc-indicator-chip__btn--remove:hover {
  opacity: 1;
  color: #f23645;
  background: rgba(242, 54, 69, 0.08);
}
@media (hover: hover) {
  .vnsc-indicator-chip__btn,
  .rsc-indicator-chip__btn {
    width: 0;
    max-width: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
    opacity: 0;
    transform: scale(0.8);
    transition:
      width 140ms ease,
      max-width 140ms ease,
      margin 140ms ease,
      opacity 120ms ease,
      transform 140ms ease;
  }
  .vnsc-indicator-chip:hover .vnsc-indicator-chip__btn,
  .rsc-indicator-chip:hover .rsc-indicator-chip__btn,
  .vnsc-indicator-chip:focus-within .vnsc-indicator-chip__btn,
  .rsc-indicator-chip:focus-within .rsc-indicator-chip__btn,
  .vnsc-indicator-chip__btn:focus-visible,
  .rsc-indicator-chip__btn:focus-visible {
    width: 14px;
    max-width: 14px;
    margin-left: 2px;
    opacity: 0.7;
    transform: scale(1);
  }
  .vnsc-indicator-chip__btn:hover,
  .rsc-indicator-chip__btn:hover {
    opacity: 1;
  }
}
.vnsc-indicator-chip__value,
.rsc-indicator-chip__value {
  margin-left: 4px;
  font-variant-numeric: tabular-nums;
  color: var(--chip-color, inherit);
}

/* src/widget/styles/toolbar.css */
.vnsc-drawing-toolbar {
  position: relative;
  height: 100%;
  width: 42px;
  min-width: 42px;
  flex-shrink: 0;
  z-index: 40;
  background: var(--vnsc-bg-secondary);
  border-right: 1px solid var(--vnsc-border-subtle, var(--vnsc-border));
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 0;
  gap: 6px;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  transition:
    width 0.2s ease,
    padding 0.2s ease,
    border-right-width 0.2s ease;
}
.vnsc-drawing-toolbar.vnsc-drawing-toolbar--collapsed {
  width: 0;
  min-width: 0;
  padding: 0;
  border-right: none;
  overflow: hidden;
}
.vnsc-drawing-toolbar__expand-btn {
  transition:
    background-color var(--vnsc-transition-fast),
    color var(--vnsc-transition-fast),
    transform var(--vnsc-transition-fast);
}
.vnsc-drawing-toolbar__expand-btn:hover {
  background-color: var(--vnsc-bg-tertiary, #f1f5f9) !important;
  color: var(--vnsc-text-primary) !important;
  transform: scale(1.05);
}
.vnsc-drawing-toolbar::-webkit-scrollbar {
  display: none;
}
.vnsc-drawing-toolbar__group {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-bottom: 4px;
}
.vnsc-drawing-toolbar__group:not(:last-child) {
  border-bottom: 1px solid var(--vnsc-border);
  padding-bottom: 4px;
}
.vnsc-drawing-toolbar__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: var(--vnsc-radius-md, 4px);
  background: transparent;
  color: var(--vnsc-text-secondary);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);
}
.vnsc-drawing-toolbar__btn:hover {
  background: rgba(41, 98, 255, 0.08);
  color: var(--vnsc-text-primary);
}
.vnsc-drawing-toolbar__btn--active {
  background: var(--vnsc-accent-bg, rgba(41, 98, 255, 0.12));
  color: var(--vnsc-accent);
}
.vnsc-drawing-toolbar__btn--active:hover {
  background: var(--vnsc-accent-bg, rgba(41, 98, 255, 0.18));
}
.vnsc-drawing-toolbar__magnet {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: var(--vnsc-radius-md, 4px);
  background: transparent;
  color: var(--vnsc-text-secondary);
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);
}
.vnsc-drawing-toolbar__magnet:hover {
  background: rgba(41, 98, 255, 0.08);
}
.vnsc-tools-group-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.vnsc-tool-btn--group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
}
.vnsc-tools-chevron {
  font-size: 7px;
  line-height: 1;
  opacity: 0.6;
  pointer-events: none;
}
.vnsc-tools-flyout {
  position: fixed;
  z-index: var(--vnsc-z-maximum);
  background: var(--vnsc-bg-primary, #0a0e14);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: var(--vnsc-radius-md, 6px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  width: 220px;
  overflow: hidden;
}
.vnsc-drawing-toolbar__btn:hover .vnsc-tool-fav-star {
  opacity: 0.5 !important;
}
.vnsc-tool-fav-star:hover {
  opacity: 1 !important;
  color: var(--vnsc-accent, #2962ff) !important;
}
.vnsc-tools-flyout input::placeholder {
  color: var(--vnsc-text-secondary, #a0a0a0);
  opacity: 0.6;
}
.vnsc-tools-flyout input:focus {
  border-color: var(--vnsc-accent, #2962ff) !important;
}
.vnsc-drawing-toolbar-shell {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 10px;
  pointer-events: none;
  z-index: 60;
  transition: width 0.2s ease;
}
.vnsc-drawing-toolbar-shell:hover,
.vnsc-drawing-toolbar-shell:has(input:focus) {
  width: 42px;
  pointer-events: auto;
}
.vnsc-drawing-toolbar {
  position: absolute;
  left: -42px;
  top: 0;
  bottom: 0;
  width: 42px;
  min-width: 42px;
  pointer-events: auto;
  z-index: 3;
  transition:
    left 0.2s ease,
    box-shadow 0.2s ease,
    border-right-color 0.2s ease,
    visibility 0s linear 0.2s;
  border-right: 1px solid transparent;
  box-shadow: none;
  visibility: hidden;
}
.vnsc-drawing-toolbar-shell:hover .vnsc-drawing-toolbar,
.vnsc-drawing-toolbar:hover,
.vnsc-drawing-toolbar-shell:has(input:focus) .vnsc-drawing-toolbar,
.vnsc-drawing-toolbar:has(input:focus),
.vnsc-drawing-toolbar-shell:focus-within .vnsc-drawing-toolbar {
  left: 0;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);
  border-right-color: var(--vnsc-border-subtle, var(--vnsc-border));
  visibility: visible;
  transition:
    left 0.2s ease,
    box-shadow 0.2s ease,
    border-right-color 0.2s ease;
}
.vnsc-drawing-toolbar-handle {
  display: flex;
  position: absolute;
  top: 50%;
  left: 0;
  width: 10px;
  height: 44px;
  transform: translateY(-50%);
  align-items: center;
  justify-content: center;
  border-radius: 0 var(--vnsc-radius-xl, 8px) var(--vnsc-radius-xl, 8px) 0;
  border: 1px solid var(--vnsc-border);
  border-left: none;
  background:
    linear-gradient(
      180deg,
      color-mix(in srgb, var(--vnsc-bg-primary) 92%, var(--vnsc-accent) 8%),
      color-mix(in srgb, var(--vnsc-bg-secondary) 88%, var(--vnsc-accent) 12%));
  box-shadow: 6px 10px 22px rgba(15, 23, 42, 0.16);
  pointer-events: auto;
  opacity: 1;
  z-index: 2;
  transition:
    opacity 0.15s ease,
    transform 0.15s ease,
    box-shadow 0.15s ease;
}
.vnsc-drawing-toolbar-handle::before {
  content: "";
  width: 3px;
  height: 3px;
  border-radius: 999px;
  background: var(--vnsc-text-secondary);
  box-shadow: 0 -6px 0 var(--vnsc-text-secondary), 0 6px 0 var(--vnsc-text-secondary);
}
.vnsc-drawing-toolbar-shell--docked {
  width: 44px;
  pointer-events: auto;
}
.vnsc-drawing-toolbar-shell--docked .vnsc-drawing-toolbar {
  left: 0;
  visibility: visible;
  border-right: 1px solid var(--vnsc-border-subtle, var(--vnsc-border));
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
}
.vnsc-drawing-toolbar-shell--docked .vnsc-drawing-toolbar-handle {
  display: none;
}
.vnsc-ohlc-header {
  padding-left: 22px !important;
  transition: padding-left 0.2s ease !important;
}
.vnsc-container:has(.vnsc-drawing-toolbar-shell:hover) .vnsc-ohlc-header,
.vnsc-container:has(.vnsc-drawing-toolbar-shell:focus-within) .vnsc-ohlc-header {
  padding-left: 54px !important;
}
.vnsc-container:has(.vnsc-drawing-toolbar-shell--collapsed) .vnsc-ohlc-header {
  padding-left: 12px !important;
}
.vnsc-drawing-toolbar-shell.vnsc-drawing-toolbar-shell--collapsed {
  width: 0;
  pointer-events: none;
}
.vnsc-drawing-toolbar-shell.vnsc-drawing-toolbar-shell--collapsed .vnsc-drawing-toolbar-handle {
  display: none;
}
@media (max-width: 768px) {
  .vnsc-drawing-toolbar {
    width: 48px !important;
    min-width: 48px !important;
    gap: 6px !important;
    padding: 6px 0 !important;
  }
  .vnsc-drawing-toolbar__btn {
    width: 40px !important;
    height: 40px !important;
    font-size: 16px !important;
    border-radius: 6px !important;
  }
  .vnsc-drawing-toolbar__expand-btn {
    width: 44px !important;
    height: 44px !important;
    left: 12px !important;
    bottom: 20px !important;
    font-size: 18px !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.4) !important;
  }
}
.vnsc-drawing-toolbar__btn--star-active {
  color: #f59e0b !important;
  background: rgba(245, 158, 11, 0.12) !important;
}
.vnsc-drawing-toolbar__btn--star-active:hover {
  background: rgba(245, 158, 11, 0.22) !important;
}
.vnsc-floating-favorites-bar {
  position: fixed;
  z-index: var(--vnsc-z-popup, 20);
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background: var(--vnsc-bg-primary, #0a0e14);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: var(--vnsc-radius-md, 8px);
  padding: 4px 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.32);
  user-select: none;
  white-space: nowrap;
}
.vnsc-floating-favorites-grip {
  cursor: grab;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 28px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  opacity: 0.7;
  transition: opacity var(--vnsc-transition-fast, 0.15s), color var(--vnsc-transition-fast, 0.15s);
  user-select: none;
  touch-action: none;
  font-size: 12px;
  letter-spacing: 1px;
}
.vnsc-floating-favorites-grip:hover {
  opacity: 1;
  color: var(--vnsc-text-primary, #ffffff);
}
.vnsc-floating-favorites-grip:active {
  cursor: grabbing;
}
.vnsc-floating-favorites-divider {
  width: 1px;
  height: 18px;
  background: var(--vnsc-border-subtle, #2a2a2a);
  margin: 0 3px;
  flex-shrink: 0;
}
.vnsc-floating-favorites-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  border-radius: 4px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  cursor: pointer;
  transition: background var(--vnsc-transition-fast, 0.15s), color var(--vnsc-transition-fast, 0.15s);
  font-size: 13px;
  line-height: 1;
  padding: 0;
}
.vnsc-floating-favorites-close:hover {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

/* src/widget/styles/settings.css */
.vnsc-settings-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(2, 6, 23, 0.6);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  animation: vnsc-reveal 200ms ease-out;
}
.vnsc-settings-backdrop[data-chart-mode=light] {
  background: rgba(15, 23, 42, 0.35);
}
.vnsc-settings-backdrop[data-chart-mode=light] .vnsc-settings-modal {
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}
@keyframes vnsc-reveal {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.vnsc-settings-modal {
  background: var(--vnsc-bg-primary, #0a0e14);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: var(--vnsc-radius-xl, 8px);
  width: 520px;
  max-width: 100%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
  overflow: hidden;
}
.vnsc-settings-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  background:
    linear-gradient(
      180deg,
      var(--vnsc-bg-secondary, #111820),
      var(--vnsc-bg-primary, #0a0e14));
  flex-shrink: 0;
}
.vnsc-settings-modal__title {
  margin: 0;
  font-size: var(--vnsc-font-lg, 15px);
  font-weight: 700;
  color: var(--vnsc-text-primary, #e0e0e0);
  letter-spacing: -0.01em;
}
.vnsc-settings-modal__close {
  background: none;
  border: none;
  color: var(--vnsc-text-secondary, #a0a0a0);
  cursor: pointer;
  font-size: 22px;
  padding: 4px;
  line-height: 1;
  transition: color 120ms ease;
}
.vnsc-settings-modal__close:hover {
  color: var(--vnsc-text-primary, #e0e0e0);
}
.vnsc-settings-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  height: 50px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  overflow-x: auto;
  scrollbar-width: none;
  flex-shrink: 0;
}
.vnsc-settings-tabs::-webkit-scrollbar {
  display: none;
}
.vnsc-settings-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  line-height: 1;
  padding: 0 12px;
  box-sizing: border-box;
  border: none;
  border-radius: var(--vnsc-radius-md, 4px);
  background: transparent;
  color: var(--vnsc-text-secondary, #a0a0a0);
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 120ms ease, color 120ms ease;
}
.vnsc-settings-tab:hover {
  background: var(--vnsc-bg-tertiary, #1c2430);
  color: var(--vnsc-text-primary, #e0e0e0);
}
.vnsc-settings-tab--active {
  background: var(--vnsc-accent, #2962ff);
  color: #fff !important;
}
.vnsc-settings-body {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding: 16px;
  scrollbar-gutter: stable;
}
.vnsc-settings-body::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.vnsc-settings-body::-webkit-scrollbar-thumb {
  background: var(--vnsc-border, #2a2a2a);
  border-radius: 3px;
}
.vnsc-settings-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.vnsc-settings-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.vnsc-settings-panel__header--subtle {
  border-top: 1px solid var(--vnsc-border, #2a2a2a);
  margin-top: 12px;
  padding-top: 12px;
}
.vnsc-settings-kicker {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--vnsc-text-secondary, #a0a0a0);
}
.vnsc-settings-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}
.vnsc-settings-row--split {
  justify-content: space-between;
  align-items: center;
}
.vnsc-settings-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  font-size: 11px;
  font-weight: 600;
  color: var(--vnsc-text-secondary, #a0a0a0);
}
.vnsc-settings-field--compact {
  min-width: 120px;
}
.vnsc-settings-input,
.vnsc-settings-select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 4px;
  background: var(--vnsc-bg-secondary, #111820);
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: 12px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 120ms ease, background 120ms ease;
}
.vnsc-settings-input:focus,
.vnsc-settings-select:focus {
  border-color: var(--vnsc-accent, #2962ff);
  background: var(--vnsc-bg-tertiary, #1c2430);
}
.vnsc-settings-select {
  cursor: pointer;
}
.vnsc-settings-pane-list,
.vnsc-settings-series-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}
.vnsc-settings-series {
  padding: 10px 12px;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.vnsc-settings-series__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.vnsc-settings-series__title {
  font-size: 12px;
  font-weight: 700;
  color: var(--vnsc-text-primary, #e0e0e0);
}
.vnsc-settings-series__meta {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  margin-top: 2px;
}
.vnsc-settings-series__actions {
  display: flex;
  gap: 6px;
  align-items: center;
}
.vnsc-settings-pane__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}
.vnsc-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 3px;
  background: var(--vnsc-bg-primary, #0a0e14);
  color: var(--vnsc-text-secondary, #a0a0a0);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  font-size: 10px;
  font-weight: 500;
}
.vnsc-settings-note {
  font-size: 11px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  background: rgba(41, 98, 255, 0.08);
  border: 1px dashed rgba(41, 98, 255, 0.25);
  padding: 8px 12px;
  border-radius: 4px;
  margin: 6px 0;
  line-height: 1.4;
}
.vnsc-settings-empty {
  text-align: center;
  color: var(--vnsc-text-secondary, #a0a0a0);
  padding: 20px;
  font-size: 12px;
}
.vnsc-btn {
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-secondary, #111820);
  color: var(--vnsc-text-primary, #e0e0e0);
  cursor: pointer;
  transition: all 120ms ease;
  outline: none;
}
.vnsc-btn:hover:not(:disabled) {
  background: var(--vnsc-bg-tertiary, #1c2430);
  border-color: var(--vnsc-text-secondary, #a0a0a0);
}
.vnsc-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.vnsc-btn--accent {
  background: var(--vnsc-accent, #2962ff);
  color: #fff;
  border-color: transparent;
}
.vnsc-btn--accent:hover:not(:disabled) {
  background: #1565c0;
  opacity: 0.95;
}
.vnsc-btn--danger {
  background: rgba(244, 67, 54, 0.15);
  color: #ef5350;
  border-color: rgba(244, 67, 54, 0.3);
}
.vnsc-btn--danger:hover:not(:disabled) {
  background: #f44336;
  color: #fff;
  border-color: transparent;
}
.vnsc-settings-slider-shell {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}
.vnsc-settings-slider-readout {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: var(--vnsc-text-secondary, #a0a0a0);
}
.vnsc-settings-slider-readout__current {
  color: var(--vnsc-accent, #2962ff);
  font-weight: 700;
}
@media (max-width: 520px) {
  .vnsc-settings-backdrop {
    padding: 8px;
    align-items: flex-end;
  }
  .vnsc-settings-modal {
    width: 100%;
    max-height: 90vh;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    animation: vnsc-slide-up 240ms cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes vnsc-slide-up {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
  .vnsc-settings-modal__header {
    padding: 14px 16px;
  }
  .vnsc-settings-tabs {
    padding: 8px 16px;
    gap: 6px;
    height: 50px;
    flex-shrink: 0;
  }
  .vnsc-settings-body {
    padding: 14px;
  }
  .vnsc-btn,
  .vnsc-settings-input,
  .vnsc-settings-select {
    min-height: 44px;
    font-size: 13px;
  }
  .vnsc-settings-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .vnsc-settings-row > .vnsc-btn {
    margin-top: 0 !important;
  }
  .vnsc-settings-series__head {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .vnsc-settings-series__actions {
    justify-content: flex-end;
    width: 100%;
  }
  .vnsc-settings-series__actions > select,
  .vnsc-settings-series__actions > button {
    flex: 1;
    min-height: 38px;
    font-size: 12px;
  }
}

/* src/widget/styles/chart-splitter.css */
.vnsc-splitter,
.rsc-splitter {
  position: absolute;
  left: 0;
  right: 0;
  height: 18px;
  margin-top: -9px;
  cursor: row-resize;
  z-index: 12;
  pointer-events: auto;
  user-select: none;
  touch-action: none;
}
.vnsc-splitter::after,
.rsc-splitter::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 2px;
  background: transparent;
  transition: background 0.15s;
}
.vnsc-splitter:hover::after,
.vnsc-splitter--dragging::after,
.rsc-splitter:hover::after,
.rsc-splitter--dragging::after {
  background: var(--vnsc-accent, #2962ff);
}
.rsc-splitter__badge {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(20, 20, 28, 0.85);
  color: #fff;
  font: 11px/1 sans-serif;
  padding: 3px 8px;
  border-radius: 10px;
  pointer-events: none;
  white-space: nowrap;
}
.rsc-splitter:focus {
  outline: none;
}
.rsc-splitter:focus-visible {
  outline: none;
}
.rsc-splitter:focus-visible::after {
  background: var(--vnsc-accent, #2962ff);
}
@media (pointer: coarse) {
  .vnsc-splitter,
  .rsc-splitter {
    height: 24px;
    margin-top: -12px;
  }
}

/* src/widget/styles/header.css */
.vnsc-ohlc-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  background: var(--vnsc-bg-secondary);
  border-bottom: 1px solid var(--vnsc-border);
  font-family: inherit;
  font-size: var(--vnsc-font-md, 12px);
  color: var(--vnsc-text-primary);
  z-index: 30;
}
.vnsc-ohlc-header__symbol {
  font-size: var(--vnsc-font-lg, 14px);
  font-weight: 700;
}
.vnsc-ohlc-header__timeframe {
  background: var(--vnsc-accent, #2962ff);
  color: #fff;
  padding: 2px 6px;
  border-radius: var(--vnsc-radius-sm, 3px);
  font-size: var(--vnsc-font-sm, 11px);
  font-weight: 600;
}
.vnsc-ohlc-header__values {
  color: var(--vnsc-text-secondary);
  white-space: nowrap;
}
.vnsc-ohlc-header__volume {
  color: var(--vnsc-text-secondary);
}
.vnsc-ohlc-header__change {
  font-weight: 600;
}
.vnsc-ohlc-header__menu {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}
.vnsc-ohlc-menu-btn {
  background: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
}
.vnsc-ohlc-menu-btn:hover {
  color: var(--vnsc-text-primary, #e0e0e0);
  background: var(--vnsc-bg-tertiary, #1c2430);
  border-color: var(--vnsc-border, #2a2a2a);
}
.vnsc-ohlc-menu-btn--active {
  color: var(--vnsc-accent, #2962ff);
  background: var(--vnsc-bg-tertiary, #1c2430);
  border-color: var(--vnsc-accent, #2962ff);
}

/* src/widget/styles/footer.css */
.vnsc-timeframe-footer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 12px;
  background: var(--vnsc-bg-secondary);
  border-top: 1px solid var(--vnsc-border);
  z-index: 30;
  flex-wrap: wrap;
}
.vnsc-tf-chip,
.vnsc-range-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 8px;
  border: 1px solid transparent;
  border-radius: var(--vnsc-radius-md);
  cursor: pointer;
  font-size: var(--vnsc-font-sm);
  font-weight: 500;
  background: transparent;
  color: var(--vnsc-text-secondary);
  transition: color var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);
  font-family: inherit;
}
.vnsc-tf-chip:hover,
.vnsc-range-chip:hover {
  color: var(--vnsc-text-primary);
  border-color: rgba(255, 255, 255, 0.12);
}
.vnsc-tf-chip--active,
.vnsc-range-chip--active {
  color: var(--vnsc-text-primary);
  font-weight: 600;
  border-color: rgba(255, 255, 255, 0.18);
}
.vnsc-tf-chip--active:hover,
.vnsc-range-chip--active:hover {
  border-color: rgba(255, 255, 255, 0.25);
}
.vnsc-trademark {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.35);
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  margin-left: auto;
}
.vnsc-trademark:hover {
  color: rgba(255, 255, 255, 0.5);
}
.vnsc-trademark-icon {
  font-size: 11px;
  color: rgba(99, 102, 241, 0.5);
}
.vnsc-trademark-icon:hover {
  color: rgba(99, 102, 241, 0.7);
}

/* src/widget/styles/paper-trade.css */
.vnsc-paper-trade-panel {
  position: relative;
  height: 100%;
  flex-shrink: 0;
  width: 280px;
  background: var(--vnsc-bg-primary);
  border-left: 1px solid var(--vnsc-border);
  z-index: 50;
  display: flex;
  flex-direction: column;
  font-size: var(--vnsc-font-sm);
  color: var(--vnsc-text-primary);
  overflow: hidden;
}
[data-vnsc-bottom-panel=host] .vnsc-paper-trade-panel {
  width: 100%;
  border-left: none;
  background: transparent;
}
.vnsc-paper-trade-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid var(--vnsc-border);
  flex-shrink: 0;
}
.vnsc-paper-trade-panel__title {
  font-size: var(--vnsc-font-md);
  font-weight: 700;
}
.vnsc-paper-trade-panel__reset-btn {
  background: var(--vnsc-bg-tertiary);
  border: none;
  color: var(--vnsc-text-secondary);
  border-radius: var(--vnsc-radius-md);
  cursor: pointer;
  padding: 4px 8px;
  font-size: var(--vnsc-font-sm);
  font-weight: 600;
  transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);
}
.vnsc-paper-trade-panel__reset-btn:hover {
  background: var(--vnsc-border);
  color: var(--vnsc-text-primary);
}
.vnsc-paper-trade-panel__stats {
  padding: 8px 12px;
  border-bottom: 1px solid var(--vnsc-border);
  flex-shrink: 0;
}
.vnsc-paper-trade-panel__stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
}
.vnsc-paper-trade-panel__stat-label {
  font-size: var(--vnsc-font-xs);
  color: var(--vnsc-text-secondary);
}
.vnsc-paper-trade-panel__stat-value {
  font-weight: 700;
  font-size: var(--vnsc-font-lg);
}
.vnsc-paper-trade-panel__position {
  padding: 8px 12px;
  border-bottom: 1px solid var(--vnsc-border);
  flex-shrink: 0;
}
.vnsc-paper-trade-panel__position-title {
  font-weight: 700;
  margin-bottom: 4px;
}
.vnsc-paper-trade-panel__position-side {
  display: inline-block;
  padding: 2px 6px;
  border-radius: var(--vnsc-radius-sm);
  font-size: var(--vnsc-font-xs);
  font-weight: 700;
}
.vnsc-paper-trade-panel__position-side--long {
  background: var(--vnsc-up);
  color: #fff;
}
.vnsc-paper-trade-panel__position-side--short {
  background: var(--vnsc-down);
  color: #fff;
}
.vnsc-paper-trade-panel__position-entry {
  margin-top: 4px;
  color: var(--vnsc-text-secondary);
}
.vnsc-paper-trade-panel__position-empty {
  color: var(--vnsc-text-secondary);
}
.vnsc-paper-trade-panel__journal {
  flex: 1;
  overflow-y: auto;
  padding: 8px 12px;
}
.vnsc-paper-trade-panel__journal-title {
  font-weight: 700;
  margin-bottom: 4px;
}
.vnsc-paper-trade-panel__journal-empty {
  color: var(--vnsc-text-secondary);
  text-align: center;
  padding: 16px 0;
}
.vnsc-paper-trade-panel__journal-item {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 1px solid var(--vnsc-border);
}
.vnsc-paper-trade-panel__journal-item--positive .vnsc-paper-trade-panel__journal-side {
  color: var(--vnsc-up);
}
.vnsc-paper-trade-panel__journal-item--positive .vnsc-paper-trade-panel__journal-pnl {
  color: var(--vnsc-up);
}
.vnsc-paper-trade-panel__journal-item--negative .vnsc-paper-trade-panel__journal-side {
  color: var(--vnsc-down);
}
.vnsc-paper-trade-panel__journal-item--negative .vnsc-paper-trade-panel__journal-pnl {
  color: var(--vnsc-down);
}
.vnsc-paper-trade-panel__journal-side {
  font-size: var(--vnsc-font-xs);
  font-weight: 700;
}
.vnsc-paper-trade-panel__journal-pnl {
  font-weight: 600;
}

/* src/widget/styles/drawing.css */
.vnsc-drawing-dock__empty {
  padding: 16px;
  text-align: center;
  color: var(--vnsc-text-muted, #606060);
}
.vnsc-drawing-point-legend {
  padding: 8px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}
.vnsc-drawing-point-legend__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}
.vnsc-drawing-point-legend__item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px;
  border-radius: var(--vnsc-radius-sm, 3px);
  cursor: pointer;
  transition: background var(--vnsc-transition-fast);
}
.vnsc-drawing-point-legend__item:hover,
.vnsc-drawing-point-legend__item--active {
  background: var(--vnsc-bg-tertiary, #1a1a1a);
}
.vnsc-drawing-point-legend__index {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--vnsc-accent, #2962ff);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--vnsc-font-xs, 10px);
  font-weight: 700;
}
.vnsc-drawing-point-legend__label {
  font-size: var(--vnsc-font-sm, 11px);
  color: var(--vnsc-text-secondary, #a0a0a0);
}
.vnsc-drawing-storage-toolbar {
  display: flex;
  gap: 4px;
  padding: 4px 8px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}
.vnsc-drawing-storage-toolbar__button {
  padding: 4px 8px;
  border: none;
  border-radius: var(--vnsc-radius-sm, 3px);
  background: transparent;
  color: var(--vnsc-text-secondary, #a0a0a0);
  cursor: pointer;
  font-size: var(--vnsc-font-sm, 11px);
  transition: background var(--vnsc-transition-fast);
}
.vnsc-drawing-storage-toolbar__button:hover {
  background: var(--vnsc-bg-tertiary, #1a1a1a);
  color: var(--vnsc-text-primary, #e0e0e0);
}
.vnsc-paper-trade-panel {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 280px;
  background: var(--vnsc-bg-primary, #0a0e14);
  border-left: 1px solid var(--vnsc-border, #2a2a2a);
  z-index: 50;
  display: flex;
  flex-direction: column;
  font-size: var(--vnsc-font-sm, 11px);
  color: var(--vnsc-text-primary, #e0e0e0);
  overflow: hidden;
}
.vnsc-paper-trade-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}
.vnsc-paper-trade-panel__close-btn {
  appearance: none;
  border: none;
  background: transparent;
  color: var(--vnsc-text-secondary, #a0a0a0);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--vnsc-font-lg, 14px);
  cursor: pointer;
  padding: 0;
  transition: color var(--vnsc-transition-fast, 120ms);
}
.vnsc-paper-trade-panel__close-btn:hover {
  color: var(--vnsc-text-primary, #e0e0e0);
}
.vnsc-paper-trade-panel__stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}
.vnsc-paper-trade-panel__stat-label {
  font-size: var(--vnsc-font-xs, 10px);
  color: var(--vnsc-text-secondary, #a0a0a0);
}
.vnsc-paper-trade-panel__stat-value {
  font-weight: 700;
  font-size: var(--vnsc-font-md, 13px);
}
.vnsc-paper-trade-panel__position {
  padding: 8px 12px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}
.vnsc-paper-trade-panel__position-badge {
  padding: 2px 6px;
  border-radius: var(--vnsc-radius-sm, 3px);
  font-size: var(--vnsc-font-xs, 10px);
  font-weight: 700;
  color: #fff;
}
.vnsc-paper-trade-panel__position-badge--long {
  background: #0d6b2e;
}
.vnsc-paper-trade-panel__position-badge--short {
  background: #c0392b;
}
.vnsc-paper-trade-panel__journal {
  flex: 1;
  overflow-y: auto;
  padding: 8px 12px;
}
.vnsc-paper-trade-panel__journal-item {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}
.vnsc-paper-trade-panel__journal-item--positive .vnsc-paper-trade-panel__journal-pnl {
  color: #089981;
}
.vnsc-paper-trade-panel__journal-item--negative .vnsc-paper-trade-panel__journal-pnl {
  color: #f23645;
}
.vnsc-drawing-inspector,
.vnsc-drawing-list-panel {
  width: min(348px, calc(100vw - 32px));
  border-radius: var(--vnsc-radius-md, 4px);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-secondary, #111820);
  box-shadow: var(--vnsc-shadow-lg, 0 8px 32px rgba(0, 0, 0, 0.4));
  color: var(--vnsc-text-primary, #e0e0e0);
  padding: 14px;
  display: grid;
  gap: 14px;
  max-height: calc(100% - 32px);
  overflow: auto;
  overscroll-behavior: contain;
}
.vnsc-drawing-inspector--embedded,
.vnsc-drawing-list-panel--embedded {
  position: static;
  z-index: auto;
  width: auto;
  max-height: none;
  overflow: visible;
  padding: 0;
  border: none;
  background: transparent;
  box-shadow: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
.vnsc-drawing-inspector--embedded .vnsc-drawing-inspector__header,
.vnsc-drawing-list-panel--embedded .vnsc-drawing-list-panel__header {
  display: none;
}
.vnsc-drawing-inspector__header,
.vnsc-drawing-list-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.vnsc-drawing-inspector__title {
  display: grid;
  gap: 4px;
  min-width: 0;
}
.vnsc-drawing-inspector__title strong,
.vnsc-drawing-list-panel__header strong {
  font-size: 13px;
  font-weight: 700;
  color: var(--vnsc-text-primary, #e0e0e0);
  letter-spacing: 0.01em;
}
.vnsc-drawing-inspector__title span,
.vnsc-drawing-list-panel__header span {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--vnsc-text-muted, #606060);
}
.vnsc-drawing-inspector__icon,
.vnsc-drawing-list-panel__icon {
  appearance: none;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: transparent;
  color: var(--vnsc-text-secondary, #a0a0a0);
  width: 28px;
  height: 28px;
  border-radius: var(--vnsc-radius-sm, 3px);
  cursor: pointer;
  transition:
    background var(--vnsc-transition-fast),
    color var(--vnsc-transition-fast),
    border-color var(--vnsc-transition-fast);
}
.vnsc-drawing-inspector__icon:hover,
.vnsc-drawing-list-panel__icon:hover {
  background: var(--vnsc-bg-tertiary, #1a1a1a);
  border-color: var(--vnsc-border, #2a2a2a);
  color: var(--vnsc-text-primary, #e0e0e0);
}
.vnsc-drawing-inspector__swatches {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.vnsc-drawing-inspector__field {
  display: grid;
  gap: 8px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.vnsc-drawing-inspector__field label {
  display: grid;
  gap: 8px;
}
.vnsc-drawing-inspector__field input[type=color] {
  appearance: none;
  width: 100%;
  height: 36px;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: var(--vnsc-radius-sm, 3px);
  background: var(--vnsc-bg-tertiary, #1a1a1a);
  padding: 3px;
  cursor: pointer;
}
.vnsc-drawing-inspector__field input[type=range] {
  width: 100%;
  accent-color: var(--vnsc-accent, #2962ff);
}
.vnsc-drawing-inspector__field select {
  appearance: none;
  width: 100%;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: var(--vnsc-radius-sm, 3px);
  background: var(--vnsc-bg-tertiary, #1a1a1a);
  color: var(--vnsc-text-primary, #e0e0e0);
  padding: 8px 10px;
  font-size: 12px;
}
.vnsc-drawing-inspector__actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.vnsc-drawing-inspector__button {
  appearance: none;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: transparent;
  color: var(--vnsc-text-secondary, #a0a0a0);
  border-radius: var(--vnsc-radius-sm, 3px);
  padding: 8px 10px;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background var(--vnsc-transition-fast),
    border-color var(--vnsc-transition-fast),
    color var(--vnsc-transition-fast);
}
.vnsc-drawing-inspector__button:hover {
  background: var(--vnsc-bg-tertiary, #1a1a1a);
  border-color: var(--vnsc-border, #2a2a2a);
  color: var(--vnsc-text-primary, #e0e0e0);
}
.vnsc-drawing-inspector__button:disabled {
  opacity: 0.42;
  cursor: default;
  transform: none;
}
.vnsc-drawing-inspector__button--danger {
  grid-column: 1 / -1;
  border-color: rgba(239, 68, 68, 0.28);
  background: rgba(239, 68, 68, 0.1);
  color: #fecaca;
}
.vnsc-drawing-inspector__button--danger:hover {
  background: rgba(239, 68, 68, 0.18);
  border-color: rgba(239, 68, 68, 0.38);
  color: #fff1f2;
}
.vnsc-drawing-list-panel {
  display: flex;
  flex-direction: column;
  max-height: min(560px, calc(100vh - 160px));
  overflow: hidden;
  padding: 0;
  gap: 0;
}
.vnsc-drawing-list-panel--embedded {
  gap: 0;
  max-height: none;
  min-height: 0;
}
.vnsc-drawing-list-panel--embedded .vnsc-drawing-list-panel__items {
  padding: 0;
}
.vnsc-drawing-list-panel--embedded .vnsc-drawing-list-panel__empty {
  margin: 0;
}
.vnsc-drawing-list-panel__header {
  flex-shrink: 0;
  padding: 12px 14px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.vnsc-drawing-list-panel__count {
  background: var(--vnsc-bg-tertiary, #1a1a1a);
  padding: 2px 6px;
  border-radius: 999px;
  font-size: var(--vnsc-font-xs, 10px);
  font-weight: 700;
  color: var(--vnsc-text-secondary, #a0a0a0);
}
.vnsc-drawing-list-panel__search {
  padding: 8px 14px;
  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);
}
.vnsc-drawing-list-panel__search-input {
  width: 100%;
  padding: 6px 10px;
  border-radius: var(--vnsc-radius-sm, 3px);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-tertiary, #1a1a1a);
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: var(--vnsc-font-sm, 11px);
  outline: none;
}
.vnsc-drawing-list-panel__search-input:focus {
  border-color: var(--vnsc-accent, #2962ff);
}
.vnsc-drawing-list-panel__items {
  display: grid;
  gap: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  flex: 1 1 auto;
  min-height: 0;
  padding: 10px 14px 12px;
  scrollbar-width: thin;
  scrollbar-color: var(--vnsc-border, #2a2a2a) transparent;
}
.vnsc-drawing-list-panel__items::-webkit-scrollbar {
  width: 4px;
}
.vnsc-drawing-list-panel__items::-webkit-scrollbar-track {
  background: transparent;
}
.vnsc-drawing-list-panel__items::-webkit-scrollbar-thumb {
  background: var(--vnsc-border, #2a2a2a);
  border-radius: 4px;
}
.vnsc-drawing-list-panel__empty {
  margin: 10px 14px 12px;
  padding: 16px 14px;
  border-radius: var(--vnsc-radius-md, 4px);
  border: 1px dashed var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-tertiary, #1a1a1a);
  color: var(--vnsc-text-secondary, #a0a0a0);
  font-size: 13px;
  line-height: 1.5;
}
.vnsc-drawing-list-panel__group {
  display: grid;
  gap: 6px;
  margin-bottom: 8px;
}
.vnsc-drawing-list-panel__group-header {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 6px 8px;
  background: var(--vnsc-bg-tertiary, #1a1a1a);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: var(--vnsc-radius-sm, 3px);
  color: var(--vnsc-text-primary, #e0e0e0);
  font-size: var(--vnsc-font-sm, 11px);
  font-weight: 700;
  cursor: pointer;
  text-align: left;
}
.vnsc-drawing-list-panel__group-caret {
  font-size: 8px;
  color: var(--vnsc-text-secondary, #a0a0a0);
}
.vnsc-drawing-list-panel__group-name {
  flex: 1;
}
.vnsc-drawing-list-panel__group-count {
  background: rgba(255, 255, 255, 0.08);
  padding: 1px 5px;
  border-radius: 999px;
  font-size: var(--vnsc-font-xs, 10px);
}
.vnsc-drawing-list-panel__item {
  display: grid;
  gap: 10px;
  padding: 12px;
  border-radius: var(--vnsc-radius-md, 4px);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-tertiary, #1a1a1a);
  transition: border-color 120ms ease;
}
.vnsc-drawing-list-panel__item--selected {
  border-color: var(--vnsc-accent, #2962ff);
  box-shadow: 0 0 0 1px rgba(41, 98, 255, 0.1) inset;
}
.vnsc-drawing-list-panel__item--drag-over {
  border-color: var(--vnsc-accent, #2962ff);
  border-style: dashed;
}
.vnsc-drawing-list-panel__select {
  appearance: none;
  border: none;
  background: transparent;
  padding: 0;
  text-align: left;
  cursor: pointer;
  display: grid;
  gap: 4px;
  color: inherit;
}
.vnsc-drawing-list-panel__label {
  font-size: 13px;
  font-weight: 700;
  color: var(--vnsc-text-primary, #e0e0e0);
  letter-spacing: 0.01em;
}
.vnsc-drawing-list-panel__meta {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--vnsc-text-muted, #606060);
}
.vnsc-drawing-list-panel__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.vnsc-drawing-list-panel__badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 9px;
  border-radius: 999px;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  background: var(--vnsc-bg-secondary, #111820);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--vnsc-text-secondary, #a0a0a0);
}
.vnsc-drawing-list-panel__icon {
  width: auto;
  height: auto;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.vnsc-drawing-list-panel__icon--delete {
  color: #f23645;
}
.vnsc-long-tp-zone {
  fill: rgba(34, 197, 94, 0.16);
}
.vnsc-long-sl-zone {
  fill: rgba(239, 68, 68, 0.16);
}
.vnsc-short-tp-zone {
  fill: rgba(239, 68, 68, 0.16);
}
.vnsc-short-sl-zone {
  fill: rgba(34, 197, 94, 0.16);
}
.vnsc-rr-badge {
  font-family:
    "Segoe UI Variable Text",
    "Aptos",
    "Segoe UI",
    sans-serif;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  fill: #e2e8f0;
}
.vnsc-drawing-inspector__icon-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 6px;
  margin-top: 6px;
}
.vnsc-drawing-inspector__icon-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: var(--vnsc-radius-sm, 3px);
  background: var(--vnsc-bg-tertiary, #1a1a1a);
  font-size: 18px;
  cursor: pointer;
  user-select: none;
  transition: background var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);
}
.vnsc-drawing-inspector__icon-cell:hover {
  background: var(--vnsc-bg-secondary, #222222);
  border-color: var(--vnsc-accent, #2962ff);
}
.vnsc-drawing-inspector__icon-cell--selected {
  background: var(--vnsc-bg-secondary, #222222);
  border-color: var(--vnsc-accent, #2962ff);
  box-shadow: 0 0 0 1px var(--vnsc-accent, #2962ff);
}

/* src/widget/styles/overlays.css */
.vnsc-tape-panel {
  position: relative;
  height: 100%;
  flex-shrink: 0;
  width: 240px;
  z-index: 51;
  background: var(--vnsc-bg-primary);
  border-left: 1px solid var(--vnsc-border);
  display: flex;
  flex-direction: column;
  font-size: var(--vnsc-font-sm);
  color: var(--vnsc-text-primary);
  overflow: hidden;
}
.vnsc-tape-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px 5px;
  border-bottom: 1px solid var(--vnsc-border);
  background: var(--vnsc-bg-secondary);
  flex-shrink: 0;
}
.vnsc-tape-panel__filter {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 8px;
  border-bottom: 1px solid var(--vnsc-border);
  flex-shrink: 0;
}
.vnsc-tape-panel__columns {
  display: grid;
  grid-template-columns: 52px 70px 52px 44px 22px;
  padding: 2px 4px;
  color: var(--vnsc-text-muted);
  font-size: var(--vnsc-font-xs);
  border-bottom: 1px solid var(--vnsc-border);
  flex-shrink: 0;
}
.vnsc-tape-panel__list {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
.vnsc-tape-panel__row {
  display: grid;
  grid-template-columns: 52px 70px 52px 44px 22px;
  height: 22px;
  align-items: center;
  padding: 0 4px;
  border-bottom: 1px solid var(--vnsc-border);
}
.vnsc-tape-panel__row--whale {
  background: var(--vnsc-bg-tertiary);
  border-bottom-color: var(--vnsc-accent);
}
.vnsc-tape-panel__footer {
  padding: 3px 8px;
  border-top: 1px solid var(--vnsc-border);
  color: var(--vnsc-text-muted);
  font-size: var(--vnsc-font-xs);
  flex-shrink: 0;
}
.vnsc-advisory-panel {
  position: relative;
  height: 100%;
  flex-shrink: 0;
  width: 260px;
  z-index: 50;
  background: var(--vnsc-bg-primary);
  border-left: 1px solid var(--vnsc-border);
  display: flex;
  flex-direction: column;
  font-size: var(--vnsc-font-md);
  color: var(--vnsc-text-primary);
  overflow: hidden;
}
.vnsc-advisory-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px 8px;
  border-bottom: 1px solid var(--vnsc-border);
  background: var(--vnsc-bg-secondary);
}
.vnsc-advisory-panel__body {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}
.vnsc-advisory-panel__decision {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.vnsc-advisory-panel__decision-badge {
  flex: 1;
  padding: 8px 12px;
  border-radius: var(--vnsc-radius-lg);
  background: var(--vnsc-text-secondary);
  color: var(--vnsc-bg-primary);
  font-weight: 700;
  font-size: var(--vnsc-font-lg);
  text-align: center;
  letter-spacing: 0.5px;
}
.vnsc-advisory-panel__confidence {
  text-align: center;
}
.vnsc-advisory-panel__confidence-label {
  color: var(--vnsc-text-muted);
  font-size: var(--vnsc-font-xs);
}
.vnsc-advisory-panel__confidence-value {
  font-weight: 700;
  font-size: var(--vnsc-font-md);
}
.vnsc-advisory-panel__agents {
  margin-bottom: 8px;
}
.vnsc-advisory-panel__agent-row {
  border-bottom: 1px solid var(--vnsc-border);
  padding-bottom: 8px;
  margin-bottom: 8px;
}
.vnsc-advisory-panel__agent-header {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}
.vnsc-advisory-panel__agent-name {
  flex: 1;
  font-size: var(--vnsc-font-md);
  color: var(--vnsc-text-primary);
  font-weight: 500;
}
.vnsc-advisory-panel__agent-weight {
  color: var(--vnsc-text-muted);
  font-size: var(--vnsc-font-sm);
  margin-left: 4px;
}
.vnsc-advisory-panel__agent-signal {
  font-size: var(--vnsc-font-xs);
  font-weight: 700;
  padding: 2px 6px;
  border-radius: var(--vnsc-radius-md);
  background: var(--vnsc-text-secondary);
  color: var(--vnsc-bg-primary);
  letter-spacing: 0.5px;
}
.vnsc-advisory-panel__agent-chevron {
  color: var(--vnsc-text-muted);
  font-size: var(--vnsc-font-xs);
}
.vnsc-advisory-panel__agent-bar {
  height: 4px;
  background: var(--vnsc-border);
  border-radius: 2px;
  margin-top: 6px;
  overflow: hidden;
}
.vnsc-advisory-panel__agent-bar-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.3s ease;
}
.vnsc-advisory-panel__agent-explanation {
  margin-top: 8px;
  font-size: var(--vnsc-font-sm);
  color: var(--vnsc-text-secondary);
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}
.vnsc-advisory-panel__skeleton {
  height: 40px;
  background: var(--vnsc-bg-tertiary);
  border-radius: var(--vnsc-radius-md);
  margin-bottom: 8px;
  animation: pulse 1.2s ease-in-out infinite;
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* src/widget/styles/replay.css */

/* src/widget/styles/floating-chart-bar.css */
.rsc-engine-surface .vnsc-floating-bar {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
@media (hover: hover) {
  .rsc-engine-surface:not(:hover) .vnsc-floating-bar {
    opacity: 0;
    pointer-events: none;
    transform: translateX(-50%) translateY(4px);
  }
}
.rsc-engine-surface:focus-within .vnsc-floating-bar {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(-50%) translateY(0);
}

/* src/widget/styles/widget.css */
[data-chart-mode=light] .MultiChartsFooter_syncBtn {
  background: var(--vnsc-bg-hover, rgba(0, 0, 0, 0.03));
  border-color: var(--vnsc-border, rgba(0, 0, 0, 0.08));
  color: var(--vnsc-text-primary, #1a1a1a);
}
[data-chart-mode=light] .MultiChartsFooter_syncBtn:hover {
  background: var(--vnsc-bg-active, rgba(0, 0, 0, 0.06));
  border-color: var(--vnsc-border-hover, rgba(0, 0, 0, 0.12));
  color: var(--vnsc-text-primary, #1a1a1a);
}
[data-chart-mode=light] .MultiChartsFooter_syncBtnActive {
  color: var(--vnsc-text-on-primary, #ffffff);
  background: var(--vnsc-accent-subtle, rgba(99, 102, 241, 0.2));
  border-color: var(--vnsc-accent, #6366f1);
}
[data-chart-mode=dark] .MultiChartsFooter_syncBtn {
  padding: 4px 10px;
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));
  color: var(--vnsc-text-secondary, #787b86);
  cursor: pointer;
  font-size: var(--vnsc-font-size-2xs, 10px);
  font-weight: 500;
  transition: all 0.15s ease;
}
[data-chart-mode=dark] .MultiChartsFooter_syncBtn:hover {
  color: var(--vnsc-text-primary, #d1d4dc);
  background: var(--vnsc-bg-active, rgba(255, 255, 255, 0.08));
  border-color: var(--vnsc-border-hover, rgba(255, 255, 255, 0.16));
}
[data-chart-mode=dark] .MultiChartsFooter_syncBtnActive {
  color: var(--vnsc-text-on-primary, #ffffff);
  background: var(--vnsc-accent-subtle, rgba(99, 102, 241, 0.2));
  border-color: var(--vnsc-accent, #6366f1);
  font-weight: 600;
  box-shadow: 0 0 10px rgba(99, 102, 241, 0.15);
}
.vnsc-root {
  box-sizing: border-box;
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.vnsc-root input,
.vnsc-root select,
.vnsc-root textarea {
  user-select: text;
  -webkit-user-select: text;
  -ms-user-select: text;
}
.vnsc-root > *,
.vnsc-root > *::before,
.vnsc-root > *::after {
  box-sizing: border-box;
}
.vnsc-root .vnsc-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: var(--vnsc-radius-md);
  cursor: pointer;
  font-family: inherit;
  font-weight: 600;
  transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);
}
.vnsc-root .vnsc-btn:hover {
  background: var(--vnsc-accent-hover);
  color: #fff;
}
.vnsc-root .vnsc-btn:active {
  transform: scale(0.97);
}
.vnsc-root .vnsc-btn:focus-visible {
  outline: var(--vnsc-focus-ring);
  outline-offset: var(--vnsc-focus-ring-offset);
}
.vnsc-root .vnsc-chip {
  padding: 3px 8px;
  border: 1px solid transparent;
  border-radius: var(--vnsc-radius-md);
  cursor: pointer;
  font-size: var(--vnsc-font-sm);
  font-weight: 500;
  background: transparent;
  color: var(--vnsc-text-secondary);
  transition: color var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);
}
.vnsc-root .vnsc-chip:hover {
  color: var(--vnsc-text-primary);
  border-color: rgba(255, 255, 255, 0.12);
}
.vnsc-root .vnsc-chip--active {
  color: var(--vnsc-text-primary);
  font-weight: 600;
  border-color: rgba(255, 255, 255, 0.18);
}
.vnsc-root .vnsc-chip--active:hover {
  border-color: rgba(255, 255, 255, 0.25);
}
.vnsc-root .vnsc-sep {
  width: 1px;
  height: 16px;
  background: var(--vnsc-border);
}
.vnsc-root ::-webkit-scrollbar {
  width: 6px;
}
.vnsc-root ::-webkit-scrollbar-track {
  background: transparent;
}
.vnsc-root ::-webkit-scrollbar-thumb {
  background: var(--vnsc-border);
  border-radius: var(--vnsc-radius-sm);
}
.vnsc-root ::-webkit-scrollbar-thumb:hover {
  background: var(--vnsc-text-muted);
}
.vnsc-root,
.vnsc-root input,
.vnsc-root select,
.vnsc-root textarea,
.vnsc-root button {
  font-family: "Inter", var(--gc-font, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif) !important;
}
.vnsc-root .vnsc-sidebar-splitter {
  position: relative;
  width: 4px;
  height: 100%;
  cursor: col-resize;
  z-index: 49;
  background: transparent;
  transition: background var(--vnsc-transition-fast);
}
.vnsc-root .vnsc-sidebar-splitter:hover {
  background: var(--vnsc-accent, #2962ff) !important;
}
.vnsc-root .vnsc-sidebar-right {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--vnsc-bg-secondary);
  border-left: 1px solid var(--vnsc-border);
  position: relative;
  z-index: 48;
  min-width: 150px;
  overflow-y: auto;
}
.vnsc-root .vnsc-sidebar-right .vnsc-drawing-dock,
.vnsc-root .vnsc-sidebar-right .vnsc-paper-trade-panel,
.vnsc-root .vnsc-sidebar-right .vnsc-advisory-panel,
.vnsc-root .vnsc-sidebar-right .vnsc-tape-panel {
  position: relative !important;
  top: auto !important;
  bottom: auto !important;
  right: auto !important;
  left: auto !important;
  width: 100% !important;
  height: auto !important;
  flex: 1 1 0% !important;
  min-height: 140px !important;
  border-left: none !important;
  border-right: none !important;
  z-index: auto !important;
  background: transparent !important;
}
.vnsc-root .vnsc-sidebar-right > div:not(:last-child) {
  border-bottom: 1px solid var(--vnsc-border) !important;
}
@keyframes vnsc-spin {
  to {
    transform: rotate(360deg);
  }
}
.vnsc-root .vnsc-spinner {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-top-color: transparent;
  animation: vnsc-spin 1s linear infinite;
}
.vnsc-root:fullscreen {
  background-color: var(--vnsc-bg-primary, #0a0e14) !important;
  width: 100vw !important;
  height: 100vh !important;
  padding: 0 !important;
}
.vnsc-root .vnsc-locked-feature {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));
  border-radius: 6px;
  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));
  color: var(--vnsc-text-primary, #d1d4dc);
  font: inherit;
  font-size: 12px;
  line-height: 1.35;
  cursor: pointer;
  text-align: left;
}
.vnsc-root .vnsc-locked-feature:hover {
  background: var(--vnsc-bg-active, rgba(255, 255, 255, 0.08));
  border-color: var(--vnsc-border-hover, rgba(255, 255, 255, 0.12));
}
.vnsc-root .vnsc-locked-feature:focus-visible {
  outline: 2px solid var(--vnsc-focus-ring, var(--vnsc-accent, #6366f1));
  outline-offset: 2px;
}
.vnsc-root .vnsc-locked-feature__icon {
  font-size: 12px;
  line-height: 1;
}
.vnsc-root .vnsc-locked-feature__label {
  white-space: nowrap;
}
.vnsc-root .vnsc-locked-feature__plan {
  color: var(--vnsc-text-secondary, #787b86);
  white-space: nowrap;
}
.vnsc-root .vnsc-locked-feature__price {
  color: var(--vnsc-accent, #6366f1);
  font-weight: 600;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/injected.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,mDAAmD;EACnD,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;;2BAGyB;AAC3B;AACA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,2CAA2C;EAC3C,kCAAkC;AACpC;AACA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;AACA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;AACA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;AACA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mDAAmD;EACnD,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,qBAAqB;AACvB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,gDAAgD;EAClD;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,6CAA6C;EAC7C,6CAA6C;EAC7C,yCAAyC;EACzC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,8FAA8F;EAC9F,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,oDAAoD;EACpD,2CAA2C;EAC3C,wEAAwE;AAC1E;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,yDAAyD;AAC3D;AACA;EACE,kDAAkD;EAClD,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,oDAAoD;EACpD,2CAA2C;AAC7C;AACA;EACE,OAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yDAAyD;EACzD,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,kDAAkD;AACpD;AACA;EACE,kCAAkC;EAClC,gDAAgD;AAClD;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB;;;;;;;;;;;sBAWoB;EACpB,YAAY;EACZ,8BAA8B;EAC9B,+CAA+C;EAC/C,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,yBAAyB;IACzB,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,8DAA8D;EAC9D,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;EACf,eAAe;AACjB;AACA;EACE,uCAAuC;AACzC;AACA;;EAEE,gEAAgE;EAChE,sCAAsC;EACtC,eAAe;AACjB;AACA;EACE,WAAW;EACX,gEAAgE;EAChE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB;;;;;qBAKmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6CAA6C;EAC7C,6CAA6C;EAC7C,kBAAkB;EAClB,yCAAyC;EACzC;;;;cAIY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,UAAU;EACV,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;;;;;;cAMY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;;;;;;cAMY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB;;;;;;aAMW;EACX,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yDAAyD;EACzD,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,8DAA8D;EAC9D,0FAA0F;EAC1F,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;AAC5D;AACA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,iDAAiD;EACjD,6CAA6C;EAC7C,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE;;IAEE,cAAc;IACd,cAAc;EAChB;EACA;IACE,eAAe;IACf,SAAS;IACT,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,+CAA+C;EAC/C,YAAY;EACZ,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,wCAAwC;EACxC,uGAAuG;AACzG;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,aAAa;AACf;AACA;EACE,OAAO;EACP,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd;;;qBAGmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,gCAAgC;IAChC,+CAA+C;EACjD;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,yCAAyC;IACzC,mDAAmD;IACnD,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;EACd;AACF;AACA;EACE,YAAY;EACZ,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;;;EAGE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,OAAO;EACP,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;AACA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,wDAAwD;AAC1D;AACA;EACE,+CAA+C;AACjD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,eAAe;EACf,8DAA8D;AAChE;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,kDAAkD;AACpD;AACA;EACE,sCAAsC;EACtC,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;;EAEE,aAAa;AACf;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;;;;;;IAME,gBAAgB;EAClB;AACF;AACA;EACE;;;;IAIE,wBAAwB;EAC1B;EACA;IACE,iCAAiC;IACjC,0BAA0B;IAC1B,+CAA+C;EACjD;EACA;IACE,mBAAmB;IACnB,iCAAiC;EACnC;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,wBAAwB;IACxB,sBAAsB;IACtB,4BAA4B;IAC5B,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,6CAA6C;IAC7C;;;;;gBAKY;IACZ;;;eAGW;EACb;AACF;AACA;EACE;;IAEE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6CAA6C;EAC7C,oDAAoD;EACpD,yCAAyC;EACzC,eAAe;EACf,wCAAwC;EACxC,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;EAEE,qCAAqC;EACrC,wCAAwC;EACxC,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,0CAA0C;EAC1C,iCAAiC;AACnC;AACA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,yCAAyC;AAC3C;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;EACd,0CAA0C;EAC1C,iEAAiE;AACnE;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yDAAyD;AAC3D;AACA;EACE,2CAA2C;EAC3C,+BAA+B;AACjC;AACA;EACE,6CAA6C;EAC7C,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE;;;;cAIY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE;;;;cAIY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,mDAAmD;EACnD,+DAA+D;EAC/D,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;;EAEE,iEAAiE;EACjE,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6CAA6C;EAC7C,6CAA6C;EAC7C,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,YAAY;EACZ,yCAAyC;EACzC,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE;IACE,gBAAgB;IAChB,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,OAAO;EACT;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kCAAkC;EAClC,wCAAwC;EACxC,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,4DAA4D;EAC5D,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,OAAO;EACP,aAAa;AACf;AACA;EACE,YAAY;EACZ,2DAA2D;EAC3D,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,4DAA4D;AAC9D;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,4BAA4B;EAC5B,QAAQ;AACV;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,4CAA4C;EAC5C,8CAA8C;AAChD;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,OAAO;EACP,yCAAyC;EACzC,6CAA6C;EAC7C,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,oDAAoD;AACtD;AACA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,mDAAmD;EACnD,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,+CAA+C;AACjD;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mDAAmD;EACnD,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,+CAA+C;EAC/C,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mDAAmD;EACnD,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,cAAc;EACd,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,cAAc;EACd,cAAc;AAChB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,WAAW;EACX,kCAAkC;EAClC,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC,mFAAmF;EACnF,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,0DAA0D;AAC5D;AACA;;;EAGE,wBAAwB;EACxB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE;IACE,OAAO;IACP,QAAQ;IACR,SAAS;IACT,SAAS;IACT,WAAW;IACX,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,kDAAkD;EAClD,6CAA6C;EAC7C,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;AACF;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;AACf;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,4DAA4D;EAC5D,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,2DAA2D;EAC3D,wCAAwC;AAC1C;AACA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,0DAA0D;EAC1D,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,2DAA2D;EAC3D,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,qDAAqD;EACrD,oBAAoB;AACtB;AACA;EACE,6DAA6D;EAC7D,kCAAkC;AACpC;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iDAAiD;IACjD,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,4DAA4D;AAC9D;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mDAAmD;AACrD;AACA;EACE,kDAAkD;AACpD;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAyD;EACzD,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,kCAAkC;EAClC,wCAAwC;EACxC,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,4DAA4D;EAC5D,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,mDAAmD;EACnD,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kDAAkD;EAClD,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,uCAAuC;EACvC,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;EAClB,qDAAqD;AACvD;AACA;EACE,uCAAuC;EACvC,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,qDAAqD;EACrD,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,4DAA4D;EAC5D,uCAAuC;EACvC,6CAA6C;EAC7C,gBAAgB;EAChB,MAAM;AACR;AACA;EACE,YAAY;EACZ,4DAA4D;AAC9D;AACA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,iBAAiB;AACnB;AACA;EACE,yCAAyC;EACzC,iBAAiB;AACnB;AACA;EACE,yCAAyC;EACzC,iBAAiB;AACnB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;IACZ,QAAQ;EACV;EACA;IACE,qCAAqC;EACvC;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,+CAA+C;EAC/C,wCAAwC;EACxC,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,0DAA0D;AAC5D;AACA;EACE,0CAA0C;EAC1C,aAAa;AACf;AACA;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,8EAA8E;EAC9E,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,mDAAmD;AACrD;AACA;;EAEE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,6CAA6C;EAC7C,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,0EAA0E;EAC1E,gCAAgC;AAClC;AACA;EACE,uEAAuE;EACvE,6BAA6B;AAC/B;AACA;EACE,0EAA0E;EAC1E,gCAAgC;AAClC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;EACpC,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4EAA4E;EAC5E,gCAAgC;AAClC;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,yEAAyE;EACzE,6BAA6B;AAC/B;AACA;EACE,uEAAuE;AACzE;AACA;EACE,4EAA4E;EAC5E,gCAAgC;AAClC;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gFAAgF;EAChF,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,gBAAgB;EAChB,gFAAgF;EAChF,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,SAAS;EACT,YAAY;EACZ,iDAAiD;AACnD;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,OAAO;IACP,QAAQ;IACR,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,0DAA0D;EAC1D,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,6CAA6C;EAC7C,mBAAmB;EACnB,yCAAyC;EACzC,8EAA8E;AAChF;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,yCAAyC;EACzC,oCAAoC;AACtC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,mDAAmD;EACnD,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,mCAAmC;EACnC,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mDAAmD;EACnD,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,gBAAgB;EAChB,iCAAiC;EACjC,oCAAoC;EACpC,mDAAmD;EACnD,cAAc;AAChB;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,mDAAmD;AACrD;AACA;EACE,0EAA0E;EAC1E,uFAAuF;AACzF;AACA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,0EAA0E;EAC1E,kCAAkC;AACpC;AACA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;AACA;EACE,2EAA2E;EAC3E,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,iCAAiC;EACjC,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,SAAS;IACT,QAAQ;IACR,iBAAiB;IACjB,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iDAAiD;EACjD,mEAAmE;EACnE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qHAAqH;EACrH,mCAAmC;EACnC,kCAAkC;EAClC,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB;;;yBAGuB;AACzB;AACA;EACE,wCAAwC;EACxC,qEAAqE;EACrE,2DAA2D;AAC7D;AACA;EACE,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;EAChB,gDAAgD;EAChD,gBAAgB;AAClB;AACA;EACE,8CAA8C;EAC9C,WAAW;EACX,+CAA+C;AACjD;AACA;EACE,UAAU;EACV,YAAY;EACZ,yDAAyD;AAC3D;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB;;;yBAGuB;AACzB;AACA;EACE,wCAAwC;EACxC,qEAAqE;EACrE,2DAA2D;AAC7D;AACA;EACE,8CAA8C;EAC9C,WAAW;EACX,gBAAgB;EAChB,gDAAgD;EAChD,gBAAgB;AAClB;AACA;EACE,8CAA8C;EAC9C,WAAW;EACX,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,+DAA+D;EAC/D,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;AACpC;AACA;EACE,wCAAwC;EACxC,2DAA2D;AAC7D;AACA;EACE,8CAA8C;EAC9C,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,+DAA+D;EAC/D,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,0CAA0C;EAC1C,6CAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,wCAAwC;EACxC,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,0CAA0C;EAC1C,UAAU;AACZ;AACA;EACE,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,UAAU;AACZ;AACA;EACE;IACE,gBAAgB;IAChB,QAAQ;EACV;EACA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,2CAA2C;EAC3C,0EAA0E;EAC1E,eAAe;EACf,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,UAAU;AACZ;AACA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,0EAA0E;EAC1E,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,aAAa;AACf;AACA;EACE,qDAAqD;EACrD,oBAAoB;EACpB,2DAA2D;AAC7D;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;AACT;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mDAAmD;AACrD;AACA;EACE,kDAAkD;AACpD;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;EAC3C,uEAAuE;AACzE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;;EAEE,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uEAAuE;AACzE;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;EACA;AACF;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,oCAAoC;EACpC,oDAAoD;EACpD,4BAA4B;EAC5B,kCAAkC;EAClC,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,mCAAmC;EACnC,6BAA6B;EAC7B,mCAAmC;EACnC,2BAA2B;EAC3B,iCAAiC;EACjC,0BAA0B;EAC1B,iCAAiC;EACjC,0BAA0B;EAC1B,8CAA8C;EAC9C,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,yCAAyC;EACzC,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,wCAAwC;EACxC,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,qCAAqC;EACrC,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,kCAAkC;EAClC,kCAAkC;EAClC,8BAA8B;EAC9B,+CAA+C;EAC/C,uCAAuC;EACvC,sCAAsC;EACtC,6BAA6B;EAC7B,4CAA4C;EAC5C,4CAA4C;EAC5C,oDAAoD;EACpD,+BAA+B;EAC/B,8CAA8C;EAC9C,oBAAoB;EACpB,oBAAoB;EACpB,uCAAuC;EACvC,mDAAmD;EACnD,6BAA6B;EAC7B,yCAAyC;EACzC,oCAAoC;EACpC,sCAAsC;EACtC,iDAAiD;EACjD,kDAAkD;EAClD,oDAAoD;EACpD,oDAAoD;EACpD,qCAAqC;EACrC,mCAAmC;EACnC,qCAAqC;EACrC,sCAAsC;EACtC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,+BAA+B;EAC/B,qCAAqC;EACrC,oCAAoC;EACpC,6CAA6C;EAC7C,oDAAoD;EACpD,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,iDAAiD;EACjD,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,4CAA4C;EAC5C,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,oCAAoC;EACpC,qCAAqC;EACrC,2CAA2C;EAC3C,yCAAyC;EACzC,oBAAoB;EACpB,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,yCAAyC;EACzC,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;EAC5B,kCAAkC;EAClC,kCAAkC;EAClC,8BAA8B;EAC9B,yCAAyC;EACzC,4CAA4C;EAC5C,oDAAoD;EACpD,+BAA+B;EAC/B,+CAA+C;EAC/C,mCAAmC;EACnC,+BAA+B;EAC/B,qCAAqC;EACrC,oDAAoD;EACpD,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,8CAA8C;EAC9C,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,uCAAuC;EACvC,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,yCAAyC;EACzC,4CAA4C;EAC5C,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,+CAA+C;EAC/C,4CAA4C;EAC5C,oDAAoD;EACpD,+BAA+B;EAC/B,gDAAgD;EAChD,8CAA8C;AAChD;AACA;EACE,0BAA0B;EAC1B,6CAA6C;EAC7C,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,uCAAuC;EACvC,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,wCAAwC;EACxC,yCAAyC;EACzC,2CAA2C;EAC3C,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,8CAA8C;EAC9C,4CAA4C;EAC5C,oDAAoD;EACpD,+BAA+B;EAC/B,+CAA+C;EAC/C,6BAA6B;EAC7B,6BAA6B;EAC7B,6CAA6C;AAC/C;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,gDAAgD;EAChD,6BAA6B;EAC7B,6BAA6B;EAC7B,8CAA8C;AAChD;AACA;EACE,0BAA0B;EAC1B,iDAAiD;EACjD,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,4CAA4C;EAC5C,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,yCAAyC;EACzC,4CAA4C;EAC5C,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,8CAA8C;EAC9C,4CAA4C;EAC5C,oDAAoD;EACpD,+BAA+B;EAC/B,gDAAgD;EAChD,8CAA8C;AAChD;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,sCAAsC;EACtC,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,0CAA0C;EAC1C,0CAA0C;EAC1C,6CAA6C;EAC7C,yCAAyC;EACzC,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,4BAA4B;EAC5B,+CAA+C;EAC/C,6BAA6B;EAC7B,mCAAmC;EACnC,oCAAoC;EACpC,4BAA4B;EAC5B,kCAAkC;EAClC,6BAA6B;EAC7B,6CAA6C;EAC7C,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,4CAA4C;EAC5C,mDAAmD;EACnD,+BAA+B;EAC/B,+CAA+C;EAC/C,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,mCAAmC;EACnC,6BAA6B;EAC7B,mCAAmC;EACnC,2BAA2B;EAC3B,iCAAiC;EACjC,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,oDAAoD;EACpD,6BAA6B;AAC/B;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,4CAA4C;AAC5C;EACE;;;;;;;;cAQY;EACZ;;;;;aAKW;EACX;;;;;;cAMY;EACZ,mDAAmD;EACnD,gDAAgD;EAChD,8CAA8C;EAC9C,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;EACxC,4CAA4C;EAC5C,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;EAC5B,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B;EAC3B,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;EAC5B,oCAAoC;EACpC,+BAA+B;EAC/B,kCAAkC;EAClC,mCAAmC;EACnC,mCAAmC;EACnC,sCAAsC;EACtC,oCAAoC;EACpC,qCAAqC;EACrC,+GAA+G;EAC/G,oHAAoH;EACpH,kHAAkH;EAClH,uHAAuH;EACvH,oHAAoH;EACpH,+GAA+G;EAC/G,4GAA4G;EAC5G,6GAA6G;EAC7G,6GAA6G;EAC7G,oHAAoH;EACpH,qHAAqH;EACrH,sHAAsH;EACtH,qHAAqH;AACvH;;AAEA,yCAAyC;AACzC;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,6EAA6E;EAC7E,uFAAuF;EACvF,yFAAyF;EACzF,2FAA2F;EAC3F,wDAAwD;EACxD,wDAAwD;EACxD,yDAAyD;EACzD,6DAA6D;EAC7D,wDAAwD;EACxD,sDAAsD;EACtD,yDAAyD;EACzD,sDAAsD;EACtD,2DAA2D;EAC3D,6DAA6D;EAC7D,2CAA2C;EAC3C,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;EAC1C,8CAA8C;EAC9C,4CAA4C;EAC5C,4CAA4C;EAC5C,8CAA8C;EAC9C,8CAA8C;EAC9C,+CAA+C;EAC/C,kDAAkD;EAClD,mDAAmD;EACnD,4BAA4B;EAC5B,sDAAsD;AACxD;AACA;EACE,+CAA+C;EAC/C,8EAA8E;EAC9E,wFAAwF;EACxF,0FAA0F;EAC1F,4FAA4F;EAC5F,wDAAwD;EACxD,wDAAwD;EACxD,qDAAqD;EACrD,2DAA2D;EAC3D,6DAA6D;EAC7D,mDAAmD;EACnD,mDAAmD;AACrD;;AAEA,wCAAwC;AACxC;EACE,uCAAuC;EACvC,sCAAsC;EACtC,wCAAwC;EACxC,sCAAsC;EACtC,wCAAwC;EACxC,uCAAuC;EACvC,uCAAuC;EACvC,sCAAsC;EACtC,uCAAuC;EACvC,sCAAsC;EACtC,uCAAuC;EACvC,yCAAyC;EACzC,uCAAuC;EACvC,uCAAuC;EACvC,4DAA4D;EAC5D,6DAA6D;EAC7D,kEAAkE;EAClE,kEAAkE;EAClE,uEAAuE;EACvE,wEAAwE;EACxE,sEAAsE;EACtE,oEAAoE;EACpE,qEAAqE;EACrE,mCAAmC;EACnC;;;;;UAKQ;EACR,+CAA+C;EAC/C,2CAA2C;EAC3C,6CAA6C;EAC7C,iDAAiD;EACjD,kGAAkG;EAClG,sGAAsG;EACtG,kGAAkG;EAClG,gJAAgJ;EAChJ,oJAAoJ;EACpJ,qJAAqJ;EACrJ,yJAAyJ;EACzJ,kJAAkJ;EAClJ,sJAAsJ;EACtJ,gJAAgJ;EAChJ,oJAAoJ;EACpJ,mGAAmG;EACnG,+FAA+F;EAC/F,uGAAuG;EACvG,uGAAuG;EACvG,qGAAqG;EACrG,0GAA0G;EAC1G,qGAAqG;EACrG,iEAAiE;EACjE,gEAAgE;EAChE,sCAAsC;EACtC,uCAAuC;EACvC,wCAAwC;EACxC,yCAAyC;EACzC,+EAA+E;EAC/E,uFAAuF;EACvF,mHAAmH;EACnH,6FAA6F;EAC7F,0GAA0G;EAC1G,0GAA0G;EAC1G,6GAA6G;EAC7G,iHAAiH;EACjH,iHAAiH;EACjH,mHAAmH;EACnH,8GAA8G;EAC9G,4GAA4G;AAC9G;AACA;EACE;IACE,uCAAuC;IACvC,oCAAoC;IACpC,sCAAsC;IACtC,oCAAoC;IACpC,sCAAsC;IACtC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,qCAAqC;IACrC,oCAAoC;IACpC,qCAAqC;IACrC,uCAAuC;IACvC,qCAAqC;IACrC,mCAAmC;IACnC,oCAAoC;IACpC,qCAAqC;IACrC,sCAAsC;EACxC;EACA;;;IAGE,uCAAuC;IACvC,gCAAgC;EAClC;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;AACA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;AACF;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,iCAAiC;EACjC,yBAAyB;EACzB,gCAAgC;EAChC,iCAAiC;EACjC,gCAAgC;EAChC,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,wBAAwB;EACxB,gCAAgC;EAChC,yBAAyB;EACzB,iCAAiC;EACjC,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA,yCAAyC;AACzC;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA,uCAAuC;AACvC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4CAA4C;EAC5C,wBAAwB;AAC1B;;AAEA,0CAA0C;AAC1C;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;AAC3C;AACA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,+CAA+C;EAC/C,+CAA+C;EAC/C,6CAA6C;EAC7C,8CAA8C;EAC9C,+CAA+C;AACjD;AACA;EACE,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA,0CAA0C;AAC1C;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA,4CAA4C;AAC5C;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,yDAAyD;EACzD,yDAAyD;EACzD,wBAAwB;EACxB,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA,2CAA2C;AAC3C;EACE;;;;6BAI2B;EAC3B;;;;kBAIgB;EAChB;;;;;uBAKqB;AACvB;;AAEA,6CAA6C;AAC7C;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,uDAAuD;AACvD;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,wCAAwC;EACxC,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,yCAAyC;EACzC,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,6BAA6B;EAC7B,mCAAmC;EACnC,oCAAoC;EACpC,4BAA4B;EAC5B,kCAAkC;EAClC,4CAA4C;EAC5C,mDAAmD;EACnD,+BAA+B;EAC/B,+CAA+C;EAC/C,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA,uCAAuC;;AAEvC,wCAAwC;AACxC;;EAEE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sCAAsC;EACtC,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;AACA;;;;;;EAME,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,6FAA6F;EAC7F,qGAAqG;EACrG,0BAA0B;EAC1B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,6FAA6F;EAC7F,qGAAqG;EACrG,0BAA0B;EAC1B,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,6BAA6B;EAC7B,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;EACf,qDAAqD;AACvD;AACA;;EAEE,wCAAwC;EACxC,uCAAuC;AACzC;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,0DAA0D;EAC1D,+DAA+D;EAC/D,8CAA8C;EAC9C,WAAW;AACb;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,WAAW;EACX,iBAAiB;EACjB,yCAAyC;EACzC,mDAAmD;EACnD,yCAAyC;EACzC,wCAAwC;EACxC,oCAAoC;EACpC,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,yCAAyC;AAC3C;AACA;;EAEE,sCAAsC;AACxC;AACA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;AACjB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;EACf,sCAAsC;AACxC;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;AACb;AACA;;EAEE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,WAAW;EACX,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;AACA;;EAEE,aAAa;AACf;AACA;;;;;;EAME,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,0DAA0D;EAC1D,+DAA+D;EAC/D,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;AACA;;EAEE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,UAAU;EACV,cAAc;EACd,mCAAmC;AACrC;AACA;EACE;;IAEE,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB;;;;;0BAKsB;EACxB;EACA;;;;;;IAME,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;EACA;;IAEE,UAAU;EACZ;AACF;AACA;;EAEE,gBAAgB;EAChB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,WAAW;EACX,oCAAoC;EACpC,qEAAqE;EACrE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB;;;gCAG8B;AAChC;AACA;EACE,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;;;yCAGuC;AACzC;AACA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qFAAqF;AACvF;AACA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,0DAA0D;EAC1D,yBAAyB;AAC3B;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qFAAqF;AACvF;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,2CAA2C;EAC3C,6CAA6C;EAC7C,yCAAyC;EACzC,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,0CAA0C;EAC1C,YAAY;AACd;AACA;EACE,oDAAoD;AACtD;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,2BAA2B;AAC7B;AACA;;EAEE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV;;;;6BAI2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;;EAKE,OAAO;EACP,0CAA0C;EAC1C,iEAAiE;EACjE,mBAAmB;EACnB;;;gCAG8B;AAChC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,wEAAwE;EACxE,oCAAoC;EACpC,iBAAiB;EACjB;;;;+EAI6E;EAC7E,gDAAgD;EAChD,oBAAoB;EACpB,UAAU;EACV,UAAU;EACV;;;yBAGuB;AACzB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC,mFAAmF;AACrF;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,mBAAmB;EACnB,qEAAqE;EACrE,wCAAwC;AAC1C;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,6CAA6C;AAC/C;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,0BAA0B;IAC1B,6BAA6B;IAC7B,oDAAoD;EACtD;AACF;AACA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,6CAA6C;EAC7C,yCAAyC;EACzC,gBAAgB;EAChB,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,gGAAgG;EAChG,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,wCAAwC;AAC1C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,mGAAmG;EACnG,eAAe;EACf,cAAc;EACd,UAAU;AACZ;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE,2CAA2C;EAC3C,6CAA6C;EAC7C,yCAAyC;EACzC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,oDAAoD;EACpD;;;;sCAIoC;EACpC,cAAc;AAChB;AACA;EACE,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;EACpD,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,yCAAyC;EACzC,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mDAAmD;AACrD;AACA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;AACA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,6CAA6C;EAC7C,wCAAwC;EACxC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,0DAA0D;AAC5D;AACA;;EAEE,yCAAyC;EACzC,4CAA4C;AAC9C;AACA;EACE,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,6CAA6C;EAC7C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,0CAA0C;EAC1C,mCAAmC;EACnC,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,6CAA6C;EAC7C,wCAAwC;EACxC,eAAe;EACf,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,4CAA4C;EAC5C,iDAAiD;AACnD;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,6BAA6B;IAC7B,4DAA4D;EAC9D;EACA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,wBAAwB;IAC1B;EACF;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,QAAQ;IACR,YAAY;IACZ,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;;;IAGE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;EACA;IACE,yBAAyB;IACzB,WAAW;EACb;EACA;;IAEE,OAAO;IACP,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,yCAAyC;AACzC;;EAEE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;;;;EAIE,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,kCAAkC;EAClC,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,uCAAuC;AACzC;AACA;EACE;;IAEE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,2CAA2C;EAC3C,oBAAoB;EACpB,oCAAoC;EACpC,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,wCAAwC;EACxC,4CAA4C;EAC5C,yCAAyC;AAC3C;AACA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,wCAAwC;EACxC,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;EACpC,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,uFAAuF;EACvF,oBAAoB;AACtB;AACA;;EAEE,+BAA+B;EAC/B,uCAAuC;AACzC;AACA;;EAEE,+BAA+B;EAC/B,gBAAgB;EAChB,uCAAuC;AACzC;AACA;;EAEE,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kCAAkC;EAClC,yCAAyC;EACzC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,YAAY;EACZ,iCAAiC;EACjC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,qFAAqF;AACvF;AACA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,oDAAoD;AACtD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,kDAAkD;AACpD;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,oDAAoD;AACtD;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,oCAAoC;EACpC,kDAAkD;AACpD;AACA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,YAAY;EACZ,2CAA2C;EAC3C,kDAAkD;EAClD,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,oDAAoD;AACtD;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,UAAU;EACV,oDAAoD;AACtD;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,oDAAoD;AACtD;AACA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,oDAAoD;AACtD;AACA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,oDAAoD;AACtD;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,qCAAqC;EACrC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,gEAAgE;EAChE,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,cAAc;EACd,4BAA4B;AAC9B;AACA;;EAEE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;AACxB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sCAAsC;AACxC;AACA;;EAEE,gBAAgB;EAChB,6CAA6C;EAC7C,uBAAuB;EACvB,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,eAAe;EACf;;;4CAG0C;AAC5C;AACA;;EAEE,4CAA4C;EAC5C,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;EACR,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,yCAAyC;EACzC,4CAA4C;EAC5C,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,6CAA6C;EAC7C,yCAAyC;EACzC,4CAA4C;EAC5C,wCAAwC;EACxC,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,uBAAuB;EACvB,0CAA0C;EAC1C,yCAAyC;EACzC,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf;;;qCAGmC;AACrC;AACA;EACE,4CAA4C;EAC5C,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,gBAAgB;EAChB,UAAU;EACV,MAAM;AACR;AACA;EACE,MAAM;EACN,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,oDAAoD;EACpD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,oDAAoD;AACtD;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,yCAAyC;EACzC,6CAA6C;EAC7C,4CAA4C;EAC5C,wCAAwC;EACxC,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,8CAA8C;EAC9C,4CAA4C;EAC5C,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,4CAA4C;EAC5C,6CAA6C;EAC7C,yCAAyC;EACzC,wCAAwC;EACxC,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,0CAA0C;AAC5C;AACA;EACE,OAAO;AACT;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,yCAAyC;EACzC,6CAA6C;EAC7C,4CAA4C;EAC5C,mCAAmC;AACrC;AACA;EACE,yCAAyC;EACzC,kDAAkD;AACpD;AACA;EACE,yCAAyC;EACzC,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,6CAA6C;EAC7C,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;;;;cAIY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6CAA6C;EAC7C,yCAAyC;EACzC,4CAA4C;EAC5C,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,4FAA4F;AAC9F;AACA;EACE,6CAA6C;EAC7C,yCAAyC;AAC3C;AACA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,2CAA2C;EAC3C,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;EAC9B,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,2CAA2C;EAC3C,oCAAoC;AACtC;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,iBAAiB;EACjB,oCAAoC;EACpC,sCAAsC;EACtC,6BAA6B;EAC7B,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;EACtC,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA,iCAAiC;;AAEjC,6CAA6C;AAC7C;EACE,kDAAkD;AACpD;AACA;EACE;IACE,UAAU;IACV,oBAAoB;IACpB,2CAA2C;EAC7C;AACF;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA,iCAAiC;AACjC;EACE,qDAAqD;EACrD,qDAAqD;EACrD,wCAAwC;AAC1C;AACA;EACE,sDAAsD;EACtD,2DAA2D;EAC3D,wCAAwC;AAC1C;AACA;EACE,2CAA2C;EAC3C,8DAA8D;EAC9D,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,+DAA+D;EAC/D,kBAAkB;EAClB,2DAA2D;EAC3D,0CAA0C;EAC1C,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,wCAAwC;EACxC,4DAA4D;EAC5D,iEAAiE;AACnE;AACA;EACE,2CAA2C;EAC3C,8DAA8D;EAC9D,yCAAyC;EACzC,gBAAgB;EAChB,6CAA6C;AAC/C;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,qFAAqF;AACvF;AACA;EACE,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;EACpC,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,uFAAuF;AACzF;AACA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;AACA;EACE,kCAAkC;AACpC;AACA;;;;;EAKE,oIAAoI;AACtI;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,kDAAkD;AACpD;AACA;EACE,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;;EAIE,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,sDAAsD;AACxD;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,4DAA4D;EAC5D,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+DAA+D;EAC/D,kBAAkB;EAClB,2DAA2D;EAC3D,wCAAwC;EACxC,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4DAA4D;EAC5D,iEAAiE;AACnE;AACA;EACE,sEAAsE;EACtE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".advisory_panel_panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 260px;\n  height: 100%;\n  z-index: 50;\n  background: var(--vnsc-bg-primary);\n  border-left: 1px solid var(--vnsc-border-primary);\n  display: flex;\n  flex-direction: column;\n  font-size: 12px;\n  color: var(--vnsc-text-primary);\n  overflow: hidden;\n}\n.advisory_panel_header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px 8px;\n  border-bottom: 1px solid var(--vnsc-border-primary);\n  background: var(--vnsc-bg-secondary);\n}\n.advisory_panel_title {\n  font-weight: 700;\n  font-size: 13px;\n}\n.advisory_panel_headerActions {\n  display: flex;\n  gap: 6px;\n}\n.advisory_panel_refreshBtn {\n  background: none;\n  border: 1px solid var(--vnsc-border-secondary);\n  color: var(--vnsc-text-secondary);\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 2px 6px;\n  font-size: 11px;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease,\n    border-color 0.15s ease;\n}\n.advisory_panel_refreshBtn:hover:not(:disabled) {\n  background: var(--vnsc-bg-hover);\n  color: var(--vnsc-text-primary);\n  border-color: var(--vnsc-text-disabled);\n}\n.advisory_panel_refreshBtn:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.advisory_panel_closeBtn {\n  background: none;\n  border: none;\n  color: var(--vnsc-text-tertiary);\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0 4px;\n  transition: color 0.15s ease;\n}\n.advisory_panel_closeBtn:hover {\n  color: var(--vnsc-text-primary);\n}\n.advisory_panel_body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px;\n}\n.advisory_panel_skeletonRow {\n  height: 40px;\n  background: var(--vnsc-bg-tertiary);\n  border-radius: 4px;\n  margin-bottom: 8px;\n  animation: advisory_panel_pulse 1.2s ease-in-out infinite;\n}\n@keyframes advisory_panel_pulse {\n  0%, 100% {\n    opacity: 0.5;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n.advisory_panel_decisionBadge {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n.advisory_panel_decisionLabel {\n  flex: 1;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-weight: 700;\n  font-size: 14px;\n  text-align: center;\n  letter-spacing: 0.5px;\n}\n.advisory_panel_decisionStrongBuy {\n  background: var(--vnsc-color-success-hover);\n  color: var(--vnsc-text-on-primary);\n}\n.advisory_panel_decisionBuy {\n  background: var(--vnsc-color-success);\n  color: var(--vnsc-text-on-primary);\n}\n.advisory_panel_decisionHold {\n  background: var(--vnsc-color-neutral);\n  color: var(--vnsc-text-on-primary);\n}\n.advisory_panel_decisionSell {\n  background: var(--vnsc-color-warning);\n  color: var(--vnsc-text-on-primary);\n}\n.advisory_panel_decisionStrongSell {\n  background: var(--vnsc-color-error);\n  color: var(--vnsc-text-on-primary);\n}\n.advisory_panel_confidence {\n  text-align: center;\n}\n.advisory_panel_confidenceLabel {\n  color: var(--vnsc-text-tertiary);\n  font-size: 10px;\n}\n.advisory_panel_confidenceValue {\n  font-weight: 700;\n  font-size: 13px;\n}\n.advisory_panel_agentRows {\n  margin-bottom: 8px;\n}\n.advisory_panel_agentRow {\n  border-bottom: 1px solid var(--vnsc-border-primary);\n  padding-bottom: 8px;\n  margin-bottom: 8px;\n}\n.advisory_panel_agentHeader {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n.advisory_panel_agentName {\n  flex: 1;\n  font-size: 12px;\n  color: var(--vnsc-text-primary);\n  font-weight: 500;\n}\n.advisory_panel_agentWeight {\n  color: var(--vnsc-text-tertiary);\n  font-size: 11px;\n  margin-left: 4px;\n}\n.advisory_panel_agentSignal {\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: var(--vnsc-color-neutral);\n  color: var(--vnsc-text-on-primary);\n  letter-spacing: 0.5px;\n}\n.advisory_panel_agentSignalBuy {\n  background: var(--vnsc-color-success);\n}\n.advisory_panel_agentSignalSell {\n  background: var(--vnsc-color-error);\n}\n.advisory_panel_agentSignalHold {\n  background: var(--vnsc-color-neutral);\n}\n.advisory_panel_agentExpand {\n  color: var(--vnsc-text-tertiary);\n  font-size: 10px;\n}\n.advisory_panel_agentScoreBar {\n  height: 4px;\n  background: var(--vnsc-border-primary);\n  border-radius: 2px;\n  margin-top: 6px;\n  overflow: hidden;\n}\n.advisory_panel_agentScoreFill {\n  height: 100%;\n  border-radius: 2px;\n  transition: width 0.3s ease;\n}\n.advisory_panel_agentExplanation {\n  margin-top: 8px;\n  font-size: 11px;\n  color: var(--vnsc-text-secondary);\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.advisory_panel_explanationToggle {\n  background: none;\n  border: none;\n  color: var(--vnsc-text-link);\n  cursor: pointer;\n  font-size: 11px;\n  padding: 0;\n  text-decoration: underline;\n  transition: color 0.15s ease;\n}\n.advisory_panel_explanationToggle:hover {\n  color: var(--vnsc-text-link-hover);\n}\n.advisory_panel_explanationContent {\n  margin-top: 8px;\n  font-size: 11px;\n  color: var(--vnsc-text-secondary);\n  line-height: 1.6;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.advisory_panel_timestamp {\n  margin-top: 10px;\n  font-size: 10px;\n  color: var(--vnsc-text-tertiary);\n  text-align: right;\n}\n.advisory_panel_emptyState {\n  text-align: center;\n  color: var(--vnsc-text-placeholder);\n  padding-top: 24px;\n  font-size: 12px;\n}\n.advisory_panel_emptyIcon {\n  font-size: 24px;\n  margin-bottom: 8px;\n}\n@media (max-width: 480px) {\n  .advisory_panel_panel {\n    width: 100%;\n    height: auto;\n    max-height: 50%;\n    bottom: 0;\n    top: auto;\n    border-left: none;\n    border-top: 1px solid var(--vnsc-border-primary);\n  }\n}\n\n.drawing_dock_dock {\n  position: absolute;\n  z-index: 50;\n  width: 360px;\n  min-height: 200px;\n  max-height: 500px;\n  background: var(--vnsc-bg-secondary, #111820);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: var(--vnsc-radius-lg, 6px);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  display: flex;\n  flex-direction: column;\n  font-family: var(--gc-font, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif);\n  font-size: var(--vnsc-font-sm, 11px);\n  color: var(--vnsc-text-primary, #e0e0e0);\n}\n.drawing_dock_header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n  background: var(--vnsc-bg-primary, #0a0e14);\n  border-radius: var(--vnsc-radius-lg, 6px) var(--vnsc-radius-lg, 6px) 0 0;\n}\n.drawing_dock_titleBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.drawing_dock_titleBlock strong {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--vnsc-text-primary);\n}\n.drawing_dock_titleBlock span {\n  font-size: 10px;\n  color: var(--vnsc-text-secondary);\n}\n.drawing_dock_headerActions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.drawing_dock_icon {\n  width: 24px;\n  height: 24px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--vnsc-text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.drawing_dock_icon:hover {\n  background-color: var(--vnsc-bg-tertiary, #f1f5f9);\n  color: var(--vnsc-text-primary);\n}\n.drawing_dock_tabs {\n  display: flex;\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n  background: var(--vnsc-bg-primary, #0a0e14);\n}\n.drawing_dock_tab {\n  flex: 1;\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  color: var(--vnsc-text-secondary);\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: color 0.15s ease, background-color 0.15s ease;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n}\n.drawing_dock_tab:hover {\n  color: var(--vnsc-text-primary);\n  background-color: var(--vnsc-bg-tertiary, #f1f5f9);\n}\n.drawing_dock_tabActive {\n  color: var(--vnsc-accent, #2962ff);\n  border-bottom-color: var(--vnsc-accent, #2962ff);\n}\n.drawing_dock_body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px;\n}\n.drawing_dock_empty {\n  color: var(--vnsc-text-secondary);\n  font-style: italic;\n  text-align: center;\n  padding: 20px;\n}\n.drawing_dock_resizeHandle {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 18px;\n  height: 18px;\n  cursor: nwse-resize;\n  background:\n    linear-gradient(\n      135deg,\n      transparent 0%,\n      transparent 40%,\n      var(--vnsc-text-secondary, #888) 40%,\n      var(--vnsc-text-secondary, #888) 44%,\n      transparent 44%,\n      transparent 56%,\n      var(--vnsc-text-secondary, #888) 56%,\n      var(--vnsc-text-secondary, #888) 60%,\n      transparent 60%);\n  opacity: 0.4;\n  transition: opacity 0.15s ease;\n  border-radius: 0 0 var(--vnsc-radius-lg, 6px) 0;\n  z-index: 1;\n}\n.drawing_dock_resizeHandle:hover {\n  opacity: 0.8;\n}\n@media (max-width: 480px) {\n  .drawing_dock_dock {\n    width: calc(100vw - 32px);\n    max-width: 360px;\n  }\n}\n.drawing_dock_templateManager {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.drawing_dock_templateGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.drawing_dock_templateLabel {\n  font-size: 11px;\n  font-weight: bold;\n  color: var(--vnsc-text-secondary, #888);\n}\n.drawing_dock_templateRow {\n  display: flex;\n  gap: 6px;\n}\n.drawing_dock_templateSelect,\n.drawing_dock_templateInput {\n  flex: 0 1 200px;\n  min-width: 120px;\n  background: var(--vnsc-surface-raised, rgba(30, 41, 59, 0.9));\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.1));\n  border-radius: 4px;\n  padding: 6px 8px;\n  color: var(--vnsc-text-primary, #fff);\n  font-size: 12px;\n}\n.drawing_dock_templateButton {\n  background: var(--vnsc-accent, #0891b2);\n  border: none;\n  border-radius: 4px;\n  padding: 6px 12px;\n  color: var(--vnsc-text-primary, #fff);\n  font-size: 12px;\n  cursor: pointer;\n}\n.drawing_dock_templateButtonDanger {\n  background: var(--vnsc-danger, #ef5350);\n}\n.drawing_dock_templateButton:disabled,\n.drawing_dock_templateButtonDanger:disabled {\n  background: var(--vnsc-surface-muted, rgba(255, 255, 255, 0.05));\n  color: var(--vnsc-text-disabled, #666);\n  cursor: default;\n}\n.drawing_dock_templateDivider {\n  height: 1px;\n  background: var(--vnsc-border-subtle, rgba(255, 255, 255, 0.08));\n  margin: 4px 0;\n}\n\n.floating_chart_bar_bar {\n  position: absolute;\n  bottom: 32px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 50;\n  max-width: 320px;\n  overflow: hidden;\n  box-sizing: border-box;\n  transition:\n    max-width 0.2s ease,\n    height 0.2s ease,\n    opacity 0.2s ease,\n    border-radius 0.2s ease,\n    padding 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 4px 8px;\n  background: var(--vnsc-bg-secondary, #111820);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: 6px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n  font-family:\n    Helvetica Neue,\n    Helvetica,\n    Arial,\n    sans-serif;\n  user-select: none;\n  white-space: nowrap;\n}\n.floating_chart_bar_btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: none;\n  border-radius: 3px;\n  background: transparent;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.floating_chart_bar_btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--vnsc-text-primary, #e0e0e0);\n}\n.floating_chart_bar_btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n.floating_chart_bar_btnActive {\n  color: var(--vnsc-primary, #2962ff);\n}\n.floating_chart_bar_separator {\n  width: 1px;\n  height: 18px;\n  background: var(--vnsc-border, #2a2a2a);\n  margin: 0 4px;\n  flex-shrink: 0;\n}\n.floating_chart_bar_grip {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 24px;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  flex-shrink: 0;\n}\n@media (hover: hover) {\n  .floating_chart_bar_bar:not(:hover):not(:focus-within) {\n    max-width: 40px;\n    height: 18px;\n    padding: 1px 8px;\n    border-radius: 13px;\n    opacity: 0.85;\n  }\n  .floating_chart_bar_bar:not(:hover):not(:focus-within) > :not(.floating_chart_bar_grip) {\n    opacity: 0;\n  }\n  .floating_chart_bar_bar:not(:hover):not(:focus-within) > .floating_chart_bar_grip {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    height: 14px;\n  }\n  .floating_chart_bar_bar:not(:hover):not(:focus-within) > .floating_chart_bar_grip svg {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n.fork_overlays_forkXAxisOverlay {\n  position: absolute;\n  inset: 0;\n  z-index: 32;\n  pointer-events: none;\n}\n.fork_overlays_forkXAxisTick {\n  position: absolute;\n  transform: translateX(-50%);\n  z-index: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.fork_overlays_forkXAxisTickLeftEdge {\n  transform: translateX(0);\n}\n.fork_overlays_forkXAxisTickRightEdge {\n  transform: translateX(-100%);\n}\n.fork_overlays_forkXAxisTickLine {\n  width: 1px;\n  height: 6px;\n  margin: 0 auto 2px;\n}\n.fork_overlays_forkXAxisTickLabel {\n  font-family:\n    Inter,\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif;\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 14px;\n  white-space: nowrap;\n  padding: 0;\n  background: none;\n  border: none;\n}\n.fork_overlays_forkXAxisHoverLabel {\n  position: absolute;\n  transform: translateX(-50%);\n  z-index: 2;\n}\n.fork_overlays_forkXAxisHoverLine {\n  width: 1px;\n  height: 8px;\n  margin: 0 auto 2px;\n}\n.fork_overlays_forkXAxisHoverLabelText {\n  font-family:\n    Inter,\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 14px;\n  white-space: nowrap;\n  padding: 2px 6px;\n  border-radius: 3px;\n  background: var(--vnsc-bg-secondary);\n  border: none;\n  color: var(--vnsc-text-primary);\n}\n.fork_overlays_forkPaneTooltip {\n  position: absolute;\n  left: 8px;\n  z-index: 18;\n  pointer-events: none;\n  font-family: var(--gc-mono, monospace);\n  font-size: 11px;\n  line-height: 16px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px 8px;\n}\n.fork_overlays_forkPaneTooltipDark {\n  background: none;\n  border: none;\n}\n.fork_overlays_forkPaneTooltipLight {\n  background: none;\n  border: none;\n}\n.fork_overlays_forkPaneTooltipLabel {\n  color: var(--vnsc-text-secondary, #64748b);\n}\n.fork_overlays_forkPaneTooltipValue {\n  color: var(--vnsc-text-primary, #1e2a3b);\n}\n.fork_overlays_forkPaneTooltipDark .fork_overlays_forkPaneTooltipLabel {\n  color: var(--vnsc-text-primary);\n}\n.fork_overlays_forkPaneTooltipDark .fork_overlays_forkPaneTooltipValue {\n  color: var(--vnsc-text-on-primary);\n}\n.fork_overlays_forkYAxisLabel {\n  position: absolute;\n  z-index: 22;\n  pointer-events: none;\n  font-family:\n    Inter,\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    monospace;\n  font-size: 9px;\n  font-weight: 500;\n  line-height: 12px;\n  white-space: nowrap;\n  padding: 1px 3px;\n  border-radius: 3px;\n  transform: translateY(-50%);\n  font-variant-numeric: tabular-nums;\n}\n.fork_overlays_forkPaneSeparator {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: var(--vnsc-border, rgba(255, 255, 255, 0.08));\n  z-index: 15;\n  pointer-events: none;\n}\n.fork_overlays_forkYAxisLabelIndicator {\n  background: var(--vnsc-bg-secondary, rgba(17, 24, 32, 0.85));\n}\n.fork_overlays_forkRubberBand {\n  position: absolute;\n  border: 1px dashed var(--vnsc-accent, rgba(56, 189, 248, 0.9));\n  background: color-mix(in srgb, var(--vnsc-accent, rgba(56, 189, 248, 1)) 12%, transparent);\n  pointer-events: none;\n  z-index: 21;\n}\n.fork_overlays_forkLoadingOverlay {\n  position: absolute;\n  inset: 0;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--vnsc-bg-overlay, rgba(10, 14, 20, 0.85));\n}\n.fork_overlays_forkBottomPanel {\n  height: var(--vnsc-bottom-panel-height, 260px);\n  max-height: 60dvh;\n  border-top: 1px solid var(--vnsc-border, #2a2a2a);\n  background: var(--vnsc-bg-secondary, #111820);\n  position: relative;\n  z-index: 40;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n@media (max-width: 480px) {\n  .fork_overlays_forkXAxisTickLabel,\n  .fork_overlays_forkXAxisHoverLabelText {\n    font-size: 9px;\n    padding: 0 2px;\n  }\n  .fork_overlays_forkPaneTooltip {\n    font-size: 10px;\n    left: 4px;\n    padding: 3px 6px;\n  }\n}\n\n.multicharts_layout_multichartsLayout {\n  display: grid;\n  grid-template-rows: 40px 1fr 32px;\n  grid-template-columns: 1fr;\n  grid-template-areas: \"header\" \"charts\" \"footer\";\n  height: 100%;\n  height: 100dvh;\n  width: 100%;\n  overflow: hidden;\n  background: var(--vnsc-bg-primary, #131722);\n  color: var(--vnsc-text-primary, #d1d4dc);\n  font-family: var(--vnsc-font-family, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif);\n}\n.multicharts_layout_header {\n  grid-area: header;\n  z-index: 100;\n  flex-shrink: 0;\n}\n.multicharts_layout_headerWorkspaceMode {\n  cursor: pointer;\n}\n.multicharts_layout_toolbar {\n  position: absolute;\n  left: 0;\n  top: 40px;\n  bottom: 32px;\n  width: 0px;\n  z-index: 500;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n  pointer-events: none;\n}\n.multicharts_layout_toolbarLocked .multicharts_layout_toolbar {\n  width: 44px;\n  pointer-events: auto;\n}\n.multicharts_layout_toolbarLocked .multicharts_layout_charts {\n  margin-left: 44px;\n}\n.multicharts_layout_toolbarLocked [data-vnsc-bottom-panel=host] {\n  margin-left: 44px;\n}\n.multicharts_layout_charts {\n  grid-area: charts;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n  position: relative;\n}\n.multicharts_layout_workspaceBody {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  position: relative;\n  z-index: 10;\n}\n.multicharts_layout_workspaceMainCol {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n}\n.multicharts_layout_workspaceBody .multicharts_layout_charts {\n  flex: 1;\n  min-height: 0;\n}\n.multicharts_layout_footer {\n  grid-area: footer;\n  z-index: 100;\n  flex-shrink: 0;\n  transition:\n    height 0.2s ease,\n    opacity 0.2s ease,\n    padding 0.2s ease;\n}\n.multicharts_layout_footer.multicharts_layout_hidden {\n  height: 0;\n  padding: 0 16px;\n  opacity: 0;\n  pointer-events: none;\n  border-top: none;\n}\n@media (min-width: 769px) {\n  .multicharts_layout_toolbar {\n    display: flex;\n  }\n}\n@media (max-width: 768px) {\n  .multicharts_layout_multichartsLayout {\n    grid-template-columns: 1fr;\n    grid-template-rows: 40px 1fr 0px;\n    grid-template-areas: \"header\" \"charts\" \"footer\";\n  }\n  .multicharts_layout_toolbar {\n    display: none;\n  }\n  .multicharts_layout_toolbar.multicharts_layout_mobileVisible {\n    display: flex;\n    position: fixed;\n    top: 40px;\n    left: 0;\n    bottom: 32px;\n    width: 280px;\n    max-width: 85vw;\n    height: auto;\n    max-height: calc(100vh - 72px);\n    z-index: 1000;\n    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.3);\n    border-right: 1px solid var(--vnsc-border, #2a2e39);\n    min-width: 280px;\n    max-width: 280px;\n    width: 280px;\n  }\n  .multicharts_layout_footer {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 0px;\n    min-height: 0px;\n    padding: 0;\n    border-top: none;\n    overflow: visible;\n    pointer-events: none;\n    background: transparent;\n    z-index: 100;\n  }\n}\n.multicharts_layout_toolbar .unifiedDrawingToolbar {\n  height: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.multicharts_layout_toolbar.multicharts_layout_expanded .unifiedDrawingToolbar {\n  overflow-y: auto;\n}\n.multicharts_layout_toolbar.multicharts_layout_collapsed .toolbarContent {\n  display: none;\n}\n.multicharts_layout_toolbar.multicharts_layout_collapsed .toolbarHeader {\n  padding: 8px;\n  justify-content: center;\n}\n.multicharts_layout_toolbar.multicharts_layout_collapsed .toolbarHeader .toolbarTitle,\n.multicharts_layout_toolbar.multicharts_layout_collapsed .toolbarHeader .lockToggle,\n.multicharts_layout_toolbar.multicharts_layout_collapsed .toolbarHeader .collapseToggle {\n  display: none;\n}\n.multicharts_layout_toolbar.multicharts_layout_collapsed .toolbarHeader .expandToggle {\n  display: flex;\n}\n.multicharts_layout_chartsContainer {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n  position: relative;\n}\n.multicharts_layout_gridContainer {\n  flex: 1;\n  display: grid;\n  gap: 8px;\n  padding: 8px;\n  min-height: 0;\n  overflow: auto;\n}\n.multicharts_layout_gridContainer[data-layout=\"1x1\"] {\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n}\n.multicharts_layout_gridContainer[data-layout=\"1x2\"] {\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr;\n}\n.multicharts_layout_gridContainer[data-layout=\"2x1\"] {\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr 1fr;\n}\n.multicharts_layout_gridContainer[data-layout=\"2x2\"] {\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr 1fr;\n}\n.multicharts_layout_gridContainer[data-layout=\"1x4\"] {\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: 1fr;\n}\n.multicharts_layout_gridContainer[data-layout=\"4x1\"] {\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(4, 1fr);\n}\n.multicharts_layout_gridContainer[data-layout=\"2x4\"] {\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: 1fr 1fr;\n}\n.multicharts_layout_gridContainer[data-layout=\"3x3\"] {\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(3, 1fr);\n}\n.multicharts_layout_chartSlot {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  border: 1px solid var(--vnsc-border, #2a2e39);\n  border-radius: 8px;\n  overflow: hidden;\n  background: var(--vnsc-bg-primary, #131722);\n  position: relative;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n.multicharts_layout_chartSlot:hover {\n  border-color: var(--vnsc-border-hover, #3a3e49);\n}\n.multicharts_layout_chartSlot.multicharts_layout_active {\n  border: 1px solid var(--vnsc-primary, #2962ff);\n}\n.multicharts_layout_chartSlot.multicharts_layout_empty {\n  border: 2px dashed var(--vnsc-border, #2a2e39);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--vnsc-bg-secondary, #1e222d);\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n.multicharts_layout_chartSlot.multicharts_layout_empty:hover {\n  background: var(--vnsc-bg-tertiary, #262b36);\n  border-color: var(--vnsc-primary, #2962ff);\n}\n.multicharts_layout_chartSlot.multicharts_layout_empty:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--vnsc-primary, #2962ff);\n}\n.multicharts_layout_chartSlot.multicharts_layout_empty span {\n  color: var(--vnsc-text-muted, #787b86);\n  font-size: 14px;\n  pointer-events: none;\n}\n.multicharts_layout_slotHeader {\n  position: absolute;\n  top: 4px;\n  left: 8px;\n  right: 8px;\n  display: flex;\n  justify-content: space-between;\n  z-index: 10;\n  pointer-events: none;\n}\n.multicharts_layout_slotHeader > * {\n  pointer-events: auto;\n}\n.multicharts_layout_symbolBadge {\n  background-color: rgba(0, 0, 0, 0.6);\n  color: white;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n.multicharts_layout_groupBadge {\n  color: white;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n.multicharts_layout_groupBadgeA {\n  background-color: #e74c3c;\n}\n.multicharts_layout_groupBadgeB {\n  background-color: #3498db;\n}\n.multicharts_layout_groupBadgeC {\n  background-color: #2ecc71;\n}\n.multicharts_layout_groupBadgeD {\n  background-color: #f39c12;\n}\n.multicharts_layout_charts .ohlcTooltip {\n  pointer-events: none;\n  z-index: 200;\n}\n.multicharts_layout_header .menu,\n.multicharts_layout_toolbar .menu {\n  z-index: 1000;\n}\n@media (prefers-contrast: high) {\n  .multicharts_layout_multichartsLayout {\n    border: 2px solid currentColor;\n  }\n  .multicharts_layout_toolbar {\n    border-right-width: 2px;\n  }\n  .multicharts_layout_chartSlot {\n    border-width: 2px;\n  }\n  .multicharts_layout_chartSlot.multicharts_layout_active {\n    border-width: 3px;\n  }\n  .multicharts_layout_footer {\n    border-top-width: 2px;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .multicharts_layout_multichartsLayout,\n  .multicharts_layout_toolbar,\n  .multicharts_layout_footer,\n  .multicharts_layout_chartSlot,\n  .multicharts_layout_slotHeader,\n  .multicharts_layout_toolbar .unifiedDrawingToolbar {\n    transition: none;\n  }\n}\n@media print {\n  .multicharts_layout_toolbar,\n  .multicharts_layout_footer,\n  .multicharts_layout_slotHeader,\n  .multicharts_layout_header .menu {\n    display: none !important;\n  }\n  .multicharts_layout_multichartsLayout {\n    grid-template-rows: auto 1fr auto;\n    grid-template-columns: 1fr;\n    grid-template-areas: \"header\" \"charts\" \"footer\";\n  }\n  .multicharts_layout_chartSlot {\n    break-inside: avoid;\n    border: 1px solid #000 !important;\n  }\n}\n@media (prefers-color-scheme: dark) {\n  .vnsc-root {\n    --vnsc-bg-primary: #131722;\n    --vnsc-bg-secondary: #1e222d;\n    --vnsc-bg-tertiary: #262b36;\n    --vnsc-bg-hover: #232838;\n    --vnsc-bg-input: #0d1117;\n    --vnsc-border: #2a2e39;\n    --vnsc-border-hover: #3a3e49;\n    --vnsc-text-primary: #d1d4dc;\n    --vnsc-text-secondary: #787b86;\n    --vnsc-text-muted: #787b86;\n    --vnsc-primary: #2962ff;\n    --vnsc-primary-hover: #1a52e0;\n    --vnsc-success: #0ecb81;\n    --vnsc-danger-bg: #2a1a1a;\n    --vnsc-danger-border: #442222;\n    --vnsc-danger-text: #f87171;\n    --vnsc-danger-hover: #3a2a2a;\n    --vnsc-accent: #2962ff;\n    --vnsc-accent-hover: #1a52e0;\n    --vnsc-accent-subtle: rgba(41, 98, 255, 0.15);\n    --vnsc-font-family:\n      -apple-system,\n      BlinkMacSystemFont,\n      \"Segoe UI\",\n      Roboto,\n      sans-serif;\n    --vnsc-font-mono:\n      ui-monospace,\n      SFMono-Regular,\n      monospace;\n  }\n}\n@media (max-width: 768px) {\n  .multicharts_layout_multichartsLayout [role=menuitem],\n  .multicharts_layout_multichartsLayout [role=option] {\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    padding: 8px 16px;\n  }\n  .multicharts_layout_multichartsLayout footer button {\n    min-height: 44px;\n    padding: 0 16px;\n  }\n  .multicharts_layout_multichartsLayout .multicharts_layout_vnsc-symbol-search-dropdown-container li {\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.ohlc_header_ohlcHeader {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  background: var(--vnsc-bg-secondary, #111820);\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n  font-family: var(--vnsc-font-family-base);\n  font-size: 12px;\n  color: var(--vnsc-text-primary, #e0e0e0);\n  z-index: 30;\n  min-height: 32px;\n  min-width: 0;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n.ohlc_header_ohlcHeader::-webkit-scrollbar {\n  display: none;\n}\n.ohlc_header_leftGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.ohlc_header_symbol {\n  font-size: 14px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.ohlc_header_timeframe {\n  background: var(--vnsc-accent-strong, #2563eb);\n  color: #fff;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n}\n.ohlc_header_timeframeGroup {\n  display: flex;\n  gap: 2px;\n  align-items: center;\n}\n.ohlc_header_timeframeBtn {\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  color: var(--vnsc-text-secondary, #787b86);\n  padding: 4px 8px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n.ohlc_header_timeframeBtn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--vnsc-text-primary, #e0e0e0);\n}\n.ohlc_header_timeframeBtnActive {\n  background: var(--vnsc-accent-strong, #2563eb);\n  color: #fff;\n  font-weight: 600;\n}\n.ohlc_header_selectorGroup {\n  position: relative;\n}\n.ohlc_header_selectorBtn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: transparent;\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: 4px;\n  color: var(--vnsc-text-secondary, #787b86);\n  padding: 4px 8px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n}\n.ohlc_header_selectorBtn:hover,\n.ohlc_header_selectorBtnOpen {\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--vnsc-text-primary, #e0e0e0);\n  border-color: var(--vnsc-accent, #2962ff);\n}\n.ohlc_header_selectorArrow {\n  font-size: 8px;\n  margin-left: 2px;\n}\n.ohlc_header_dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 4px;\n  background: var(--vnsc-bg-primary, #1e293b);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  list-style: none;\n  padding: 4px;\n  z-index: 100;\n  min-width: 120px;\n}\n.ohlc_header_dropdownFloating {\n  position: fixed;\n  top: auto;\n  left: auto;\n  margin-top: 0;\n  z-index: 9999;\n}\n.ohlc_header_dropdownItem {\n  padding: 6px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--vnsc-text-secondary, #787b86);\n  transition: background 0.15s ease;\n}\n.ohlc_header_dropdownItem:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--vnsc-text-primary, #e0e0e0);\n}\n.ohlc_header_dropdownItemSelected {\n  background: rgba(41, 98, 255, 0.15);\n  color: var(--vnsc-primary, #2962ff);\n  font-weight: 600;\n}\n.ohlc_header_dropdownItemDisabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.ohlc_header_dropdownItemDisabled:hover {\n  background: transparent;\n  color: var(--vnsc-text-secondary, #787b86);\n}\n.ohlc_header_comingSoonBadge {\n  margin-left: 8px;\n  padding: 1px 6px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--vnsc-primary, #2962ff);\n  background: rgba(41, 98, 255, 0.15);\n  white-space: nowrap;\n}\n.ohlc_header_replayControl {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n.ohlc_header_replayToggleBtn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: transparent;\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: 4px;\n  color: var(--vnsc-text-secondary, #787b86);\n  padding: 4px 8px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n  line-height: 1;\n}\n.ohlc_header_replayToggleBtn:hover {\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--vnsc-text-primary, #e0e0e0);\n  border-color: var(--vnsc-accent, #2962ff);\n}\n.ohlc_header_replayToggleBtnActive {\n  background: rgba(41, 98, 255, 0.2);\n  color: var(--vnsc-primary, #2962ff);\n  font-weight: 600;\n  border-color: var(--vnsc-primary, #2962ff);\n}\n.ohlc_header_replayBar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 6px;\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 4px;\n}\n.ohlc_header_replayBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--vnsc-text-secondary, #787b86);\n  cursor: pointer;\n  font-size: 10px;\n  transition: all 0.15s ease;\n}\n.ohlc_header_replayBtn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--vnsc-text-primary, #e0e0e0);\n}\n.ohlc_header_replayBtnActive {\n  color: var(--vnsc-primary, #2962ff);\n}\n.ohlc_header_replaySlider {\n  width: 80px;\n  height: 4px;\n  accent-color: var(--vnsc-accent, #2962ff);\n  cursor: pointer;\n}\n.ohlc_header_replayProgress {\n  font-size: 10px;\n  color: var(--vnsc-text-secondary, #787b86);\n  white-space: nowrap;\n  min-width: 50px;\n}\n.ohlc_header_replayPnl {\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n  margin: 0 4px;\n}\n.ohlc_header_replayPnl[data-pnl-positive=true] {\n  color: #22bb5c;\n}\n.ohlc_header_replayPnl[data-pnl-positive=false] {\n  color: #d7324b;\n}\n.ohlc_header_replayAnalytics {\n  display: inline-flex;\n  gap: 6px;\n  align-items: center;\n  font-size: 10px;\n  white-space: nowrap;\n  margin: 0 4px;\n}\n.ohlc_header_replayAnalyticsItem {\n  padding: 0 4px;\n  color: var(--vnsc-text-secondary, #787b86);\n  border-right: 1px solid var(--vnsc-border, rgba(148,163,184,0.2));\n}\n.ohlc_header_replayAnalyticsItem:last-child {\n  border-right: none;\n}\n.ohlc_header_replayAnalyticsItem[data-positive=true] {\n  color: #22bb5c;\n}\n.ohlc_header_replayAnalyticsItem[data-positive=false] {\n  color: #d7324b;\n}\n.ohlc_header_replaySpeed {\n  background: transparent;\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: 4px;\n  color: var(--vnsc-text-secondary, #787b86);\n  font-size: 10px;\n  padding: 1px 4px;\n  cursor: pointer;\n}\n.ohlc_header_menu {\n  display: flex;\n  gap: 2px;\n  margin-left: auto;\n}\n.ohlc_header_menuBtn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--vnsc-text-secondary, #787b86);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.ohlc_header_menuBtn:hover {\n  background-color: rgba(255, 255, 255, 0.08);\n  color: var(--vnsc-text-primary);\n}\n.ohlc_header_menuBtnActive {\n  background-color: var(--vnsc-accent, #2962ff);\n  color: #fff;\n}\n.ohlc_header_menuBtnActive:hover {\n  background-color: #1a52d6;\n  color: #fff;\n}\n.ohlc_header_upgradeBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 26px;\n  padding: 0 10px;\n  border: 1px solid rgba(41, 98, 255, 0.45);\n  border-radius: 4px;\n  background: rgba(41, 98, 255, 0.14);\n  color: #dbe4ff;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n  box-shadow: none;\n}\n.ohlc_header_upgradeBtn:hover {\n  background: rgba(41, 98, 255, 0.24);\n  box-shadow: none;\n}\n.ohlc_header_logoBadge {\n  background:\n    linear-gradient(\n      135deg,\n      #3b82f6,\n      #1d4ed8);\n  color: #ffffff;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-weight: bold;\n  font-size: 11px;\n  letter-spacing: 0.5px;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);\n  display: inline-flex;\n  align-items: center;\n  user-select: none;\n}\n.ohlc_header_logoBadgeMobile {\n  background:\n    linear-gradient(\n      135deg,\n      var(--vnsc-accent, #22d3ee),\n      #0891b2);\n  color: #0a0e17;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: 800;\n  font-size: 11px;\n  letter-spacing: 0.5px;\n  display: inline-flex;\n  align-items: center;\n  user-select: none;\n}\n.ohlc_header_rightGroupMobile {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.ohlc_header_dropdownContainerMobile {\n  position: relative;\n}\n.ohlc_header_mobileChartSystemMenu {\n  position: absolute;\n  top: 32px;\n  right: 0;\n  min-width: 220px;\n  max-height: calc(100vh - 100px);\n  overflow-y: auto;\n  padding: 8px;\n  background-color: var(--vnsc-bg-secondary, #0f172a);\n  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.18));\n  border-radius: 8px;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  z-index: 250;\n  scrollbar-width: thin;\n}\n.ohlc_header_menuActionBtn {\n  height: 32px;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  color: var(--vnsc-text-secondary, #94a3b8);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  transition: all 0.12s ease;\n}\n.ohlc_header_menuActionBtn:hover,\n.ohlc_header_menuActionBtn.ohlc_header_active {\n  background-color: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.05));\n  color: var(--vnsc-text-primary, #e2e8f0);\n}\n.ohlc_header_replayBarMobile {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--vnsc-bg-secondary, #111820);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: 6px;\n  padding: 6px 10px;\n  position: absolute;\n  top: 36px;\n  left: 6px;\n  right: 6px;\n  z-index: 220;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n  box-sizing: border-box;\n}\n.ohlc_header_ohlcCluster {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: 8px;\n  font-size: 11px;\n  font-family: var(--vnsc-font-mono, monospace);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.ohlc_header_ohlcItem {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n.ohlc_header_ohlcLabel {\n  color: inherit;\n  opacity: 0.75;\n  font-weight: 600;\n}\n.ohlc_header_ohlcValue {\n  color: inherit;\n}\n.ohlc_header_ohlcChange {\n  font-weight: 600;\n  margin-left: 4px;\n}\n.ohlc_header_ohlcUp {\n  color: var(--vnsc-color-bullish, #26a69a);\n}\n.ohlc_header_ohlcDown {\n  color: var(--vnsc-color-bearish, #ef5350);\n}\n@media (max-width: 640px) {\n  .ohlc_header_ohlcHeader {\n    padding: 3px 6px;\n    gap: 4px;\n  }\n  .ohlc_header_symbol {\n    font-size: 12px;\n  }\n  .ohlc_header_replaySlider {\n    width: 60px;\n    flex: 1;\n  }\n  .ohlc_header_menuBtn {\n    width: 24px;\n    height: 24px;\n  }\n}\n.ohlc_header_envPopover {\n  position: fixed;\n  top: auto;\n  left: auto;\n  z-index: 9999;\n  min-width: 220px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px 12px;\n  background: var(--vnsc-bg-primary, #1e293b);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  font-size: 12px;\n}\n.ohlc_header_envRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n.ohlc_header_liveBadgeDot {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--vnsc-accent, #22d3ee);\n  margin-right: 6px;\n}\n\n.pine_editor_panel {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  font-family: Inter, sans-serif;\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  color: var(--vnsc-text-primary, #e0e0e0);\n  background: var(--vnsc-bg-primary, #0c1017);\n}\n.pine_editor_toolbar {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  border-bottom: 1px solid var(--vnsc-border-divider, #202b3c);\n  padding: 8px 12px;\n  flex-shrink: 0;\n}\n.pine_editor_title {\n  font-weight: bold;\n  margin-right: 4px;\n}\n.pine_editor_body {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n}\n.pine_editor_sidebar {\n  width: 220px;\n  border-right: 1px solid var(--vnsc-border-divider, #202b3c);\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n.pine_editor_sidebarHeader {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 10px;\n  font-weight: 600;\n  font-size: 11px;\n  color: var(--vnsc-text-secondary, #9aa3b8);\n  border-bottom: 1px solid var(--vnsc-border-divider, #202b3c);\n}\n.pine_editor_scriptList {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 0;\n}\n.pine_editor_scriptItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 10px;\n  cursor: pointer;\n  border-left: 3px solid transparent;\n  transition: background 0.15s;\n  gap: 4px;\n}\n.pine_editor_scriptItem:hover {\n  background: var(--vnsc-bg-hover, #1a2030);\n}\n.pine_editor_scriptItemActive {\n  background: var(--vnsc-bg-selected, #1a2744);\n  border-left-color: var(--vnsc-accent, #6366f1);\n}\n.pine_editor_scriptName {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12px;\n}\n.pine_editor_renameInput {\n  flex: 1;\n  background: var(--vnsc-bg-input, #090d14);\n  border: 1px solid var(--vnsc-accent, #6366f1);\n  border-radius: 3px;\n  color: var(--vnsc-text-primary, #e0e0e0);\n  font-size: 12px;\n  padding: 2px 6px;\n  outline: none;\n}\n.pine_editor_scriptActions {\n  display: flex;\n  gap: 2px;\n  flex-shrink: 0;\n}\n.pine_editor_compileBtn {\n  padding: 5px 12px;\n  background: var(--vnsc-color-success, #089981);\n  border: none;\n  border-radius: 4px;\n  color: #fff;\n  font-weight: bold;\n  cursor: pointer;\n  margin-left: auto;\n  transition: background-color 0.2s ease;\n}\n.pine_editor_compileBtn:hover {\n  background: var(--vnsc-color-success-hover, #067a68);\n}\n.pine_editor_toolBtn {\n  padding: 4px 10px;\n  background: var(--vnsc-bg-input, #1e2a3a);\n  border: 1px solid var(--vnsc-border-input, #2a3a4e);\n  border-radius: 4px;\n  color: var(--vnsc-text-primary, #c0c8d8);\n  font-size: 11px;\n  cursor: pointer;\n  transition: background 0.15s;\n  white-space: nowrap;\n}\n.pine_editor_toolBtn:hover {\n  background: var(--vnsc-bg-input-hover, #2a3a4e);\n}\n.pine_editor_smallBtn {\n  padding: 2px 6px;\n  background: transparent;\n  border: 1px solid var(--vnsc-border-input, #2a3a4e);\n  border-radius: 3px;\n  color: var(--vnsc-text-secondary, #9aa3b8);\n  font-size: 10px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.pine_editor_smallBtn:hover {\n  background: var(--vnsc-bg-input-hover, #1e2a3a);\n  color: var(--vnsc-text-primary, #c0c8d8);\n}\n.pine_editor_smallBtnDanger {\n  padding: 2px 6px;\n  background: transparent;\n  border: 1px solid var(--vnsc-border-error, #4a1a1a);\n  border-radius: 3px;\n  color: var(--vnsc-color-bearish, #f23645);\n  font-size: 10px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.pine_editor_smallBtnDanger:hover {\n  background: var(--vnsc-bg-hover, #2a1010);\n}\n.pine_editor_editorContainer {\n  flex: 1;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.pine_editor_errorBox {\n  padding: 8px 12px;\n  background: rgba(242, 54, 69, 0.1);\n  border-top: 1px solid #f23645;\n  color: #f23645;\n  flex-shrink: 0;\n}\n.pine_editor_successBox {\n  padding: 8px 12px;\n  background: rgba(8, 153, 129, 0.1);\n  border-top: 1px solid #089981;\n  color: #089981;\n  flex-shrink: 0;\n}\n@media (max-width: 768px) {\n  .pine_editor_sidebar {\n    width: 160px;\n  }\n  .pine_editor_scriptActions {\n    flex-direction: column;\n  }\n}\n@media (max-width: 480px) {\n  .pine_editor_toolbar {\n    flex-wrap: wrap;\n  }\n  .pine_editor_sidebar {\n    display: none;\n  }\n  .pine_editor_compileBtn {\n    margin-left: 0;\n    width: 100%;\n  }\n}\n\n.right_dock_rail_workspaceDock {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 10px;\n  z-index: var(--vnsc-z-sidebar, 48);\n  pointer-events: auto;\n}\n.right_dock_rail_workspaceDock::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 3px;\n  height: 3px;\n  border-radius: 999px;\n  background: var(--vnsc-text-secondary);\n  box-shadow: 0 -6px 0 var(--vnsc-text-secondary), 0 6px 0 var(--vnsc-text-secondary);\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n.right_dock_rail_workspaceDockFlyout {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  transform: translateX(100%);\n  visibility: hidden;\n  transition: transform 0.2s ease, visibility 0s linear 0.2s;\n}\n.right_dock_rail_workspaceDock:hover .right_dock_rail_workspaceDockFlyout,\n.right_dock_rail_workspaceDock:focus-within .right_dock_rail_workspaceDockFlyout,\n.right_dock_rail_workspaceDockOpen .right_dock_rail_workspaceDockFlyout {\n  transform: translateX(0);\n  visibility: visible;\n  transition: transform 0.2s ease, visibility 0s;\n}\n.right_dock_rail_workspaceDock * {\n  pointer-events: auto;\n}\n.right_dock_rail_workspaceDockPinned {\n  position: static;\n  width: auto;\n  flex-shrink: 0;\n  display: flex;\n}\n.right_dock_rail_workspaceDockPinned::before {\n  display: none;\n}\n.right_dock_rail_workspaceDockPinned .right_dock_rail_workspaceDockFlyout {\n  display: contents;\n  visibility: visible;\n}\n@media (max-width: 767px) {\n  .right_dock_rail_workspaceDock {\n    left: 0;\n    right: 0;\n    top: auto;\n    bottom: 0;\n    width: auto;\n    z-index: 20;\n  }\n  .right_dock_rail_workspaceDock::before {\n    display: none;\n  }\n  .right_dock_rail_workspaceDockFlyout {\n    position: static;\n    transform: none;\n    visibility: visible;\n  }\n}\n\n.right_sidebar_dock_dock {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  height: 100%;\n  border-left: 1px solid var(--vnsc-border, #2a2a2a);\n  background: var(--vnsc-bg-secondary, #111820);\n  position: relative;\n  z-index: 48;\n  min-width: 150px;\n  overflow: hidden;\n  transition: width 0.18s ease;\n}\n.right_sidebar_dock_dockClosed {\n  min-width: 40px;\n}\n@media (max-width: 767px) {\n  .right_sidebar_dock_dock {\n    transition: none;\n  }\n  .right_sidebar_dock_dockClosed {\n    height: auto;\n    min-height: 0;\n    border-top: none;\n  }\n}\n.right_sidebar_dock_splitter {\n  width: 4px;\n  cursor: col-resize;\n  z-index: 49;\n  background: transparent;\n  transition: background 0.2s;\n  flex-shrink: 0;\n}\n.right_sidebar_dock_splitterActive {\n  background: var(--vnsc-accent, #2962ff);\n}\n.right_sidebar_dock_stacked {\n  flex-shrink: 0;\n  overflow-y: auto;\n}\n.right_sidebar_dock_body {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n}\n.right_sidebar_dock_panel {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.right_sidebar_dock_panelHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--vnsc-border-divider, #2a2a2a);\n  flex-shrink: 0;\n}\n.right_sidebar_dock_panelTitle {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--vnsc-text-secondary, #787b86);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.right_sidebar_dock_panelActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.right_sidebar_dock_panelClose {\n  background: transparent;\n  border: none;\n  color: var(--vnsc-text-secondary, #787b86);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  padding: 2px;\n  border-radius: 4px;\n}\n.right_sidebar_dock_panelClose:hover {\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\n  color: var(--vnsc-text-primary, #d1d4dc);\n}\n.right_sidebar_dock_panelBody {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n.right_sidebar_dock_strip {\n  width: 40px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding: 6px 0;\n  border-left: 1px solid var(--vnsc-border-divider, #2a2a2a);\n  background: var(--vnsc-bg-primary, #131722);\n  overflow-y: auto;\n}\n.right_sidebar_dock_stripBtn {\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  color: var(--vnsc-text-secondary, #787b86);\n  cursor: pointer;\n}\n.right_sidebar_dock_stripBtn:hover {\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\n  color: var(--vnsc-text-primary, #d1d4dc);\n}\n.right_sidebar_dock_stripBtnDisabled {\n  opacity: 0.38;\n  cursor: not-allowed;\n}\n.right_sidebar_dock_stripPin {\n  margin-bottom: 4px;\n  flex-shrink: 0;\n}\n.right_sidebar_dock_stripBtn:focus {\n  outline: none;\n}\n.right_sidebar_dock_stripBtn:focus-visible {\n  outline: 2px solid var(--vnsc-accent-strong, #2563eb);\n  outline-offset: -2px;\n}\n.right_sidebar_dock_stripBtnActive {\n  background: var(--vnsc-bg-selected, rgba(59, 130, 246, 0.15));\n  color: var(--vnsc-accent, #2962ff);\n}\n@media (max-width: 767px) {\n  .right_sidebar_dock_splitter {\n    display: none;\n  }\n  .right_sidebar_dock_dock {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: auto;\n    height: 45%;\n    min-height: 220px;\n    min-width: 0;\n    width: auto !important;\n    border-left: none;\n    border-top: 1px solid var(--vnsc-border, #2a2a2a);\n    z-index: 20;\n  }\n  .right_sidebar_dock_stripBtn {\n    min-width: 44px;\n    min-height: 44px;\n  }\n  .right_sidebar_dock_panelClose {\n    min-width: 44px;\n    min-height: 44px;\n  }\n}\n.right_sidebar_dock_dw {\n  padding: 8px 10px;\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n}\n.right_sidebar_dock_dwHead {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n.right_sidebar_dock_dwSymbol {\n  font-weight: 700;\n  font-size: 13px;\n  color: var(--vnsc-text-primary, #d1d4dc);\n}\n.right_sidebar_dock_dwTime {\n  font-size: 10px;\n  color: var(--vnsc-text-secondary, #787b86);\n}\n.right_sidebar_dock_dwRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 3px 0;\n  border-bottom: 1px solid var(--vnsc-border-divider, #2a2a2a);\n}\n.right_sidebar_dock_dwRow:last-child {\n  border-bottom: none;\n}\n.right_sidebar_dock_dwLabel {\n  color: var(--vnsc-text-secondary, #787b86);\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex-shrink: 1;\n}\n.right_sidebar_dock_dwValue {\n  font-weight: 600;\n  color: var(--vnsc-text-primary, #d1d4dc);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.right_sidebar_dock_dwUp {\n  color: var(--vnsc-color-bullish, rgb(38, 166, 154));\n}\n.right_sidebar_dock_dwDown {\n  color: var(--vnsc-color-bearish, rgb(239, 83, 80));\n}\n.right_sidebar_dock_dwSection {\n  margin-top: 8px;\n  padding-top: 6px;\n  border-top: 1px solid var(--vnsc-border-divider, #2a2a2a);\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--vnsc-text-secondary, #787b86);\n}\n.right_sidebar_dock_dwEmpty {\n  padding: 16px 12px;\n  font-size: 12px;\n  color: var(--vnsc-text-secondary, #787b86);\n  text-align: center;\n}\n\n.strategy_tester_panel {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  padding: 12px;\n  gap: 12px;\n  font-family: Inter, sans-serif;\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  color: var(--vnsc-text-primary, #e0e0e0);\n  background: var(--vnsc-bg-primary, #0c1017);\n}\n.strategy_tester_header {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  border-bottom: 1px solid var(--vnsc-border-divider, #202b3c);\n  padding-bottom: 10px;\n}\n.strategy_tester_title {\n  font-weight: bold;\n}\n.strategy_tester_select {\n  padding: 4px 8px;\n  background: var(--vnsc-bg-input, #131b26);\n  border: 1px solid var(--vnsc-border-input, #202b3c);\n  border-radius: 4px;\n  color: var(--vnsc-text-primary, #fff);\n}\n.strategy_tester_runBtn {\n  padding: 5px 12px;\n  background: var(--vnsc-accent, #2962ff);\n  border: none;\n  border-radius: 4px;\n  color: #fff;\n  font-weight: bold;\n  cursor: pointer;\n  margin-left: auto;\n  transition: background-color 0.2s ease;\n}\n.strategy_tester_runBtn:hover {\n  background: var(--vnsc-accent-hover, #1a52d6);\n}\n.strategy_tester_saveRunBtn {\n  align-self: flex-start;\n  padding: 6px 14px;\n  background: transparent;\n  border: 1px solid var(--vnsc-accent, #2962ff);\n  border-radius: 4px;\n  color: var(--vnsc-accent, #2962ff);\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n.strategy_tester_saveRunBtn:hover {\n  background: rgba(41, 98, 255, 0.12);\n}\n.strategy_tester_hintMark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 14px;\n  border: 1px solid var(--vnsc-text-secondary, #888);\n  border-radius: 50%;\n  font-size: 10px;\n  font-weight: bold;\n  color: var(--vnsc-text-secondary, #888);\n  cursor: help;\n  margin-left: 4px;\n  vertical-align: middle;\n}\n.strategy_tester_statsGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n}\n.strategy_tester_statCard {\n  padding: 10px;\n  background: var(--vnsc-bg-secondary, #131b26);\n  border-radius: 4px;\n  border: 1px solid var(--vnsc-border-divider, #202b3c);\n}\n.strategy_tester_statLabel {\n  color: var(--vnsc-text-secondary, #888);\n  font-size: 11px;\n  margin-bottom: 4px;\n}\n.strategy_tester_statValue {\n  font-size: 16px;\n  font-weight: bold;\n}\n.strategy_tester_statValuePositive {\n  color: var(--vnsc-color-bullish, #089981);\n}\n.strategy_tester_statValueNegative {\n  color: var(--vnsc-color-bearish, #f23645);\n}\n.strategy_tester_tradeLog {\n  flex: 1;\n  overflow-y: auto;\n  border: 1px solid var(--vnsc-border-divider, #202b3c);\n  border-radius: 4px;\n}\n.strategy_tester_tradeTable {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n}\n.strategy_tester_tradeTable th {\n  padding: 8px;\n  border-bottom: 1px solid var(--vnsc-border-divider, #202b3c);\n  color: var(--vnsc-text-secondary, #888);\n  background: var(--vnsc-bg-secondary, #131b26);\n  position: sticky;\n  top: 0;\n}\n.strategy_tester_tradeTable td {\n  padding: 8px;\n  border-bottom: 1px solid var(--vnsc-border-divider, #1c2430);\n}\n.strategy_tester_tradeTypeLong {\n  text-transform: uppercase;\n  color: var(--vnsc-accent, #2962ff);\n  font-weight: bold;\n}\n.strategy_tester_tradeTypeShort {\n  text-transform: uppercase;\n  color: var(--vnsc-color-warning, #ff6d00);\n  font-weight: bold;\n}\n.strategy_tester_tradePnlPositive {\n  color: var(--vnsc-color-bullish, #089981);\n  font-weight: bold;\n}\n.strategy_tester_tradePnlNegative {\n  color: var(--vnsc-color-bearish, #f23645);\n  font-weight: bold;\n}\n.strategy_tester_tradeDate {\n  color: var(--vnsc-text-secondary, #888);\n}\n.strategy_tester_emptyState {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--vnsc-text-muted, #555);\n  font-style: italic;\n}\n@media (max-width: 480px) {\n  .strategy_tester_panel {\n    padding: 8px;\n    gap: 8px;\n  }\n  .strategy_tester_statsGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .strategy_tester_header {\n    flex-wrap: wrap;\n  }\n  .strategy_tester_runBtn {\n    margin-left: 0;\n    margin-top: 8px;\n    width: 100%;\n  }\n}\n\n.symbol_search_wrapper {\n  position: relative;\n  min-width: min(380px, 100%);\n  flex: 1 1 380px;\n}\n.symbol_search_input {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1.5px solid var(--vnsc-border, #3a3e49);\n  background: var(--vnsc-surface, #1e222d);\n  color: var(--vnsc-text, #f8fafc);\n  font: inherit;\n  font-size: 12px;\n  line-height: 1.4;\n  padding: 8px 10px;\n  border-radius: 6px;\n  outline: none;\n  transition: border-color 100ms ease, box-shadow 100ms ease;\n}\n.symbol_search_input::placeholder {\n  color: var(--vnsc-text-secondary, #787b86);\n  opacity: 0.85;\n}\n.symbol_search_input:focus {\n  border-color: var(--vnsc-accent, #6366f1);\n  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);\n}\n.symbol_search_dropdown {\n  position: absolute;\n  z-index: 1000;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border: 1px solid var(--vnsc-accent, #6366f1);\n  border-radius: 10px;\n  background: var(--vnsc-bg-primary, #1e222d);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6), 0 0 0 2px rgba(99, 102, 241, 0.15);\n  max-height: min(60vh, 600px);\n  overflow: auto;\n}\n.symbol_search_dropdown ul {\n  margin: 0;\n  padding: 6px;\n  list-style: none;\n}\n.symbol_search_item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: var(--vnsc-text-secondary);\n  font-size: 12px;\n  transition: background 100ms ease, color 100ms ease;\n}\n.symbol_search_item:hover,\n.symbol_search_itemHighlighted {\n  background: var(--vnsc-bg-tertiary);\n  color: var(--vnsc-text-primary);\n}\n.symbol_search_itemDisabled,\n.symbol_search_itemDisabled:hover {\n  opacity: 0.45;\n  cursor: not-allowed;\n  background: transparent;\n}\n.symbol_search_currentBadge {\n  margin-left: auto;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 999px;\n  border: 1px solid var(--vnsc-border, #3a3e49);\n  color: var(--vnsc-text-secondary);\n  white-space: nowrap;\n}\n.symbol_search_symbol {\n  font-weight: 700;\n  color: inherit;\n}\n.symbol_search_name {\n  font-size: 11px;\n  color: inherit;\n}\n.symbol_search_exchangeBar {\n  display: flex;\n  gap: 4px;\n  padding: 6px 8px 4px;\n  border-bottom: 1px solid var(--vnsc-border);\n}\n.symbol_search_exBtn {\n  padding: 2px 8px;\n  border-radius: 4px;\n  border: 1px solid var(--vnsc-border);\n  background: transparent;\n  color: var(--vnsc-text-secondary);\n  font-size: 11px;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n}\n.symbol_search_exBtn:hover {\n  background: var(--vnsc-bg-tertiary);\n  color: var(--vnsc-text-primary);\n}\n.symbol_search_exBtnActive {\n  background: var(--vnsc-accent, #2962ff);\n  border-color: var(--vnsc-accent, #2962ff);\n  color: #fff;\n}\n.symbol_search_exBadge {\n  font-size: 9px;\n  font-weight: 700;\n  padding: 1px 4px;\n  border-radius: 3px;\n  background: var(--vnsc-bg-tertiary);\n  color: var(--vnsc-text-secondary);\n  flex-shrink: 0;\n}\n.symbol_search_exBadgeHose {\n  background: color-mix(in srgb, var(--vnsc-color-success) 18%, transparent);\n  color: var(--vnsc-color-success);\n}\n.symbol_search_exBadgeHnx {\n  background: color-mix(in srgb, var(--vnsc-color-info) 18%, transparent);\n  color: var(--vnsc-color-info);\n}\n.symbol_search_exBadgeUpcom {\n  background: color-mix(in srgb, var(--vnsc-color-warning) 18%, transparent);\n  color: var(--vnsc-color-warning);\n}\n.symbol_search_section {\n  padding: 6px 8px 4px;\n}\n.symbol_search_section + .symbol_search_section {\n  border-top: 1px solid var(--vnsc-border);\n}\n.symbol_search_sectionLabel {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--vnsc-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-bottom: 5px;\n}\n.symbol_search_chipRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 4px;\n}\n.symbol_search_chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  padding: 0 8px;\n  box-sizing: border-box;\n  border-radius: 4px;\n  border: 1px solid var(--vnsc-border);\n  background: rgba(255, 255, 255, 0.03);\n  color: var(--vnsc-text-primary);\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 120ms ease, border-color 120ms ease;\n}\n.symbol_search_chip:hover {\n  background: var(--vnsc-bg-tertiary);\n}\n.symbol_search_chipVn30 {\n  border-color: color-mix(in srgb, var(--vnsc-color-success) 35%, transparent);\n  color: var(--vnsc-color-success);\n}\n.symbol_search_chipVn30:hover {\n  background: color-mix(in srgb, var(--vnsc-color-success) 12%, transparent);\n}\n.symbol_search_chipFutures {\n  border-color: color-mix(in srgb, var(--vnsc-color-info) 35%, transparent);\n  color: var(--vnsc-color-info);\n}\n.symbol_search_chipFutures:hover {\n  background: color-mix(in srgb, var(--vnsc-color-info) 12%, transparent);\n}\n.symbol_search_chipCrypto {\n  border-color: color-mix(in srgb, var(--vnsc-color-warning) 35%, transparent);\n  color: var(--vnsc-color-warning);\n}\n.symbol_search_chipCrypto:hover {\n  background: color-mix(in srgb, var(--vnsc-color-warning) 12%, transparent);\n}\n.symbol_search_vn30Grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 6px;\n  margin-top: 4px;\n}\n.symbol_search_emptyState {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 12px;\n}\n.symbol_search_emptyText,\n.symbol_search_loadingText {\n  font-size: 12px;\n  color: var(--vnsc-text-secondary);\n}\n.symbol_search_colorDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n  flex-shrink: 0;\n}\n.symbol_search_overlayRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 0;\n}\n.symbol_search_overlayRowLeft {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n.symbol_search_addBtn {\n  padding: 2px 8px;\n  border: 1px solid color-mix(in srgb, var(--vnsc-color-success) 40%, transparent);\n  border-radius: 4px;\n  background: transparent;\n  color: var(--vnsc-color-success);\n  font-size: 11px;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.symbol_search_addBtn:hover {\n  background: color-mix(in srgb, var(--vnsc-color-success) 10%, transparent);\n}\n.symbol_search_removeBtn {\n  padding: 2px 8px;\n  border: 1px solid color-mix(in srgb, var(--vnsc-color-bearish) 40%, transparent);\n  border-radius: 4px;\n  background: transparent;\n  color: var(--vnsc-color-bearish);\n  font-size: 11px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.symbol_search_removeBtn:hover {\n  background: color-mix(in srgb, var(--vnsc-color-bearish) 10%, transparent);\n}\n.symbol_search_divider {\n  margin: 0;\n  border: none;\n  border-top: 1px solid var(--vnsc-border, #3a3e49);\n}\n@media (max-width: 480px) {\n  .symbol_search_wrapper {\n    min-width: 100%;\n  }\n  .symbol_search_dropdown {\n    left: 0;\n    right: 0;\n    max-height: 50vh;\n  }\n}\n.symbol_search_modalBackdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 5000;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 12vh 16px 16px;\n  background: var(--vnsc-bg-overlay, rgba(10, 14, 20, 0.85));\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n.symbol_search_modalPanel {\n  width: min(640px, 100%);\n  max-height: 70vh;\n  overflow: auto;\n  border: 1px solid var(--vnsc-accent, #6366f1);\n  border-radius: 12px;\n  background: var(--vnsc-bg-modal, #1e222d);\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6), 0 0 0 2px rgba(99, 102, 241, 0.15);\n}\n.symbol_search_dropdownFlat {\n  position: static;\n  z-index: auto;\n  margin: 8px 0 0;\n  padding: 0;\n  list-style: none;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  max-height: none;\n  overflow: visible;\n}\n.symbol_search_dropdownFlat ul {\n  margin: 0;\n  padding: 6px 0 0;\n  list-style: none;\n}\n.symbol_search_unifiedRowActions {\n  display: inline-flex;\n  gap: 4px;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n.symbol_search_switchBtn {\n  color: #fff;\n  border-color: var(--vnsc-accent, #6366f1);\n  background: rgba(99, 102, 241, 0.15);\n}\n.symbol_search_switchBtn:hover {\n  background: rgba(99, 102, 241, 0.3);\n}\n\n.tape_panel_panel {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 240px;\n  z-index: var(--vnsc-z-dock, 51);\n  background: var(--vnsc-bg-primary);\n  border-left: 1px solid var(--vnsc-border-primary);\n  display: flex;\n  flex-direction: column;\n  font-size: var(--vnsc-font-size-xs);\n  color: var(--vnsc-text-primary);\n  overflow: hidden;\n}\n.tape_panel_header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--vnsc-space-2);\n  border-bottom: 1px solid var(--vnsc-border-divider);\n  background: var(--vnsc-bg-secondary);\n  flex-shrink: 0;\n}\n.tape_panel_title {\n  font-weight: 700;\n  font-size: var(--vnsc-font-size-sm);\n}\n.tape_panel_closeBtn {\n  background: none;\n  border: none;\n  color: var(--vnsc-text-secondary);\n  cursor: pointer;\n  font-size: var(--vnsc-font-size-md);\n  padding: 0 4px;\n  transition: color 0.15s ease;\n}\n.tape_panel_closeBtn:hover {\n  color: var(--vnsc-text-primary);\n}\n.tape_panel_filterBar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  border-bottom: 1px solid var(--vnsc-border-divider);\n  flex-shrink: 0;\n}\n.tape_panel_filterLabel {\n  color: var(--vnsc-text-secondary);\n  white-space: nowrap;\n}\n.tape_panel_filterSlider {\n  flex: 1;\n  cursor: pointer;\n}\n.tape_panel_filterValue {\n  width: 38px;\n  text-align: right;\n  color: var(--vnsc-text-primary);\n  flex-shrink: 0;\n}\n.tape_panel_columnHeaders {\n  display: grid;\n  grid-template-columns: 52px 70px 52px 44px 22px;\n  padding: 2px 4px;\n  color: var(--vnsc-text-secondary);\n  font-size: var(--vnsc-font-size-2xs);\n  border-bottom: 1px solid var(--vnsc-border-divider);\n  flex-shrink: 0;\n}\n.tape_panel_entriesList {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.tape_panel_loading,\n.tape_panel_empty {\n  text-align: center;\n  color: var(--vnsc-text-secondary);\n  padding-top: 20px;\n}\n.tape_panel_row {\n  display: grid;\n  grid-template-columns: 52px 70px 52px 44px 22px;\n  height: 22px;\n  align-items: center;\n  padding: 0 4px;\n  background: transparent;\n  border-bottom: 1px solid var(--vnsc-border-divider);\n}\n.tape_panel_rowWhale {\n  background: color-mix(in srgb, var(--vnsc-color-warning) 15%, transparent);\n  border-bottom: 1px solid color-mix(in srgb, var(--vnsc-color-warning) 60%, transparent);\n}\n.tape_panel_rowTime {\n  color: var(--vnsc-text-secondary);\n  font-size: var(--vnsc-font-size-2xs);\n}\n.tape_panel_rowPrice {\n  text-align: right;\n  font-weight: 400;\n}\n.tape_panel_rowPriceBuy {\n  color: var(--vnsc-color-bullish);\n}\n.tape_panel_rowPriceSell {\n  color: var(--vnsc-color-bearish);\n}\n.tape_panel_rowPriceWhale {\n  font-weight: 700;\n}\n.tape_panel_rowVolume {\n  text-align: right;\n  color: var(--vnsc-text-secondary);\n}\n.tape_panel_rowValue {\n  text-align: right;\n  color: var(--vnsc-text-secondary);\n}\n.tape_panel_rowValueWhale {\n  color: var(--vnsc-color-warning);\n}\n.tape_panel_rowSide {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 14px;\n  width: 16px;\n  border-radius: 2px;\n  font-size: var(--vnsc-font-size-2xs);\n  font-weight: 700;\n}\n.tape_panel_rowSideBuy {\n  background: color-mix(in srgb, var(--vnsc-color-bullish) 35%, transparent);\n  color: var(--vnsc-text-on-primary);\n}\n.tape_panel_rowSideSell {\n  background: var(--vnsc-color-bearish);\n  color: var(--vnsc-text-on-primary);\n}\n.tape_panel_rowSideUnknown {\n  background: color-mix(in srgb, var(--vnsc-text-secondary) 30%, transparent);\n  color: var(--vnsc-text-primary);\n}\n.tape_panel_footer {\n  padding: 4px 8px;\n  border-top: 1px solid var(--vnsc-border-divider);\n  color: var(--vnsc-text-secondary);\n  font-size: var(--vnsc-font-size-2xs);\n  flex-shrink: 0;\n}\n@media (max-width: 480px) {\n  .tape_panel_panel {\n    width: 100%;\n    height: auto;\n    max-height: 40%;\n    bottom: 0;\n    top: auto;\n    right: 0;\n    border-left: none;\n    border-top: 1px solid var(--vnsc-border-primary);\n  }\n}\n\n.timeframe_footer_timeframeFooter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 3px 8px;\n  background: var(--vnsc-bg-secondary, transparent);\n  border-top: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\n  z-index: 30;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  scrollbar-width: none;\n  font-family: var(--vnsc-font-family-base, \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: var(--vnsc-text-secondary, #787b86);\n}\n.timeframe_footer_timeframeChips {\n  display: flex;\n  gap: 2px;\n  flex-shrink: 0;\n}\n.timeframe_footer_tfChip {\n  padding: 2px 6px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--vnsc-text-secondary, #787b86);\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 500;\n  font-family: inherit;\n  transition:\n    color 0.15s ease,\n    border-color 0.15s ease,\n    background 0.15s ease;\n}\n.timeframe_footer_tfChip:hover {\n  color: var(--vnsc-text-primary, #d1d4dc);\n  border-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.12));\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\n}\n.timeframe_footer_tfChipActive {\n  background: var(--vnsc-accent-strong, #2563eb);\n  color: #fff;\n  font-weight: 600;\n  border-color: var(--vnsc-accent-strong, #2563eb);\n  box-shadow: none;\n}\n.timeframe_footer_tfChipActive:hover {\n  background: var(--vnsc-accent-strong, #2563eb);\n  color: #fff;\n  border-color: var(--vnsc-accent-hover, #1e4bd8);\n}\n.timeframe_footer_separator {\n  width: 1px;\n  height: 14px;\n  background: var(--vnsc-border, rgba(255, 255, 255, 0.08));\n}\n.timeframe_footer_rangeChips {\n  display: flex;\n  gap: 2px;\n  flex-shrink: 0;\n}\n.timeframe_footer_rangeChip {\n  padding: 2px 6px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--vnsc-text-secondary, #787b86);\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 500;\n  font-family: inherit;\n  transition:\n    color 0.15s ease,\n    border-color 0.15s ease,\n    background 0.15s ease;\n}\n.timeframe_footer_rangeChip:hover {\n  color: var(--vnsc-text-primary, #d1d4dc);\n  border-color: var(--vnsc-border-secondary, rgba(255, 255, 255, 0.12));\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\n}\n.timeframe_footer_rangeChipActive {\n  background: var(--vnsc-accent-strong, #2563eb);\n  color: #fff;\n  font-weight: 600;\n  border-color: var(--vnsc-accent-strong, #2563eb);\n  box-shadow: none;\n}\n.timeframe_footer_rangeChipActive:hover {\n  background: var(--vnsc-accent-strong, #2563eb);\n  color: #fff;\n  border-color: var(--vnsc-accent-hover, #1e4bd8);\n}\n.timeframe_footer_footerChildren {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n.timeframe_footer_groupCaption {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--vnsc-text-muted, #6b7280);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  align-self: center;\n  margin-right: 2px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n@media (max-width: 1280px) {\n  .timeframe_footer_groupCaption {\n    display: none;\n  }\n}\n.timeframe_footer_rightCluster {\n  margin-left: auto;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-shrink: 0;\n}\n.timeframe_footer_footerChildren + .timeframe_footer_rightCluster {\n  margin-left: 0;\n}\n.timeframe_footer_scaleGroup {\n  display: flex;\n  gap: 2px;\n  padding: 2px;\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\n  border-radius: 6px;\n  background: transparent;\n}\n.timeframe_footer_scaleBtn {\n  padding: 2px 6px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--vnsc-text-secondary, #787b86);\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 500;\n  font-family: inherit;\n  font-variant-numeric: tabular-nums;\n}\n.timeframe_footer_scaleBtn:hover {\n  color: var(--vnsc-text-primary, #d1d4dc);\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\n}\n.timeframe_footer_scaleBtnActive {\n  background: var(--vnsc-accent-strong, #2563eb);\n  color: var(--vnsc-text-on-primary, #ffffff);\n  font-weight: 600;\n}\n.timeframe_footer_tzBadge {\n  padding: 2px 6px;\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  font-family: inherit;\n  color: var(--vnsc-text-secondary, #787b86);\n  background: var(--vnsc-bg-hover, transparent);\n  white-space: nowrap;\n}\n.timeframe_footer_clockText {\n  font-size: 11px;\n  font-weight: 500;\n  font-family: var(--vnsc-font-family-mono, ui-monospace, monospace);\n  color: var(--vnsc-text-primary, #d1d4dc);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.timeframe_footer_countdownText {\n  font-variant-numeric: tabular-nums;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 11px;\n  font-weight: 600;\n  font-family: var(--vnsc-font-family-mono, ui-monospace, monospace);\n  color: var(--vnsc-accent, #2962ff);\n  white-space: nowrap;\n}\n.timeframe_footer_countdownGlyph {\n  font-size: 10px;\n  opacity: 0.7;\n}\n.timeframe_footer_trademark {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 8px;\n  font-size: 11px;\n  font-weight: 500;\n  font-family: inherit;\n  color: var(--vnsc-text-muted, #6b7280);\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n  opacity: 0.9;\n}\n.timeframe_footer_trademark:hover {\n  color: var(--vnsc-text-secondary, #787b86);\n  opacity: 1;\n}\n.timeframe_footer_trademarkIcon {\n  font-size: 11px;\n  color: var(--vnsc-accent, #2962ff);\n  opacity: 0.7;\n}\n.timeframe_footer_trademarkIcon:hover {\n  color: var(--vnsc-accent, #2962ff);\n  opacity: 1;\n}\n@media (max-width: 480px) {\n  .timeframe_footer_timeframeFooter {\n    padding: 4px 8px;\n    gap: 8px;\n  }\n  .timeframe_footer_tfChip,\n  .timeframe_footer_rangeChip {\n    padding: 2px 6px;\n    font-size: 10px;\n  }\n  .timeframe_footer_separator {\n    height: 12px;\n  }\n}\n\n.watchlist_panel_root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n.watchlist_panel_colHead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  background: var(--vnsc-bg-primary, #131722);\n  border-bottom: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));\n  font-size: 10px;\n  color: var(--vnsc-text-secondary, #787b86);\n  font-variant-numeric: tabular-nums;\n}\n.watchlist_panel_colHeadName {\n  flex: 1;\n  min-width: 0;\n}\n.watchlist_panel_col {\n  flex-shrink: 0;\n  width: 50px;\n  text-align: right;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.watchlist_panel_list {\n  display: flex;\n  flex-direction: column;\n  padding: 4px 4px 12px;\n  gap: 1px;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: var(--vnsc-border, #2a3550) transparent;\n}\n.watchlist_panel_list::-webkit-scrollbar {\n  width: 8px;\n}\n.watchlist_panel_list::-webkit-scrollbar-thumb {\n  background: var(--vnsc-border, #2a3550);\n  border-radius: 8px;\n}\n.watchlist_panel_list::-webkit-scrollbar-corner {\n  background: transparent;\n}\n.watchlist_panel_row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  min-height: 34px;\n  padding: 3px 8px;\n  background: transparent;\n  border: none;\n  border-bottom: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));\n  border-radius: 0;\n  cursor: pointer;\n  text-align: left;\n  font-variant-numeric: tabular-nums;\n}\n.watchlist_panel_row:last-child {\n  border-bottom: none;\n}\n.watchlist_panel_row:hover {\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\n}\n.watchlist_panel_row:focus {\n  outline: none;\n}\n.watchlist_panel_row:focus-visible {\n  outline: 2px solid var(--vnsc-accent-strong, #2563eb);\n  outline-offset: -2px;\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.04));\n}\n.watchlist_panel_rowActive {\n  background: var(--vnsc-bg-selected, rgba(59, 130, 246, 0.15));\n}\n.watchlist_panel_symBlock {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n}\n.watchlist_panel_sym {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--vnsc-text-primary, #d1d4dc);\n  white-space: nowrap;\n}\n.watchlist_panel_name {\n  font-size: 10px;\n  color: var(--vnsc-text-secondary, #787b86);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.watchlist_panel_spark {\n  flex-shrink: 0;\n  color: var(--vnsc-text-secondary, #787b86);\n}\n.watchlist_panel_cell {\n  flex-shrink: 0;\n  width: 50px;\n  min-width: 0;\n  text-align: right;\n  font-size: 11px;\n  color: var(--vnsc-text-primary, #d1d4dc);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.watchlist_panel_up {\n  color: var(--vnsc-color-bullish, rgb(38, 166, 154));\n}\n.watchlist_panel_down {\n  color: var(--vnsc-color-bearish, rgb(239, 83, 80));\n}\n.watchlist_panel_empty {\n  padding: 16px 12px;\n  font-size: 12px;\n  color: var(--vnsc-text-secondary, #787b86);\n  text-align: center;\n}\n.watchlist_panel_details {\n  position: sticky;\n  bottom: 0;\n  z-index: 1;\n  margin-top: auto;\n  padding: 8px;\n  background: var(--vnsc-bg-primary, #131722);\n  border-top: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));\n}\n.watchlist_panel_detailsHead {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n.watchlist_panel_detailsSymBlock {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n.watchlist_panel_detailsSym {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--vnsc-text-primary, #d1d4dc);\n  white-space: nowrap;\n}\n.watchlist_panel_detailsName {\n  font-size: 10px;\n  color: var(--vnsc-text-secondary, #787b86);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.watchlist_panel_detailsQuote {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  flex-shrink: 0;\n}\n.watchlist_panel_detailsLast {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--vnsc-text-primary, #d1d4dc);\n}\n.watchlist_panel_detailsChg,\n.watchlist_panel_detailsPct {\n  font-size: 10px;\n  color: var(--vnsc-text-secondary, #787b86);\n}\n.watchlist_panel_detailGrid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 4px;\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px solid var(--vnsc-border-divider, rgba(42, 42, 42, 0.6));\n}\n.watchlist_panel_detailCell {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.watchlist_panel_detailLabel {\n  font-size: 9px;\n  color: var(--vnsc-text-secondary, #787b86);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.watchlist_panel_detailValue {\n  font-size: 10px;\n  color: var(--vnsc-text-primary, #d1d4dc);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.watchlist_panel_detailsEmpty {\n  padding-top: 6px;\n  font-size: 10px;\n  color: var(--vnsc-text-secondary, #787b86);\n  text-align: center;\n}\n\n.whale_panel_panel {\n}\n.whale_panel_title {\n}\n.whale_panel_net {\n}\n.whale_panel_netPositive {\n}\n.whale_panel_netNegative {\n}\n.whale_panel_table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.whale_panel_table th {\n  padding: 8px;\n  text-align: left;\n  color: var(--vnsc-text-secondary);\n  font-size: 11px;\n  font-weight: 600;\n  border-bottom: 1px solid var(--vnsc-border);\n}\n.whale_panel_table td {\n  padding: 8px;\n  border-bottom: 1px solid var(--vnsc-border);\n}\n.whale_panel_rowLabel {\n  font-weight: 500;\n  color: var(--vnsc-text-primary);\n}\n.whale_panel_buy {\n  color: #089981;\n  font-weight: 600;\n  text-align: right;\n}\n.whale_panel_sell {\n  color: #f23645;\n  font-weight: 600;\n  text-align: right;\n}\n@media (max-width: 480px) {\n  .whale_panel_panel {\n  }\n}\n\n/* src/widget/styles/tokens/colors.css */\n.vnsc-root {\n  --vnsc-color-primary: #3b82f6;\n  --vnsc-color-primary-hover: #2563eb;\n  --vnsc-color-primary-active: #1d4ed8;\n  --vnsc-color-primary-muted: rgba(59, 130, 246, 0.15);\n  --vnsc-color-accent: #2962ff;\n  --vnsc-color-accent-hover: #1e4bd8;\n  --vnsc-primary: #2962ff;\n  --vnsc-primary-hover: #1a52e0;\n  --vnsc-color-success: #22a85e;\n  --vnsc-color-success-hover: #1e8a49;\n  --vnsc-color-warning: #e67e22;\n  --vnsc-color-warning-hover: #d46e1a;\n  --vnsc-color-error: #c0392b;\n  --vnsc-color-error-hover: #a93226;\n  --vnsc-color-info: #3b82f6;\n  --vnsc-bg: var(--vnsc-bg-primary);\n  --vnsc-bg-primary: #131722;\n  --vnsc-bg-primary-rgba: rgba(19, 23, 34, 0.85);\n  --vnsc-bg-secondary: #1e222d;\n  --vnsc-bg-tertiary: #131722;\n  --vnsc-bg-elevated: #1f2937;\n  --vnsc-bg-overlay: rgba(10, 14, 20, 0.85);\n  --vnsc-bg-modal: #1e222d;\n  --vnsc-bg-popover: #1a1f2e;\n  --vnsc-bg-tooltip: #1f2937;\n  --vnsc-bg-input: #1a1f2e;\n  --vnsc-bg-input-hover: #1f2937;\n  --vnsc-bg-input-focus: #1f2937;\n  --vnsc-bg-disabled: #1a1f2e;\n  --vnsc-bg-hover: rgba(255, 255, 255, 0.04);\n  --vnsc-bg-active: rgba(255, 255, 255, 0.08);\n  --vnsc-bg-selected: rgba(59, 130, 246, 0.15);\n  --vnsc-bg-focus: rgba(59, 130, 246, 0.2);\n  --vnsc-text-primary: #d1d4dc;\n  --vnsc-text-secondary: #787b86;\n  --vnsc-text-tertiary: #50535e;\n  --vnsc-text-muted: #4e5263;\n  --vnsc-text-inverse: #0a0e14;\n  --vnsc-text-link: #3b82f6;\n  --vnsc-text-link-hover: #60a5fa;\n  --vnsc-text-disabled: #4a4a4a;\n  --vnsc-text-placeholder: #606060;\n  --vnsc-text-on-primary: #ffffff;\n  --vnsc-text-on-accent: #ffffff;\n  --vnsc-surface: var(--vnsc-bg-secondary);\n  --vnsc-text: var(--vnsc-text-primary);\n  --vnsc-border-primary: #2a2a2a;\n  --vnsc-border-secondary: #3a3a3a;\n  --vnsc-border-focus: #3b82f6;\n  --vnsc-border-error: #c0392b;\n  --vnsc-border-success: #22a85e;\n  --vnsc-border-warning: #e67e22;\n  --vnsc-border-input: #2a2a2a;\n  --vnsc-border-input-hover: #3a3a3a;\n  --vnsc-border-input-focus: #3b82f6;\n  --vnsc-border-divider: #2a2a2a;\n  --vnsc-border-overlay: rgba(255, 255, 255, 0.1);\n  --vnsc-color-bullish: rgb(38, 166, 154);\n  --vnsc-color-bearish: rgb(239, 83, 80);\n  --vnsc-color-neutral: #6c757d;\n  --vnsc-color-volume: rgba(59, 130, 246, 0.3);\n  --vnsc-color-grid: rgba(255, 255, 255, 0.05);\n  --vnsc-color-grid-subtle: rgba(255, 255, 255, 0.025);\n  --vnsc-color-crosshair: #2962ff;\n  --vnsc-color-selection: rgba(41, 98, 255, 0.2);\n  --vnsc-grid-dash: \"\";\n  --vnsc-grid-width: 1;\n  --vnsc-accent: var(--vnsc-color-accent);\n  --vnsc-accent-hover: var(--vnsc-color-accent-hover);\n  --vnsc-accent-strong: #2563eb;\n  --vnsc-border: var(--vnsc-border-primary);\n  --vnsc-up: var(--vnsc-color-bullish);\n  --vnsc-down: var(--vnsc-color-bearish);\n  --vnsc-color-whale-buy: var(--vnsc-color-bullish);\n  --vnsc-color-whale-sell: var(--vnsc-color-bearish);\n  --vnsc-color-cvd-positive: var(--vnsc-color-bullish);\n  --vnsc-color-cvd-negative: var(--vnsc-color-bearish);\n  --vnsc-color-darkflow-strong: #7c3aed;\n  --vnsc-color-darkflow-weak: #a855f7;\n  --vnsc-drawing-color-default: #3b82f6;\n  --vnsc-drawing-color-selected: #fbbf24;\n  --vnsc-drawing-color-hover: #60a5fa;\n  --vnsc-drawing-color-locked: #6c757d;\n  --vnsc-drawing-color-hidden: #4a4a4a;\n  --vnsc-scrollbar-track: transparent;\n  --vnsc-scrollbar-thumb: #3a3a3a;\n  --vnsc-scrollbar-thumb-hover: #4a4a4a;\n  --vnsc-scrollbar-corner: transparent;\n  --vnsc-accent-subtle: rgba(41, 98, 255, 0.15);\n  --vnsc-focus-ring: 0 0 0 3px rgba(96, 165, 250, 0.6);\n  --vnsc-focus-ring-offset: 2px;\n}\n.vnsc-root[data-chart-mode=light] {\n  --vnsc-bg: var(--vnsc-bg-primary);\n  --vnsc-bg-primary: #ffffff;\n  --vnsc-bg-primary-rgba: rgba(255, 255, 255, 0.85);\n  --vnsc-bg-secondary: #f8fafc;\n  --vnsc-bg-tertiary: #f1f5f9;\n  --vnsc-bg-elevated: #ffffff;\n  --vnsc-bg-overlay: rgba(255, 255, 255, 0.95);\n  --vnsc-bg-modal: #ffffff;\n  --vnsc-bg-popover: #f8fafc;\n  --vnsc-bg-tooltip: #1e293b;\n  --vnsc-bg-input: #ffffff;\n  --vnsc-bg-input-hover: #f8fafc;\n  --vnsc-bg-input-focus: #ffffff;\n  --vnsc-bg-disabled: #f1f5f9;\n  --vnsc-bg-hover: rgba(0, 0, 0, 0.04);\n  --vnsc-bg-active: rgba(0, 0, 0, 0.08);\n  --vnsc-bg-selected: rgba(59, 130, 246, 0.1);\n  --vnsc-bg-focus: rgba(59, 130, 246, 0.15);\n  --vnsc-text: #1e293b;\n  --vnsc-text-primary: #0f172a;\n  --vnsc-text-secondary: #475569;\n  --vnsc-text-tertiary: #94a3b8;\n  --vnsc-text-muted: #64748b;\n  --vnsc-text-inverse: #ffffff;\n  --vnsc-text-link: #2563eb;\n  --vnsc-text-link-hover: #1d4ed8;\n  --vnsc-text-disabled: #cbd5e1;\n  --vnsc-text-placeholder: #94a3b8;\n  --vnsc-text-on-primary: #ffffff;\n  --vnsc-text-on-accent: #ffffff;\n  --vnsc-surface: #ffffff;\n  --vnsc-accent: #2563eb;\n  --vnsc-accent-hover: #1d4ed8;\n  --vnsc-accent-strong: #2563eb;\n  --vnsc-border: var(--vnsc-border-primary);\n  --vnsc-border-primary: #e2e8f0;\n  --vnsc-border-secondary: #cbd5e1;\n  --vnsc-border-focus: #2563eb;\n  --vnsc-border-input: #e2e8f0;\n  --vnsc-border-input-hover: #cbd5e1;\n  --vnsc-border-input-focus: #2563eb;\n  --vnsc-border-divider: #e2e8f0;\n  --vnsc-border-overlay: rgba(0, 0, 0, 0.1);\n  --vnsc-color-grid: rgba(150, 160, 180, 0.07);\n  --vnsc-color-grid-subtle: rgba(150, 160, 180, 0.035);\n  --vnsc-color-crosshair: #2563eb;\n  --vnsc-color-selection: rgba(37, 99, 235, 0.15);\n  --vnsc-scrollbar-track: transparent;\n  --vnsc-scrollbar-thumb: #cbd5e1;\n  --vnsc-scrollbar-thumb-hover: #94a3b8;\n  --vnsc-focus-ring: 0 0 0 3px rgba(37, 99, 235, 0.55);\n  --vnsc-focus-ring-offset: 2px;\n}\n.vnsc-root[data-chart-theme=classic-dark] {\n  --vnsc-bg-primary: #0F1720;\n  --vnsc-bg-primary-rgba: rgba(15, 23, 32, 0.85);\n  --vnsc-bg-secondary: #07101A;\n  --vnsc-bg-tertiary: #0F1925;\n  --vnsc-bg-elevated: #122433;\n  --vnsc-bg-overlay: rgba(7, 16, 26, 0.9);\n  --vnsc-bg-modal: #07101A;\n  --vnsc-bg-popover: #0F1720;\n  --vnsc-bg-tooltip: #122433;\n  --vnsc-bg-input: #0F1720;\n  --vnsc-bg-input-hover: #122433;\n  --vnsc-bg-hover: rgba(77, 166, 255, 0.06);\n  --vnsc-bg-active: rgba(77, 166, 255, 0.1);\n  --vnsc-bg-selected: rgba(77, 166, 255, 0.15);\n  --vnsc-text-primary: #B8C7D6;\n  --vnsc-text-secondary: #7A8B9E;\n  --vnsc-text-muted: #4E6273;\n  --vnsc-accent: #4DA6FF;\n  --vnsc-accent-hover: #3690E8;\n  --vnsc-accent-strong: #2B7CD4;\n  --vnsc-border-primary: #122433;\n  --vnsc-border-divider: #122433;\n  --vnsc-border-overlay: rgba(77, 166, 255, 0.15);\n  --vnsc-color-grid: rgba(255, 255, 255, 0.05);\n  --vnsc-color-grid-subtle: rgba(255, 255, 255, 0.025);\n  --vnsc-color-crosshair: #4DA6FF;\n  --vnsc-color-selection: rgba(77, 166, 255, 0.15);\n  --vnsc-accent-subtle: rgba(77, 166, 255, 0.15);\n}\n.vnsc-root[data-chart-theme=trading-night] {\n  --vnsc-bg-primary: #071226;\n  --vnsc-bg-primary-rgba: rgba(7, 18, 38, 0.85);\n  --vnsc-bg-secondary: #041022;\n  --vnsc-bg-tertiary: #071A30;\n  --vnsc-bg-elevated: #083044;\n  --vnsc-bg-overlay: rgba(4, 16, 34, 0.9);\n  --vnsc-bg-modal: #041022;\n  --vnsc-bg-popover: #071226;\n  --vnsc-bg-tooltip: #083044;\n  --vnsc-bg-input: #071226;\n  --vnsc-bg-input-hover: #083044;\n  --vnsc-bg-hover: rgba(0, 163, 255, 0.07);\n  --vnsc-bg-active: rgba(0, 163, 255, 0.12);\n  --vnsc-bg-selected: rgba(0, 163, 255, 0.18);\n  --vnsc-text-primary: #A9D6FF;\n  --vnsc-text-secondary: #6B9BC0;\n  --vnsc-text-muted: #3E6E91;\n  --vnsc-accent: #00A3FF;\n  --vnsc-accent-hover: #0090E0;\n  --vnsc-accent-strong: #0284C7;\n  --vnsc-border-primary: #083044;\n  --vnsc-border-divider: #083044;\n  --vnsc-border-overlay: rgba(0, 163, 255, 0.15);\n  --vnsc-color-grid: rgba(255, 255, 255, 0.05);\n  --vnsc-color-grid-subtle: rgba(255, 255, 255, 0.025);\n  --vnsc-color-crosshair: #00A3FF;\n  --vnsc-color-selection: rgba(0, 163, 255, 0.15);\n  --vnsc-color-bullish: #00C48C;\n  --vnsc-color-bearish: #FF4D6D;\n  --vnsc-accent-subtle: rgba(0, 163, 255, 0.15);\n}\n.vnsc-root[data-chart-theme=modern-light] {\n  --vnsc-accent: #0B74DE;\n  --vnsc-accent-hover: #095BB8;\n  --vnsc-accent-strong: #0B74DE;\n  --vnsc-color-crosshair: #0B74DE;\n  --vnsc-color-selection: rgba(11, 116, 222, 0.12);\n  --vnsc-color-bullish: #1E8A3A;\n  --vnsc-color-bearish: #D64545;\n  --vnsc-accent-subtle: rgba(11, 116, 222, 0.12);\n}\n.vnsc-root[data-chart-theme=neutral-pro] {\n  --vnsc-bg-primary: #FAFBFC;\n  --vnsc-bg-primary-rgba: rgba(250, 251, 252, 0.85);\n  --vnsc-bg-secondary: #F4F6F8;\n  --vnsc-bg-tertiary: #EEF0F2;\n  --vnsc-bg-elevated: #FFFFFF;\n  --vnsc-bg-overlay: rgba(244, 246, 248, 0.95);\n  --vnsc-bg-modal: #FFFFFF;\n  --vnsc-bg-popover: #F4F6F8;\n  --vnsc-bg-input: #FFFFFF;\n  --vnsc-bg-input-hover: #F4F6F8;\n  --vnsc-bg-hover: rgba(43, 108, 176, 0.05);\n  --vnsc-bg-active: rgba(43, 108, 176, 0.1);\n  --vnsc-bg-selected: rgba(43, 108, 176, 0.15);\n  --vnsc-text-primary: #2C3E50;\n  --vnsc-text-secondary: #64748B;\n  --vnsc-text-muted: #94A3B8;\n  --vnsc-accent: #2B6CB0;\n  --vnsc-accent-hover: #234F86;\n  --vnsc-accent-strong: #2B6CB0;\n  --vnsc-border-primary: #E6EDF5;\n  --vnsc-border-divider: #E6EDF5;\n  --vnsc-border-overlay: rgba(43, 108, 176, 0.1);\n  --vnsc-color-grid: rgba(150, 160, 180, 0.07);\n  --vnsc-color-grid-subtle: rgba(150, 160, 180, 0.035);\n  --vnsc-color-crosshair: #2B6CB0;\n  --vnsc-color-selection: rgba(43, 108, 176, 0.12);\n  --vnsc-accent-subtle: rgba(43, 108, 176, 0.12);\n}\n.vnsc-root[data-chart-theme=high-contrast] {\n  --vnsc-bg-primary: #000000;\n  --vnsc-bg-secondary: #0d0d0d;\n  --vnsc-bg-tertiary: #000000;\n  --vnsc-bg-elevated: #1a1a1a;\n  --vnsc-bg-overlay: rgba(0, 0, 0, 0.95);\n  --vnsc-bg-modal: #0d0d0d;\n  --vnsc-bg-popover: #0d0d0d;\n  --vnsc-bg-tooltip: #1a1a1a;\n  --vnsc-bg-input: #000000;\n  --vnsc-bg-hover: rgba(255, 255, 255, 0.12);\n  --vnsc-bg-active: rgba(255, 255, 255, 0.2);\n  --vnsc-bg-selected: rgba(255, 255, 255, 0.18);\n  --vnsc-bg-focus: rgba(59, 130, 246, 0.35);\n  --vnsc-text-primary: #ffffff;\n  --vnsc-text-secondary: #e0e0e0;\n  --vnsc-text-tertiary: #b0b0b0;\n  --vnsc-text-muted: #c0c0c0;\n  --vnsc-text-link: #FFD700;\n  --vnsc-text-link-hover: #FFC700;\n  --vnsc-text-disabled: #808080;\n  --vnsc-text-placeholder: #909090;\n  --vnsc-text-on-primary: #000000;\n  --vnsc-text-on-accent: #000000;\n  --vnsc-border-primary: #ffffff;\n  --vnsc-border-secondary: #e0e0e0;\n  --vnsc-border-divider: #ffffff;\n  --vnsc-border-focus: #FFD700;\n  --vnsc-border-overlay: rgba(255, 255, 255, 0.3);\n  --vnsc-color-primary: #FFD700;\n  --vnsc-color-primary-hover: #FFC700;\n  --vnsc-color-primary-active: #FFE033;\n  --vnsc-color-accent: #FFD700;\n  --vnsc-color-accent-hover: #FFC700;\n  --vnsc-accent-strong: #7A6200;\n  --vnsc-accent-subtle: rgba(255, 215, 0, 0.15);\n  --vnsc-color-bullish: #00ff66;\n  --vnsc-color-bearish: #ff3333;\n  --vnsc-color-neutral: #cccccc;\n  --vnsc-color-grid: rgba(255, 255, 255, 0.15);\n  --vnsc-color-grid-subtle: rgba(255, 255, 255, 0.08);\n  --vnsc-color-crosshair: #FFD700;\n  --vnsc-color-selection: rgba(255, 215, 0, 0.35);\n  --vnsc-color-whale-buy: #00ff66;\n  --vnsc-color-whale-sell: #ff3333;\n  --vnsc-color-success: #00ff66;\n  --vnsc-color-success-hover: #33ff88;\n  --vnsc-color-warning: #ffcc00;\n  --vnsc-color-warning-hover: #ffdd33;\n  --vnsc-color-error: #ff3333;\n  --vnsc-color-error-hover: #ff6666;\n  --vnsc-color-info: #60a5fa;\n  --vnsc-scrollbar-thumb: #606060;\n  --vnsc-scrollbar-thumb-hover: #909090;\n  --vnsc-focus-ring: 0 0 0 3px rgba(96, 165, 250, 0.6);\n  --vnsc-focus-ring-offset: 2px;\n}\n\n/* src/widget/styles/tokens/spacing.css */\n.vnsc-root {\n  --vnsc-space-0: 0;\n  --vnsc-space-1: 4px;\n  --vnsc-space-2: 8px;\n  --vnsc-space-3: 12px;\n  --vnsc-space-4: 16px;\n  --vnsc-space-5: 20px;\n  --vnsc-space-6: 24px;\n  --vnsc-space-8: 32px;\n  --vnsc-space-10: 40px;\n  --vnsc-space-12: 48px;\n  --vnsc-space-16: 64px;\n  --vnsc-space-xs: 4px;\n  --vnsc-space-sm: 8px;\n  --vnsc-space-md: 16px;\n  --vnsc-space-lg: 24px;\n  --vnsc-space-xl: 32px;\n  --vnsc-space-2xl: 40px;\n  --vnsc-space-3xl: 48px;\n  --vnsc-space-toolbar-gap: 8px;\n  --vnsc-space-toolbar-padding: 8px;\n  --vnsc-space-panel-padding: 16px;\n  --vnsc-space-modal-padding: 24px;\n  --vnsc-space-drawing-gap: 4px;\n  --vnsc-space-dock-padding: 12px;\n  --vnsc-space-splitter-size: 4px;\n  --vnsc-space-header-height: 36px;\n  --vnsc-space-footer-height: 28px;\n  --vnsc-space-panel-height: 300px;\n  --vnsc-radius-none: 0;\n  --vnsc-radius-xs: 2px;\n  --vnsc-radius-sm: 4px;\n  --vnsc-radius-md: 6px;\n  --vnsc-radius-lg: 8px;\n  --vnsc-radius-xl: 12px;\n  --vnsc-radius-2xl: 16px;\n  --vnsc-radius-full: 9999px;\n  --vnsc-radius-button: 4px;\n  --vnsc-radius-input: 4px;\n  --vnsc-radius-card: 8px;\n  --vnsc-radius-modal: 12px;\n  --vnsc-radius-popover: 8px;\n  --vnsc-radius-tooltip: 6px;\n  --vnsc-size-xs: 16px;\n  --vnsc-size-sm: 24px;\n  --vnsc-size-md: 32px;\n  --vnsc-size-lg: 40px;\n  --vnsc-size-xl: 48px;\n  --vnsc-size-2xl: 56px;\n  --vnsc-size-3xl: 64px;\n  --vnsc-icon-xs: 12px;\n  --vnsc-icon-sm: 16px;\n  --vnsc-icon-md: 20px;\n  --vnsc-icon-lg: 24px;\n  --vnsc-icon-xl: 28px;\n  --vnsc-btn-height-sm: 24px;\n  --vnsc-btn-height-md: 32px;\n  --vnsc-btn-height-lg: 40px;\n  --vnsc-btn-padding-x-sm: 8px;\n  --vnsc-btn-padding-x-md: 12px;\n  --vnsc-btn-padding-x-lg: 16px;\n  --vnsc-input-height-sm: 24px;\n  --vnsc-input-height-md: 32px;\n  --vnsc-input-height-lg: 40px;\n  --vnsc-input-padding-x: 10px;\n  --vnsc-chart-margin-top: 8px;\n  --vnsc-chart-margin-right: 12px;\n  --vnsc-chart-margin-bottom: 32px;\n  --vnsc-chart-margin-left: 12px;\n  --vnsc-pane-min-height: 60px;\n  --vnsc-pane-handle-size: 4px;\n  --vnsc-tooltip-padding: 8px 12px;\n  --vnsc-tooltip-gap: 4px;\n}\n\n/* src/widget/styles/tokens/typography.css */\n.vnsc-root {\n  --vnsc-font-family-base:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    \"Helvetica Neue\",\n    Arial,\n    sans-serif;\n  --vnsc-font-family-mono:\n    \"JetBrains Mono\",\n    \"Fira Code\",\n    \"Consolas\",\n    \"Monaco\",\n    monospace;\n  --vnsc-font-family-display:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif;\n  --vnsc-font-family-ui: var(--vnsc-font-family-base);\n  --vnsc-font-family: var(--vnsc-font-family-base);\n  --vnsc-font-mono: var(--vnsc-font-family-mono);\n  --vnsc-font-size-2xs: 10px;\n  --vnsc-font-size-xs: 11px;\n  --vnsc-font-size-sm: 12px;\n  --vnsc-font-size-base: 13px;\n  --vnsc-font-size-md: 14px;\n  --vnsc-font-size-lg: 16px;\n  --vnsc-font-size-xl: 18px;\n  --vnsc-font-size-2xl: 20px;\n  --vnsc-font-size-3xl: 24px;\n  --vnsc-font-size-4xl: 30px;\n  --vnsc-font-2xs: var(--vnsc-font-size-2xs);\n  --vnsc-font-xs: var(--vnsc-font-size-xs);\n  --vnsc-font-sm: var(--vnsc-font-size-sm);\n  --vnsc-font-base: var(--vnsc-font-size-base);\n  --vnsc-font-md: var(--vnsc-font-size-md);\n  --vnsc-font-lg: var(--vnsc-font-size-lg);\n  --vnsc-font-xl: var(--vnsc-font-size-xl);\n  --vnsc-font-size-caption: 10px;\n  --vnsc-font-size-overline: 10px;\n  --vnsc-font-size-body-sm: 12px;\n  --vnsc-font-size-body: 13px;\n  --vnsc-font-size-body-lg: 14px;\n  --vnsc-font-size-heading-sm: 14px;\n  --vnsc-font-size-heading: 16px;\n  --vnsc-font-size-heading-lg: 18px;\n  --vnsc-font-size-display: 24px;\n  --vnsc-font-weight-light: 300;\n  --vnsc-font-weight-normal: 400;\n  --vnsc-font-weight-medium: 500;\n  --vnsc-font-weight-semibold: 600;\n  --vnsc-font-weight-bold: 700;\n  --vnsc-font-weight-extrabold: 800;\n  --vnsc-font-weight-regular: 400;\n  --vnsc-font-weight-body: 400;\n  --vnsc-font-weight-heading: 600;\n  --vnsc-font-weight-button: 500;\n  --vnsc-line-height-none: 1;\n  --vnsc-line-height-tight: 1.25;\n  --vnsc-line-height-snug: 1.375;\n  --vnsc-line-height-normal: 1.5;\n  --vnsc-line-height-relaxed: 1.625;\n  --vnsc-line-height-loose: 2;\n  --vnsc-line-height-heading: 1.25;\n  --vnsc-line-height-body: 1.5;\n  --vnsc-line-height-code: 1.6;\n  --vnsc-letter-spacing-tight: -0.02em;\n  --vnsc-letter-spacing-normal: 0;\n  --vnsc-letter-spacing-wide: 0.02em;\n  --vnsc-letter-spacing-wider: 0.04em;\n  --vnsc-letter-spacing-widest: 0.1em;\n  --vnsc-letter-spacing-heading: -0.02em;\n  --vnsc-letter-spacing-button: 0.02em;\n  --vnsc-letter-spacing-caption: 0.04em;\n  --vnsc-typography-toolbar: var(--vnsc-font-size-sm) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);\n  --vnsc-typography-panel-title: var(--vnsc-font-size-base) / var(--vnsc-line-height-tight) var(--vnsc-font-family-ui);\n  --vnsc-typography-panel-body: var(--vnsc-font-size-sm) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);\n  --vnsc-typography-modal-title: var(--vnsc-font-size-lg) / var(--vnsc-line-height-tight) var(--vnsc-font-family-display);\n  --vnsc-typography-modal-body: var(--vnsc-font-size-base) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);\n  --vnsc-typography-tooltip: var(--vnsc-font-size-xs) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);\n  --vnsc-typography-button: var(--vnsc-font-size-sm) / var(--vnsc-line-height-none) var(--vnsc-font-family-ui);\n  --vnsc-typography-input: var(--vnsc-font-size-sm) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);\n  --vnsc-typography-label: var(--vnsc-font-size-xs) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);\n  --vnsc-typography-chart-axis: var(--vnsc-font-size-xs) / var(--vnsc-line-height-normal) var(--vnsc-font-family-mono);\n  --vnsc-typography-chart-tooltip: var(--vnsc-font-size-sm) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);\n  --vnsc-typography-chart-price: var(--vnsc-font-size-base) / var(--vnsc-line-height-tight) var(--vnsc-font-family-mono);\n  --vnsc-typography-drawing-label: var(--vnsc-font-size-xs) / var(--vnsc-line-height-normal) var(--vnsc-font-family-ui);\n}\n\n/* src/widget/styles/tokens/shadows.css */\n.vnsc-root {\n  --vnsc-shadow-none: none;\n  --vnsc-shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --vnsc-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);\n  --vnsc-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --vnsc-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --vnsc-shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  --vnsc-shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  --vnsc-shadow-inner: inset 0 2px 4px rgba(0, 0, 0, 0.06);\n  --vnsc-shadow-primary: 0 4px 14px rgba(59, 130, 246, 0.4);\n  --vnsc-shadow-primary-lg: 0 10px 25px rgba(59, 130, 246, 0.3);\n  --vnsc-shadow-success: 0 4px 14px rgba(34, 168, 94, 0.4);\n  --vnsc-shadow-error: 0 4px 14px rgba(192, 57, 43, 0.4);\n  --vnsc-shadow-warning: 0 4px 14px rgba(230, 126, 34, 0.4);\n  --vnsc-shadow-focus: 0 0 0 3px rgba(59, 130, 246, 0.4);\n  --vnsc-shadow-focus-error: 0 0 0 3px rgba(192, 57, 43, 0.4);\n  --vnsc-shadow-focus-success: 0 0 0 3px rgba(34, 168, 94, 0.4);\n  --vnsc-elevation-0: var(--vnsc-shadow-none);\n  --vnsc-elevation-1: var(--vnsc-shadow-sm);\n  --vnsc-elevation-2: var(--vnsc-shadow-md);\n  --vnsc-elevation-3: var(--vnsc-shadow-lg);\n  --vnsc-elevation-4: var(--vnsc-shadow-xl);\n  --vnsc-elevation-5: var(--vnsc-shadow-2xl);\n  --vnsc-shadow-toolbar: var(--vnsc-elevation-2);\n  --vnsc-shadow-panel: var(--vnsc-elevation-3);\n  --vnsc-shadow-modal: var(--vnsc-elevation-4);\n  --vnsc-shadow-popover: var(--vnsc-elevation-3);\n  --vnsc-shadow-tooltip: var(--vnsc-elevation-2);\n  --vnsc-shadow-dropdown: var(--vnsc-elevation-3);\n  --vnsc-shadow-dock: 0 10px 30px rgba(0, 0, 0, 0.3);\n  --vnsc-shadow-drawing: 0 2px 8px rgba(0, 0, 0, 0.2);\n  --vnsc-shadow-splitter: none;\n  --vnsc-shadow-chart-container: var(--vnsc-elevation-1);\n}\n.vnsc-root[data-chart-mode=light] {\n  --vnsc-shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --vnsc-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);\n  --vnsc-shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -1px rgba(0, 0, 0, 0.04);\n  --vnsc-shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.03);\n  --vnsc-shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.03);\n  --vnsc-shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.15);\n  --vnsc-shadow-inner: inset 0 2px 4px rgba(0, 0, 0, 0.04);\n  --vnsc-shadow-focus: 0 0 0 3px rgba(37, 99, 235, 0.4);\n  --vnsc-shadow-focus-error: 0 0 0 3px rgba(192, 57, 43, 0.4);\n  --vnsc-shadow-focus-success: 0 0 0 3px rgba(34, 168, 94, 0.4);\n  --vnsc-shadow-dock: 0 10px 30px rgba(0, 0, 0, 0.15);\n  --vnsc-shadow-drawing: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* src/widget/styles/tokens/motion.css */\n.vnsc-root {\n  --vnsc-transition-duration-instant: 0ms;\n  --vnsc-transition-duration-fast: 100ms;\n  --vnsc-transition-duration-normal: 200ms;\n  --vnsc-transition-duration-slow: 300ms;\n  --vnsc-transition-duration-slower: 500ms;\n  --vnsc-transition-duration-hover: 150ms;\n  --vnsc-transition-duration-focus: 100ms;\n  --vnsc-transition-duration-press: 50ms;\n  --vnsc-transition-duration-enter: 200ms;\n  --vnsc-transition-duration-exit: 150ms;\n  --vnsc-transition-duration-modal: 200ms;\n  --vnsc-transition-duration-tooltip: 100ms;\n  --vnsc-transition-duration-panel: 300ms;\n  --vnsc-transition-easing-linear: linear;\n  --vnsc-transition-easing-ease-in: cubic-bezier(0.4, 0, 1, 1);\n  --vnsc-transition-easing-ease-out: cubic-bezier(0, 0, 0.2, 1);\n  --vnsc-transition-easing-ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n  --vnsc-transition-easing-spring: cubic-bezier(0.34, 1.56, 0.64, 1);\n  --vnsc-transition-easing-bounce: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  --vnsc-transition-easing-default: var(--vnsc-transition-easing-ease-out);\n  --vnsc-transition-easing-enter: var(--vnsc-transition-easing-ease-out);\n  --vnsc-transition-easing-exit: var(--vnsc-transition-easing-ease-in);\n  --vnsc-transition-easing-spring: var(--vnsc-transition-easing-spring);\n  --vnsc-transition-property-all: all;\n  --vnsc-transition-property-colors:\n    color,\n    background-color,\n    border-color,\n    fill,\n    stroke;\n  --vnsc-transition-property-transform: transform;\n  --vnsc-transition-property-opacity: opacity;\n  --vnsc-transition-property-shadow: box-shadow;\n  --vnsc-transition-property-visibility: visibility;\n  --vnsc-transition-fast: var(--vnsc-transition-duration-fast) var(--vnsc-transition-easing-default);\n  --vnsc-transition-normal: var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-default);\n  --vnsc-transition-slow: var(--vnsc-transition-duration-slow) var(--vnsc-transition-easing-default);\n  --vnsc-transition-colors-fast: var(--vnsc-transition-property-colors) var(--vnsc-transition-duration-fast) var(--vnsc-transition-easing-default);\n  --vnsc-transition-colors-normal: var(--vnsc-transition-property-colors) var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-default);\n  --vnsc-transition-transform-fast: var(--vnsc-transition-property-transform) var(--vnsc-transition-duration-fast) var(--vnsc-transition-easing-spring);\n  --vnsc-transition-transform-normal: var(--vnsc-transition-property-transform) var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-spring);\n  --vnsc-transition-opacity-fast: var(--vnsc-transition-property-opacity) var(--vnsc-transition-duration-fast) var(--vnsc-transition-easing-default);\n  --vnsc-transition-opacity-normal: var(--vnsc-transition-property-opacity) var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-default);\n  --vnsc-transition-shadow-fast: var(--vnsc-transition-property-shadow) var(--vnsc-transition-duration-fast) var(--vnsc-transition-easing-default);\n  --vnsc-transition-shadow-normal: var(--vnsc-transition-property-shadow) var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-default);\n  --vnsc-transition-button: var(--vnsc-transition-colors-fast), var(--vnsc-transition-transform-fast);\n  --vnsc-transition-input: var(--vnsc-transition-colors-fast), var(--vnsc-transition-shadow-fast);\n  --vnsc-transition-panel: var(--vnsc-transition-transform-normal), var(--vnsc-transition-opacity-normal);\n  --vnsc-transition-modal: var(--vnsc-transition-transform-normal), var(--vnsc-transition-opacity-normal);\n  --vnsc-transition-tooltip: var(--vnsc-transition-opacity-fast), var(--vnsc-transition-transform-fast);\n  --vnsc-transition-dropdown: var(--vnsc-transition-transform-normal), var(--vnsc-transition-opacity-normal);\n  --vnsc-transition-drawing: var(--vnsc-transition-transform-fast), var(--vnsc-transition-opacity-fast);\n  --vnsc-transition-splitter: var(--vnsc-transition-transform-fast);\n  --vnsc-transition-chart: var(--vnsc-transition-transform-normal);\n  --vnsc-animation-duration-spin: 1000ms;\n  --vnsc-animation-duration-pulse: 2000ms;\n  --vnsc-animation-duration-bounce: 1000ms;\n  --vnsc-animation-duration-shimmer: 1500ms;\n  --vnsc-animation-spin: spin var(--vnsc-animation-duration-spin) linear infinite;\n  --vnsc-animation-pulse: pulse var(--vnsc-animation-duration-pulse) ease-in-out infinite;\n  --vnsc-animation-bounce: bounce var(--vnsc-animation-duration-bounce) var(--vnsc-transition-easing-bounce) infinite;\n  --vnsc-animation-shimmer: shimmer var(--vnsc-animation-duration-shimmer) ease-in-out infinite;\n  --vnsc-animation-fade-in: fadeIn var(--vnsc-transition-duration-enter) var(--vnsc-transition-easing-enter);\n  --vnsc-animation-fade-out: fadeOut var(--vnsc-transition-duration-exit) var(--vnsc-transition-easing-exit);\n  --vnsc-animation-slide-up: slideUp var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-enter);\n  --vnsc-animation-slide-down: slideDown var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-enter);\n  --vnsc-animation-slide-left: slideLeft var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-enter);\n  --vnsc-animation-slide-right: slideRight var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-enter);\n  --vnsc-animation-scale-in: scaleIn var(--vnsc-transition-duration-normal) var(--vnsc-transition-easing-spring);\n  --vnsc-animation-scale-out: scaleOut var(--vnsc-transition-duration-exit) var(--vnsc-transition-easing-exit);\n}\n@media (prefers-reduced-motion: reduce) {\n  .vnsc-root {\n    --vnsc-transition-duration-instant: 0ms;\n    --vnsc-transition-duration-fast: 0ms;\n    --vnsc-transition-duration-normal: 0ms;\n    --vnsc-transition-duration-slow: 0ms;\n    --vnsc-transition-duration-slower: 0ms;\n    --vnsc-transition-duration-hover: 0ms;\n    --vnsc-transition-duration-focus: 0ms;\n    --vnsc-transition-duration-press: 0ms;\n    --vnsc-transition-duration-enter: 0ms;\n    --vnsc-transition-duration-exit: 0ms;\n    --vnsc-transition-duration-modal: 0ms;\n    --vnsc-transition-duration-tooltip: 0ms;\n    --vnsc-transition-duration-panel: 0ms;\n    --vnsc-animation-duration-spin: 0ms;\n    --vnsc-animation-duration-pulse: 0ms;\n    --vnsc-animation-duration-bounce: 0ms;\n    --vnsc-animation-duration-shimmer: 0ms;\n  }\n  .vnsc-root *,\n  .vnsc-root *::before,\n  .vnsc-root *::after {\n    animation-iteration-count: 1 !important;\n    scroll-behavior: auto !important;\n  }\n}\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@keyframes slideUp {\n  from {\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes slideDown {\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n@keyframes slideLeft {\n  from {\n    transform: translateX(10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n@keyframes slideRight {\n  from {\n    transform: translateX(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n@keyframes scaleIn {\n  from {\n    transform: scale(0.95);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n@keyframes scaleOut {\n  from {\n    transform: scale(1);\n    opacity: 1;\n  }\n  to {\n    transform: scale(0.95);\n    opacity: 0;\n  }\n}\n\n/* src/widget/styles/tokens/z-index.css */\n.vnsc-root {\n  --vnsc-z-0: 0;\n  --vnsc-z-1: 1;\n  --vnsc-z-2: 2;\n  --vnsc-z-3: 3;\n  --vnsc-z-4: 4;\n  --vnsc-z-5: 5;\n  --vnsc-z-10: 10;\n  --vnsc-z-20: 20;\n  --vnsc-z-30: 30;\n  --vnsc-z-40: 40;\n  --vnsc-z-50: 50;\n  --vnsc-z-background: 0;\n  --vnsc-z-content: 1;\n  --vnsc-z-raised: 10;\n  --vnsc-z-overlay: 20;\n  --vnsc-z-modal: 30;\n  --vnsc-z-popover: 40;\n  --vnsc-z-tooltip: 50;\n  --vnsc-z-toast: 60;\n  --vnsc-z-maximum: 9999;\n  --vnsc-z-chart-canvas: 1;\n  --vnsc-z-chart-overlay: 10;\n  --vnsc-z-chart-crosshair: 15;\n  --vnsc-z-chart-tooltip: 20;\n  --vnsc-z-chart-drawing: 25;\n  --vnsc-z-chart-selection: 30;\n  --vnsc-z-chart-measurement: 35;\n  --vnsc-z-chart-x-axis: 40;\n  --vnsc-z-chart-pane-tooltip: 45;\n  --vnsc-z-toolbar: 50;\n  --vnsc-z-header: 55;\n  --vnsc-z-footer: 55;\n  --vnsc-z-dock: 60;\n  --vnsc-z-dock-flyout: 65;\n  --vnsc-z-drawing-toolbar: 70;\n  --vnsc-z-drawing-inspector: 75;\n  --vnsc-z-drawing-list: 75;\n  --vnsc-z-drawing-context-menu: 80;\n  --vnsc-z-panel: 85;\n  --vnsc-z-panel-content: 90;\n  --vnsc-z-modal-backdrop: 95;\n  --vnsc-z-modal: 100;\n  --vnsc-z-modal-content: 105;\n  --vnsc-z-popover: 110;\n  --vnsc-z-popover-content: 115;\n  --vnsc-z-tooltip: 120;\n  --vnsc-z-tooltip-content: 125;\n  --vnsc-z-toast: 130;\n  --vnsc-z-toast-content: 135;\n  --vnsc-z-ads-banner: 95;\n  --vnsc-z-ads-popup: 99;\n  --vnsc-z-trademark: 100;\n  --vnsc-z-sidebar: 48;\n  --vnsc-z-sidebar-splitter: 49;\n  --vnsc-z-sidebar-content: 50;\n  --vnsc-z-bottom-panel: 40;\n  --vnsc-z-bottom-panel-content: 41;\n  --vnsc-z-drawing-dock: 50;\n  --vnsc-z-drawing-dock-header: 51;\n  --vnsc-z-drawing-dock-content: 52;\n  --vnsc-z-drawing-dock-flyout: 55;\n  --vnsc-z-settings-modal: 100;\n  --vnsc-z-settings-modal-content: 101;\n  --vnsc-z-settings-modal-tabs: 102;\n  --vnsc-z-snapshot-modal: 100;\n  --vnsc-z-snapshot-modal-content: 101;\n  --vnsc-z-alerts-modal: 100;\n  --vnsc-z-alerts-modal-content: 101;\n  --vnsc-z-symbol-search: 80;\n  --vnsc-z-symbol-search-results: 81;\n  --vnsc-z-whale-panel: 60;\n  --vnsc-z-whale-panel-content: 61;\n  --vnsc-z-context-rail: 55;\n  --vnsc-z-context-rail-content: 56;\n  --vnsc-z-pat-modal: 100;\n  --vnsc-z-pat-modal-content: 101;\n}\n\n/* src/widget/styles/tokens/opacity.css */\n.vnsc-root {\n  --vnsc-opacity-disabled: 0.38;\n  --vnsc-opacity-hover: 0.04;\n  --vnsc-opacity-focus: 0.12;\n  --vnsc-opacity-pressed: 0.16;\n  --vnsc-opacity-dragging: 0.08;\n  --vnsc-opacity-overlay: 0.5;\n  --vnsc-opacity-backdrop: 0.85;\n  --vnsc-opacity-watermark: 0.05;\n  --vnsc-opacity-skeleton-base: 0.08;\n  --vnsc-opacity-skeleton-highlight: 0.15;\n}\n\n/* src/widget/styles/tokens/focus.css */\n.vnsc-root {\n  --vnsc-ring-width: 2px;\n  --vnsc-ring-offset: 2px;\n  --vnsc-ring-color: var(--vnsc-color-primary);\n  --vnsc-ring-opacity: 0.4;\n}\n\n/* src/widget/styles/tokens/surfaces.css */\n.vnsc-root {\n  --vnsc-surface-0: var(--vnsc-bg-primary);\n  --vnsc-surface-1: var(--vnsc-bg-secondary);\n  --vnsc-surface-2: var(--vnsc-bg-tertiary);\n  --vnsc-surface-3: var(--vnsc-bg-elevated);\n  --vnsc-surface-4: var(--vnsc-bg-elevated);\n}\n.vnsc-root[data-chart-mode=light] {\n  --vnsc-surface-4: #e2e8f0;\n}\n\n/* src/widget/styles/tokens/states.css */\n.vnsc-root {\n  --vnsc-state-hover: var(--vnsc-bg-hover);\n  --vnsc-state-active: var(--vnsc-bg-active);\n  --vnsc-state-pressed: rgba(255, 255, 255, 0.12);\n  --vnsc-state-dragging: rgba(59, 130, 246, 0.08);\n  --vnsc-state-loading: var(--vnsc-bg-disabled);\n  --vnsc-state-selected: var(--vnsc-bg-selected);\n  --vnsc-state-focus-within: var(--vnsc-bg-focus);\n}\n.vnsc-root[data-chart-mode=light] {\n  --vnsc-state-pressed: rgba(0, 0, 0, 0.12);\n  --vnsc-state-dragging: rgba(37, 99, 235, 0.08);\n}\n\n/* src/widget/styles/tokens/backdrop.css */\n.vnsc-root {\n  --vnsc-backdrop-blur-sm: 4px;\n  --vnsc-backdrop-blur-md: 8px;\n  --vnsc-backdrop-blur-lg: 16px;\n  --vnsc-backdrop-blur-xl: 24px;\n  --vnsc-backdrop-saturate: 1.8;\n  --vnsc-backdrop-brightness: 0.7;\n}\n\n/* src/widget/styles/tokens/indicators.css */\n.vnsc-root {\n  --vnsc-indicator-1: #2962ff;\n  --vnsc-indicator-2: #ff6d00;\n  --vnsc-indicator-3: #e040fb;\n  --vnsc-indicator-4: #00bcd4;\n  --vnsc-indicator-5: #ffeb3b;\n  --vnsc-indicator-6: #4caf50;\n  --vnsc-indicator-7: #ff5252;\n  --vnsc-indicator-8: #7c4dff;\n  --vnsc-indicator-9: #00e676;\n  --vnsc-indicator-10: #ff9100;\n  --vnsc-macd-signal: #ff6d00;\n  --vnsc-macd-histogram-positive: var(--vnsc-color-bullish);\n  --vnsc-macd-histogram-negative: var(--vnsc-color-bearish);\n  --vnsc-bb-upper: #2962ff;\n  --vnsc-bb-lower: #2962ff;\n  --vnsc-bb-fill: rgba(41, 98, 255, 0.06);\n}\n\n/* src/widget/styles/tokens/gradients.css */\n.vnsc-root {\n  --vnsc-gradient-area-fill:\n    linear-gradient(\n      180deg,\n      rgba(41,98,255,0.28) 0%,\n      rgba(41,98,255,0) 100%);\n  --vnsc-gradient-volume-fade:\n    linear-gradient(\n      180deg,\n      var(--vnsc-color-volume),\n      transparent);\n  --vnsc-gradient-shimmer:\n    linear-gradient(\n      90deg,\n      transparent 0%,\n      rgba(255,255,255,0.05) 50%,\n      transparent 100%);\n}\n\n/* src/widget/styles/tokens/breakpoints.css */\n.vnsc-root {\n  --vnsc-breakpoint-compact: 480px;\n  --vnsc-breakpoint-medium: 768px;\n  --vnsc-breakpoint-wide: 1200px;\n  --vnsc-breakpoint-ultra: 1920px;\n}\n\n/* src/widget/styles/tokens/presets/midnight-blue.css */\n.vnsc-root[data-chart-theme=midnight-blue] {\n  --vnsc-bg-primary: #0d1117;\n  --vnsc-bg-secondary: #161b22;\n  --vnsc-bg-tertiary: #0d1117;\n  --vnsc-bg-elevated: #1c2333;\n  --vnsc-bg-overlay: rgba(13, 17, 23, 0.9);\n  --vnsc-bg-modal: #161b22;\n  --vnsc-bg-popover: #161b22;\n  --vnsc-bg-tooltip: #1c2333;\n  --vnsc-bg-input: #0d1117;\n  --vnsc-bg-input-hover: #161b22;\n  --vnsc-bg-hover: rgba(88, 166, 255, 0.08);\n  --vnsc-bg-active: rgba(88, 166, 255, 0.14);\n  --vnsc-bg-selected: rgba(88, 166, 255, 0.2);\n  --vnsc-bg-focus: rgba(88, 166, 255, 0.25);\n  --vnsc-text-primary: #c9d1d9;\n  --vnsc-text-secondary: #8b949e;\n  --vnsc-text-tertiary: #484f58;\n  --vnsc-text-link: #58a6ff;\n  --vnsc-text-link-hover: #79c0ff;\n  --vnsc-border-primary: #21262d;\n  --vnsc-border-secondary: #30363d;\n  --vnsc-border-divider: #21262d;\n  --vnsc-color-primary: #58a6ff;\n  --vnsc-color-primary-hover: #79c0ff;\n  --vnsc-color-primary-active: #79c0ff;\n  --vnsc-color-accent: #58a6ff;\n  --vnsc-color-accent-hover: #79c0ff;\n  --vnsc-color-grid: rgba(255, 255, 255, 0.07);\n  --vnsc-color-grid-subtle: rgba(255, 255, 255, 0.03);\n  --vnsc-color-crosshair: #58a6ff;\n  --vnsc-color-selection: rgba(88, 166, 255, 0.2);\n  --vnsc-scrollbar-thumb: #30363d;\n  --vnsc-scrollbar-thumb-hover: #484f58;\n}\n\n/* src/widget/styles/tokens/index.css */\n\n/* src/widget/styles/pane-overlays.css */\n.vnsc-pane-label,\n.rsc-pane-label {\n  position: absolute;\n  left: 0;\n  width: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  font-size: 9px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: var(--vnsc-text-micro, #7c8798);\n  pointer-events: none;\n  user-select: none;\n  z-index: 10;\n}\n.vnsc-pane-header,\n.rsc-pane-header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 4px;\n  padding: 0;\n  background: transparent;\n  border-bottom: none;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 150ms ease;\n  z-index: 50;\n  min-width: 0;\n}\n.vnsc-pane-wrap:hover .vnsc-pane-header,\n.vnsc-pane-wrap:focus-within .vnsc-pane-header,\n.vnsc-pane-wrap--active .vnsc-pane-header,\n.rsc-pane-wrap:hover .rsc-pane-header,\n.rsc-pane-wrap:focus-within .rsc-pane-header,\n.rsc-pane-wrap--active .rsc-pane-header {\n  opacity: 1;\n  pointer-events: auto;\n}\n.vnsc-pane-header__label,\n.rsc-pane-header__label {\n  display: inline-flex;\n  align-items: center;\n  min-height: 16px;\n  padding: 0 6px;\n  border-radius: 3px;\n  background: color-mix(in srgb, var(--vnsc-surface, var(--vnsc-bg, #131722)) 90%, transparent);\n  border: 1px solid color-mix(in srgb, var(--vnsc-border, rgba(148, 163, 184, 0.24)) 100%, transparent);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  color: var(--vnsc-text-secondary, #787b86);\n  flex-shrink: 0;\n}\n.vnsc-pane-header__content,\n.rsc-pane-header__content {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n.vnsc-pane-header__actions,\n.rsc-pane-header__actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  min-height: 16px;\n  padding: 0 4px;\n  border-radius: 4px;\n  background: color-mix(in srgb, var(--vnsc-surface, var(--vnsc-bg, #131722)) 90%, transparent);\n  border: 1px solid color-mix(in srgb, var(--vnsc-border, rgba(148, 163, 184, 0.24)) 100%, transparent);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  margin-left: auto;\n  margin-right: 0;\n  flex-shrink: 0;\n}\n.vnsc-pane-btn,\n.rsc-pane-btn {\n  border: 1px solid transparent;\n  background: transparent;\n  color: var(--vnsc-text-secondary, #787b86);\n  padding: 1px 4px;\n  border-radius: 3px;\n  cursor: pointer;\n  font: inherit;\n  line-height: 1;\n  font-size: 12px;\n  transition: color 0.15s ease, border-color 0.15s ease;\n}\n.vnsc-pane-btn:hover,\n.rsc-pane-btn:hover {\n  color: var(--vnsc-text-primary, #d1d4dc);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n.vnsc-pane-btn:disabled,\n.rsc-pane-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  border-color: transparent;\n}\n.vnsc-pane-wrap,\n.rsc-pane-wrap {\n  overflow: visible;\n}\n.vnsc-series-picker,\n.rsc-series-picker {\n  position: absolute;\n  min-width: 340px;\n  max-width: min(480px, calc(100vw - 24px));\n  box-sizing: border-box;\n  padding: 6px;\n  border-radius: 10px;\n  background: var(--vnsc-surface, rgba(255, 255, 255, 0.98));\n  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.24));\n  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.18);\n  z-index: 70;\n}\n.vnsc-series-picker__search,\n.rsc-series-picker__search {\n  padding: 4px 6px 8px;\n}\n.vnsc-series-picker__search-input,\n.rsc-series-picker__search-input {\n  width: 100%;\n  padding: 6px 10px;\n  border-radius: var(--vnsc-radius-sm, 4px);\n  border: 1px solid var(--vnsc-border-input, #2a2a2a);\n  background: var(--vnsc-bg-input, #1a1f2e);\n  color: var(--vnsc-text-primary, #e0e0e0);\n  font-size: var(--vnsc-font-sm, 12px);\n  outline: none;\n  box-sizing: border-box;\n}\n.vnsc-series-picker__search-input:focus,\n.rsc-series-picker__search-input:focus {\n  border-color: var(--vnsc-accent, #2962ff);\n}\n.vnsc-series-picker__search-input::placeholder,\n.rsc-series-picker__search-input::placeholder {\n  color: var(--vnsc-text-muted, #64748b);\n}\n.vnsc-series-picker__list,\n.rsc-series-picker__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 320px;\n  overflow: auto;\n}\n.vnsc-series-picker__item,\n.rsc-series-picker__item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 6px 10px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--vnsc-text, #1e2a3b);\n  text-align: left;\n  cursor: pointer;\n  font-size: 13px;\n  font-family: inherit;\n  line-height: 1.4;\n}\n.vnsc-series-picker__item:hover,\n.rsc-series-picker__item:hover {\n  background: rgba(45, 156, 219, 0.12);\n}\n.vnsc-series-picker__item--active,\n.rsc-series-picker__item--active {\n  background: rgba(45, 156, 219, 0.16);\n}\n.vnsc-series-picker__label,\n.rsc-series-picker__label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.vnsc-series-picker__check,\n.rsc-series-picker__check {\n  font-size: 12px;\n  color: #2d9cdb;\n  flex-shrink: 0;\n}\n.vnsc-series-picker__empty,\n.rsc-series-picker__empty {\n  padding: 16px 10px;\n  text-align: center;\n  color: var(--vnsc-text-muted, #64748b);\n  font-size: 13px;\n}\n.vnsc-series-picker__footer,\n.rsc-series-picker__footer {\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px solid rgba(148, 163, 184, 0.18);\n  font-size: 11px;\n  color: var(--vnsc-text-muted, #64748b);\n}\n.vnsc-indicator-legend,\n.rsc-indicator-legend {\n  position: absolute;\n  top: 24px;\n  left: 80px;\n  right: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 4px 0;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 150ms ease;\n  z-index: 15;\n}\n.vnsc-pane-header__legend,\n.rsc-pane-header__legend {\n  display: flex;\n  position: static;\n  top: auto;\n  left: auto;\n  right: auto;\n  flex: 1 1 auto;\n  min-width: 0;\n  max-height: 16px;\n  align-items: center;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n  gap: 3px;\n  padding: 0;\n  opacity: 1;\n  pointer-events: auto;\n  transition: none;\n  z-index: auto;\n  scrollbar-width: none;\n}\n.vnsc-pane-header__legend::-webkit-scrollbar,\n.rsc-pane-header__legend::-webkit-scrollbar {\n  display: none;\n}\n.vnsc-pane-wrap:hover .vnsc-indicator-legend,\n.vnsc-pane-wrap:focus-within .vnsc-indicator-legend,\n.vnsc-pane-wrap--active .vnsc-indicator-legend,\n.rsc-pane-wrap:hover .rsc-indicator-legend,\n.rsc-pane-wrap:focus-within .rsc-indicator-legend,\n.rsc-pane-wrap--active .rsc-indicator-legend {\n  opacity: 1;\n  pointer-events: auto;\n}\n.vnsc-indicator-chip,\n.rsc-indicator-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 0 5px;\n  height: 16px;\n  line-height: 1;\n  box-sizing: border-box;\n  border-radius: 4px;\n  background: var(--vnsc-surface, rgba(255, 255, 255, 0.92));\n  border: 1px solid var(--vnsc-border, rgba(148, 163, 184, 0.24));\n  font-size: 9px;\n  font-weight: 500;\n  color: var(--vnsc-text, #1e2a3b);\n  cursor: default;\n  user-select: none;\n  white-space: nowrap;\n}\n.vnsc-indicator-chip--hidden,\n.rsc-indicator-chip--hidden {\n  opacity: 0.45;\n}\n.vnsc-indicator-chip__dot,\n.rsc-indicator-chip__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: var(--chip-color, #2962ff);\n  flex-shrink: 0;\n}\n.vnsc-indicator-chip__name,\n.rsc-indicator-chip__name {\n  white-space: nowrap;\n}\n.vnsc-indicator-chip__suffix,\n.rsc-indicator-chip__suffix {\n  margin-left: 3px;\n  font-size: 8px;\n  font-weight: 600;\n  color: var(--chip-color, #2962ff);\n}\n.vnsc-indicator-chip__btn,\n.rsc-indicator-chip__btn {\n  border: 0;\n  background: transparent;\n  color: inherit;\n  padding: 0 1px;\n  cursor: pointer;\n  font-size: 10px;\n  line-height: 1;\n  border-radius: 2px;\n  display: flex;\n  align-items: center;\n}\n.vnsc-indicator-chip__btn:hover,\n.rsc-indicator-chip__btn:hover {\n  background: rgba(148, 163, 184, 0.18);\n}\n.vnsc-indicator-chip__btn--remove,\n.rsc-indicator-chip__btn--remove {\n  opacity: 0.5;\n}\n.vnsc-indicator-chip__btn--remove:hover,\n.rsc-indicator-chip__btn--remove:hover {\n  opacity: 1;\n  color: #f23645;\n  background: rgba(242, 54, 69, 0.08);\n}\n@media (hover: hover) {\n  .vnsc-indicator-chip__btn,\n  .rsc-indicator-chip__btn {\n    width: 0;\n    max-width: 0;\n    padding: 0;\n    margin: 0;\n    overflow: hidden;\n    opacity: 0;\n    transform: scale(0.8);\n    transition:\n      width 140ms ease,\n      max-width 140ms ease,\n      margin 140ms ease,\n      opacity 120ms ease,\n      transform 140ms ease;\n  }\n  .vnsc-indicator-chip:hover .vnsc-indicator-chip__btn,\n  .rsc-indicator-chip:hover .rsc-indicator-chip__btn,\n  .vnsc-indicator-chip:focus-within .vnsc-indicator-chip__btn,\n  .rsc-indicator-chip:focus-within .rsc-indicator-chip__btn,\n  .vnsc-indicator-chip__btn:focus-visible,\n  .rsc-indicator-chip__btn:focus-visible {\n    width: 14px;\n    max-width: 14px;\n    margin-left: 2px;\n    opacity: 0.7;\n    transform: scale(1);\n  }\n  .vnsc-indicator-chip__btn:hover,\n  .rsc-indicator-chip__btn:hover {\n    opacity: 1;\n  }\n}\n.vnsc-indicator-chip__value,\n.rsc-indicator-chip__value {\n  margin-left: 4px;\n  font-variant-numeric: tabular-nums;\n  color: var(--chip-color, inherit);\n}\n\n/* src/widget/styles/toolbar.css */\n.vnsc-drawing-toolbar {\n  position: relative;\n  height: 100%;\n  width: 42px;\n  min-width: 42px;\n  flex-shrink: 0;\n  z-index: 40;\n  background: var(--vnsc-bg-secondary);\n  border-right: 1px solid var(--vnsc-border-subtle, var(--vnsc-border));\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 6px 0;\n  gap: 6px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-width: none;\n  transition:\n    width 0.2s ease,\n    padding 0.2s ease,\n    border-right-width 0.2s ease;\n}\n.vnsc-drawing-toolbar.vnsc-drawing-toolbar--collapsed {\n  width: 0;\n  min-width: 0;\n  padding: 0;\n  border-right: none;\n  overflow: hidden;\n}\n.vnsc-drawing-toolbar__expand-btn {\n  transition:\n    background-color var(--vnsc-transition-fast),\n    color var(--vnsc-transition-fast),\n    transform var(--vnsc-transition-fast);\n}\n.vnsc-drawing-toolbar__expand-btn:hover {\n  background-color: var(--vnsc-bg-tertiary, #f1f5f9) !important;\n  color: var(--vnsc-text-primary) !important;\n  transform: scale(1.05);\n}\n.vnsc-drawing-toolbar::-webkit-scrollbar {\n  display: none;\n}\n.vnsc-drawing-toolbar__group {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  margin-bottom: 4px;\n}\n.vnsc-drawing-toolbar__group:not(:last-child) {\n  border-bottom: 1px solid var(--vnsc-border);\n  padding-bottom: 4px;\n}\n.vnsc-drawing-toolbar__btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: var(--vnsc-radius-md, 4px);\n  background: transparent;\n  color: var(--vnsc-text-secondary);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);\n}\n.vnsc-drawing-toolbar__btn:hover {\n  background: rgba(41, 98, 255, 0.08);\n  color: var(--vnsc-text-primary);\n}\n.vnsc-drawing-toolbar__btn--active {\n  background: var(--vnsc-accent-bg, rgba(41, 98, 255, 0.12));\n  color: var(--vnsc-accent);\n}\n.vnsc-drawing-toolbar__btn--active:hover {\n  background: var(--vnsc-accent-bg, rgba(41, 98, 255, 0.18));\n}\n.vnsc-drawing-toolbar__magnet {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: var(--vnsc-radius-md, 4px);\n  background: transparent;\n  color: var(--vnsc-text-secondary);\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n  transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);\n}\n.vnsc-drawing-toolbar__magnet:hover {\n  background: rgba(41, 98, 255, 0.08);\n}\n.vnsc-tools-group-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.vnsc-tool-btn--group {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1px;\n}\n.vnsc-tools-chevron {\n  font-size: 7px;\n  line-height: 1;\n  opacity: 0.6;\n  pointer-events: none;\n}\n.vnsc-tools-flyout {\n  position: fixed;\n  z-index: var(--vnsc-z-maximum);\n  background: var(--vnsc-bg-primary, #0a0e14);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: var(--vnsc-radius-md, 6px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n  display: flex;\n  flex-direction: column;\n  width: 220px;\n  overflow: hidden;\n}\n.vnsc-drawing-toolbar__btn:hover .vnsc-tool-fav-star {\n  opacity: 0.5 !important;\n}\n.vnsc-tool-fav-star:hover {\n  opacity: 1 !important;\n  color: var(--vnsc-accent, #2962ff) !important;\n}\n.vnsc-tools-flyout input::placeholder {\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  opacity: 0.6;\n}\n.vnsc-tools-flyout input:focus {\n  border-color: var(--vnsc-accent, #2962ff) !important;\n}\n.vnsc-drawing-toolbar-shell {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 10px;\n  pointer-events: none;\n  z-index: 60;\n  transition: width 0.2s ease;\n}\n.vnsc-drawing-toolbar-shell:hover,\n.vnsc-drawing-toolbar-shell:has(input:focus) {\n  width: 42px;\n  pointer-events: auto;\n}\n.vnsc-drawing-toolbar {\n  position: absolute;\n  left: -42px;\n  top: 0;\n  bottom: 0;\n  width: 42px;\n  min-width: 42px;\n  pointer-events: auto;\n  z-index: 3;\n  transition:\n    left 0.2s ease,\n    box-shadow 0.2s ease,\n    border-right-color 0.2s ease,\n    visibility 0s linear 0.2s;\n  border-right: 1px solid transparent;\n  box-shadow: none;\n  visibility: hidden;\n}\n.vnsc-drawing-toolbar-shell:hover .vnsc-drawing-toolbar,\n.vnsc-drawing-toolbar:hover,\n.vnsc-drawing-toolbar-shell:has(input:focus) .vnsc-drawing-toolbar,\n.vnsc-drawing-toolbar:has(input:focus),\n.vnsc-drawing-toolbar-shell:focus-within .vnsc-drawing-toolbar {\n  left: 0;\n  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);\n  border-right-color: var(--vnsc-border-subtle, var(--vnsc-border));\n  visibility: visible;\n  transition:\n    left 0.2s ease,\n    box-shadow 0.2s ease,\n    border-right-color 0.2s ease;\n}\n.vnsc-drawing-toolbar-handle {\n  display: flex;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 10px;\n  height: 44px;\n  transform: translateY(-50%);\n  align-items: center;\n  justify-content: center;\n  border-radius: 0 var(--vnsc-radius-xl, 8px) var(--vnsc-radius-xl, 8px) 0;\n  border: 1px solid var(--vnsc-border);\n  border-left: none;\n  background:\n    linear-gradient(\n      180deg,\n      color-mix(in srgb, var(--vnsc-bg-primary) 92%, var(--vnsc-accent) 8%),\n      color-mix(in srgb, var(--vnsc-bg-secondary) 88%, var(--vnsc-accent) 12%));\n  box-shadow: 6px 10px 22px rgba(15, 23, 42, 0.16);\n  pointer-events: auto;\n  opacity: 1;\n  z-index: 2;\n  transition:\n    opacity 0.15s ease,\n    transform 0.15s ease,\n    box-shadow 0.15s ease;\n}\n.vnsc-drawing-toolbar-handle::before {\n  content: \"\";\n  width: 3px;\n  height: 3px;\n  border-radius: 999px;\n  background: var(--vnsc-text-secondary);\n  box-shadow: 0 -6px 0 var(--vnsc-text-secondary), 0 6px 0 var(--vnsc-text-secondary);\n}\n.vnsc-drawing-toolbar-shell--docked {\n  width: 44px;\n  pointer-events: auto;\n}\n.vnsc-drawing-toolbar-shell--docked .vnsc-drawing-toolbar {\n  left: 0;\n  visibility: visible;\n  border-right: 1px solid var(--vnsc-border-subtle, var(--vnsc-border));\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);\n}\n.vnsc-drawing-toolbar-shell--docked .vnsc-drawing-toolbar-handle {\n  display: none;\n}\n.vnsc-ohlc-header {\n  padding-left: 22px !important;\n  transition: padding-left 0.2s ease !important;\n}\n.vnsc-container:has(.vnsc-drawing-toolbar-shell:hover) .vnsc-ohlc-header,\n.vnsc-container:has(.vnsc-drawing-toolbar-shell:focus-within) .vnsc-ohlc-header {\n  padding-left: 54px !important;\n}\n.vnsc-container:has(.vnsc-drawing-toolbar-shell--collapsed) .vnsc-ohlc-header {\n  padding-left: 12px !important;\n}\n.vnsc-drawing-toolbar-shell.vnsc-drawing-toolbar-shell--collapsed {\n  width: 0;\n  pointer-events: none;\n}\n.vnsc-drawing-toolbar-shell.vnsc-drawing-toolbar-shell--collapsed .vnsc-drawing-toolbar-handle {\n  display: none;\n}\n@media (max-width: 768px) {\n  .vnsc-drawing-toolbar {\n    width: 48px !important;\n    min-width: 48px !important;\n    gap: 6px !important;\n    padding: 6px 0 !important;\n  }\n  .vnsc-drawing-toolbar__btn {\n    width: 40px !important;\n    height: 40px !important;\n    font-size: 16px !important;\n    border-radius: 6px !important;\n  }\n  .vnsc-drawing-toolbar__expand-btn {\n    width: 44px !important;\n    height: 44px !important;\n    left: 12px !important;\n    bottom: 20px !important;\n    font-size: 18px !important;\n    border-radius: 8px !important;\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.4) !important;\n  }\n}\n.vnsc-drawing-toolbar__btn--star-active {\n  color: #f59e0b !important;\n  background: rgba(245, 158, 11, 0.12) !important;\n}\n.vnsc-drawing-toolbar__btn--star-active:hover {\n  background: rgba(245, 158, 11, 0.22) !important;\n}\n.vnsc-floating-favorites-bar {\n  position: fixed;\n  z-index: var(--vnsc-z-popup, 20);\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  background: var(--vnsc-bg-primary, #0a0e14);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: var(--vnsc-radius-md, 8px);\n  padding: 4px 6px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.32);\n  user-select: none;\n  white-space: nowrap;\n}\n.vnsc-floating-favorites-grip {\n  cursor: grab;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 14px;\n  height: 28px;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  opacity: 0.7;\n  transition: opacity var(--vnsc-transition-fast, 0.15s), color var(--vnsc-transition-fast, 0.15s);\n  user-select: none;\n  touch-action: none;\n  font-size: 12px;\n  letter-spacing: 1px;\n}\n.vnsc-floating-favorites-grip:hover {\n  opacity: 1;\n  color: var(--vnsc-text-primary, #ffffff);\n}\n.vnsc-floating-favorites-grip:active {\n  cursor: grabbing;\n}\n.vnsc-floating-favorites-divider {\n  width: 1px;\n  height: 18px;\n  background: var(--vnsc-border-subtle, #2a2a2a);\n  margin: 0 3px;\n  flex-shrink: 0;\n}\n.vnsc-floating-favorites-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  cursor: pointer;\n  transition: background var(--vnsc-transition-fast, 0.15s), color var(--vnsc-transition-fast, 0.15s);\n  font-size: 13px;\n  line-height: 1;\n  padding: 0;\n}\n.vnsc-floating-favorites-close:hover {\n  background: rgba(239, 68, 68, 0.15);\n  color: #ef4444;\n}\n\n/* src/widget/styles/settings.css */\n.vnsc-settings-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(2, 6, 23, 0.6);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  animation: vnsc-reveal 200ms ease-out;\n}\n.vnsc-settings-backdrop[data-chart-mode=light] {\n  background: rgba(15, 23, 42, 0.35);\n}\n.vnsc-settings-backdrop[data-chart-mode=light] .vnsc-settings-modal {\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);\n}\n@keyframes vnsc-reveal {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.vnsc-settings-modal {\n  background: var(--vnsc-bg-primary, #0a0e14);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: var(--vnsc-radius-xl, 8px);\n  width: 520px;\n  max-width: 100%;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n}\n.vnsc-settings-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n  background:\n    linear-gradient(\n      180deg,\n      var(--vnsc-bg-secondary, #111820),\n      var(--vnsc-bg-primary, #0a0e14));\n  flex-shrink: 0;\n}\n.vnsc-settings-modal__title {\n  margin: 0;\n  font-size: var(--vnsc-font-lg, 15px);\n  font-weight: 700;\n  color: var(--vnsc-text-primary, #e0e0e0);\n  letter-spacing: -0.01em;\n}\n.vnsc-settings-modal__close {\n  background: none;\n  border: none;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  cursor: pointer;\n  font-size: 22px;\n  padding: 4px;\n  line-height: 1;\n  transition: color 120ms ease;\n}\n.vnsc-settings-modal__close:hover {\n  color: var(--vnsc-text-primary, #e0e0e0);\n}\n.vnsc-settings-tabs {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 16px;\n  height: 50px;\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n  overflow-x: auto;\n  scrollbar-width: none;\n  flex-shrink: 0;\n}\n.vnsc-settings-tabs::-webkit-scrollbar {\n  display: none;\n}\n.vnsc-settings-tab {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 34px;\n  line-height: 1;\n  padding: 0 12px;\n  box-sizing: border-box;\n  border: none;\n  border-radius: var(--vnsc-radius-md, 4px);\n  background: transparent;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: background 120ms ease, color 120ms ease;\n}\n.vnsc-settings-tab:hover {\n  background: var(--vnsc-bg-tertiary, #1c2430);\n  color: var(--vnsc-text-primary, #e0e0e0);\n}\n.vnsc-settings-tab--active {\n  background: var(--vnsc-accent, #2962ff);\n  color: #fff !important;\n}\n.vnsc-settings-body {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n  padding: 16px;\n  scrollbar-gutter: stable;\n}\n.vnsc-settings-body::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n.vnsc-settings-body::-webkit-scrollbar-thumb {\n  background: var(--vnsc-border, #2a2a2a);\n  border-radius: 3px;\n}\n.vnsc-settings-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.vnsc-settings-panel__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n.vnsc-settings-panel__header--subtle {\n  border-top: 1px solid var(--vnsc-border, #2a2a2a);\n  margin-top: 12px;\n  padding-top: 12px;\n}\n.vnsc-settings-kicker {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n}\n.vnsc-settings-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.vnsc-settings-row--split {\n  justify-content: space-between;\n  align-items: center;\n}\n.vnsc-settings-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n}\n.vnsc-settings-field--compact {\n  min-width: 120px;\n}\n.vnsc-settings-input,\n.vnsc-settings-select {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: 4px;\n  background: var(--vnsc-bg-secondary, #111820);\n  color: var(--vnsc-text-primary, #e0e0e0);\n  font-size: 12px;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 120ms ease, background 120ms ease;\n}\n.vnsc-settings-input:focus,\n.vnsc-settings-select:focus {\n  border-color: var(--vnsc-accent, #2962ff);\n  background: var(--vnsc-bg-tertiary, #1c2430);\n}\n.vnsc-settings-select {\n  cursor: pointer;\n}\n.vnsc-settings-pane-list,\n.vnsc-settings-series-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n.vnsc-settings-series {\n  padding: 10px 12px;\n  background: var(--vnsc-bg-secondary, #111820);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.vnsc-settings-series__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n.vnsc-settings-series__title {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--vnsc-text-primary, #e0e0e0);\n}\n.vnsc-settings-series__meta {\n  font-size: 10px;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  margin-top: 2px;\n}\n.vnsc-settings-series__actions {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n.vnsc-settings-pane__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n.vnsc-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 6px;\n  border-radius: 3px;\n  background: var(--vnsc-bg-primary, #0a0e14);\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  font-size: 10px;\n  font-weight: 500;\n}\n.vnsc-settings-note {\n  font-size: 11px;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  background: rgba(41, 98, 255, 0.08);\n  border: 1px dashed rgba(41, 98, 255, 0.25);\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin: 6px 0;\n  line-height: 1.4;\n}\n.vnsc-settings-empty {\n  text-align: center;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  padding: 20px;\n  font-size: 12px;\n}\n.vnsc-btn {\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 4px;\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  background: var(--vnsc-bg-secondary, #111820);\n  color: var(--vnsc-text-primary, #e0e0e0);\n  cursor: pointer;\n  transition: all 120ms ease;\n  outline: none;\n}\n.vnsc-btn:hover:not(:disabled) {\n  background: var(--vnsc-bg-tertiary, #1c2430);\n  border-color: var(--vnsc-text-secondary, #a0a0a0);\n}\n.vnsc-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.vnsc-btn--accent {\n  background: var(--vnsc-accent, #2962ff);\n  color: #fff;\n  border-color: transparent;\n}\n.vnsc-btn--accent:hover:not(:disabled) {\n  background: #1565c0;\n  opacity: 0.95;\n}\n.vnsc-btn--danger {\n  background: rgba(244, 67, 54, 0.15);\n  color: #ef5350;\n  border-color: rgba(244, 67, 54, 0.3);\n}\n.vnsc-btn--danger:hover:not(:disabled) {\n  background: #f44336;\n  color: #fff;\n  border-color: transparent;\n}\n.vnsc-settings-slider-shell {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n.vnsc-settings-slider-readout {\n  display: flex;\n  justify-content: space-between;\n  font-size: 10px;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n}\n.vnsc-settings-slider-readout__current {\n  color: var(--vnsc-accent, #2962ff);\n  font-weight: 700;\n}\n@media (max-width: 520px) {\n  .vnsc-settings-backdrop {\n    padding: 8px;\n    align-items: flex-end;\n  }\n  .vnsc-settings-modal {\n    width: 100%;\n    max-height: 90vh;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    animation: vnsc-slide-up 240ms cubic-bezier(0.16, 1, 0.3, 1);\n  }\n  @keyframes vnsc-slide-up {\n    from {\n      transform: translateY(100%);\n    }\n    to {\n      transform: translateY(0);\n    }\n  }\n  .vnsc-settings-modal__header {\n    padding: 14px 16px;\n  }\n  .vnsc-settings-tabs {\n    padding: 8px 16px;\n    gap: 6px;\n    height: 50px;\n    flex-shrink: 0;\n  }\n  .vnsc-settings-body {\n    padding: 14px;\n  }\n  .vnsc-btn,\n  .vnsc-settings-input,\n  .vnsc-settings-select {\n    min-height: 44px;\n    font-size: 13px;\n  }\n  .vnsc-settings-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n  .vnsc-settings-row > .vnsc-btn {\n    margin-top: 0 !important;\n  }\n  .vnsc-settings-series__head {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n  .vnsc-settings-series__actions {\n    justify-content: flex-end;\n    width: 100%;\n  }\n  .vnsc-settings-series__actions > select,\n  .vnsc-settings-series__actions > button {\n    flex: 1;\n    min-height: 38px;\n    font-size: 12px;\n  }\n}\n\n/* src/widget/styles/chart-splitter.css */\n.vnsc-splitter,\n.rsc-splitter {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 18px;\n  margin-top: -9px;\n  cursor: row-resize;\n  z-index: 12;\n  pointer-events: auto;\n  user-select: none;\n  touch-action: none;\n}\n.vnsc-splitter::after,\n.rsc-splitter::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 2px;\n  background: transparent;\n  transition: background 0.15s;\n}\n.vnsc-splitter:hover::after,\n.vnsc-splitter--dragging::after,\n.rsc-splitter:hover::after,\n.rsc-splitter--dragging::after {\n  background: var(--vnsc-accent, #2962ff);\n}\n.rsc-splitter__badge {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(20, 20, 28, 0.85);\n  color: #fff;\n  font: 11px/1 sans-serif;\n  padding: 3px 8px;\n  border-radius: 10px;\n  pointer-events: none;\n  white-space: nowrap;\n}\n.rsc-splitter:focus {\n  outline: none;\n}\n.rsc-splitter:focus-visible {\n  outline: none;\n}\n.rsc-splitter:focus-visible::after {\n  background: var(--vnsc-accent, #2962ff);\n}\n@media (pointer: coarse) {\n  .vnsc-splitter,\n  .rsc-splitter {\n    height: 24px;\n    margin-top: -12px;\n  }\n}\n\n/* src/widget/styles/header.css */\n.vnsc-ohlc-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 6px 12px;\n  background: var(--vnsc-bg-secondary);\n  border-bottom: 1px solid var(--vnsc-border);\n  font-family: inherit;\n  font-size: var(--vnsc-font-md, 12px);\n  color: var(--vnsc-text-primary);\n  z-index: 30;\n}\n.vnsc-ohlc-header__symbol {\n  font-size: var(--vnsc-font-lg, 14px);\n  font-weight: 700;\n}\n.vnsc-ohlc-header__timeframe {\n  background: var(--vnsc-accent, #2962ff);\n  color: #fff;\n  padding: 2px 6px;\n  border-radius: var(--vnsc-radius-sm, 3px);\n  font-size: var(--vnsc-font-sm, 11px);\n  font-weight: 600;\n}\n.vnsc-ohlc-header__values {\n  color: var(--vnsc-text-secondary);\n  white-space: nowrap;\n}\n.vnsc-ohlc-header__volume {\n  color: var(--vnsc-text-secondary);\n}\n.vnsc-ohlc-header__change {\n  font-weight: 600;\n}\n.vnsc-ohlc-header__menu {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.vnsc-ohlc-menu-btn {\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  padding: 0;\n}\n.vnsc-ohlc-menu-btn:hover {\n  color: var(--vnsc-text-primary, #e0e0e0);\n  background: var(--vnsc-bg-tertiary, #1c2430);\n  border-color: var(--vnsc-border, #2a2a2a);\n}\n.vnsc-ohlc-menu-btn--active {\n  color: var(--vnsc-accent, #2962ff);\n  background: var(--vnsc-bg-tertiary, #1c2430);\n  border-color: var(--vnsc-accent, #2962ff);\n}\n\n/* src/widget/styles/footer.css */\n.vnsc-timeframe-footer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 4px 12px;\n  background: var(--vnsc-bg-secondary);\n  border-top: 1px solid var(--vnsc-border);\n  z-index: 30;\n  flex-wrap: wrap;\n}\n.vnsc-tf-chip,\n.vnsc-range-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3px 8px;\n  border: 1px solid transparent;\n  border-radius: var(--vnsc-radius-md);\n  cursor: pointer;\n  font-size: var(--vnsc-font-sm);\n  font-weight: 500;\n  background: transparent;\n  color: var(--vnsc-text-secondary);\n  transition: color var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);\n  font-family: inherit;\n}\n.vnsc-tf-chip:hover,\n.vnsc-range-chip:hover {\n  color: var(--vnsc-text-primary);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n.vnsc-tf-chip--active,\n.vnsc-range-chip--active {\n  color: var(--vnsc-text-primary);\n  font-weight: 600;\n  border-color: rgba(255, 255, 255, 0.18);\n}\n.vnsc-tf-chip--active:hover,\n.vnsc-range-chip--active:hover {\n  border-color: rgba(255, 255, 255, 0.25);\n}\n.vnsc-trademark {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 8px;\n  font-size: 11px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.35);\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n  margin-left: auto;\n}\n.vnsc-trademark:hover {\n  color: rgba(255, 255, 255, 0.5);\n}\n.vnsc-trademark-icon {\n  font-size: 11px;\n  color: rgba(99, 102, 241, 0.5);\n}\n.vnsc-trademark-icon:hover {\n  color: rgba(99, 102, 241, 0.7);\n}\n\n/* src/widget/styles/paper-trade.css */\n.vnsc-paper-trade-panel {\n  position: relative;\n  height: 100%;\n  flex-shrink: 0;\n  width: 280px;\n  background: var(--vnsc-bg-primary);\n  border-left: 1px solid var(--vnsc-border);\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n  font-size: var(--vnsc-font-sm);\n  color: var(--vnsc-text-primary);\n  overflow: hidden;\n}\n[data-vnsc-bottom-panel=host] .vnsc-paper-trade-panel {\n  width: 100%;\n  border-left: none;\n  background: transparent;\n}\n.vnsc-paper-trade-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--vnsc-border);\n  flex-shrink: 0;\n}\n.vnsc-paper-trade-panel__title {\n  font-size: var(--vnsc-font-md);\n  font-weight: 700;\n}\n.vnsc-paper-trade-panel__reset-btn {\n  background: var(--vnsc-bg-tertiary);\n  border: none;\n  color: var(--vnsc-text-secondary);\n  border-radius: var(--vnsc-radius-md);\n  cursor: pointer;\n  padding: 4px 8px;\n  font-size: var(--vnsc-font-sm);\n  font-weight: 600;\n  transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);\n}\n.vnsc-paper-trade-panel__reset-btn:hover {\n  background: var(--vnsc-border);\n  color: var(--vnsc-text-primary);\n}\n.vnsc-paper-trade-panel__stats {\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--vnsc-border);\n  flex-shrink: 0;\n}\n.vnsc-paper-trade-panel__stats-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px;\n}\n.vnsc-paper-trade-panel__stat-label {\n  font-size: var(--vnsc-font-xs);\n  color: var(--vnsc-text-secondary);\n}\n.vnsc-paper-trade-panel__stat-value {\n  font-weight: 700;\n  font-size: var(--vnsc-font-lg);\n}\n.vnsc-paper-trade-panel__position {\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--vnsc-border);\n  flex-shrink: 0;\n}\n.vnsc-paper-trade-panel__position-title {\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n.vnsc-paper-trade-panel__position-side {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: var(--vnsc-radius-sm);\n  font-size: var(--vnsc-font-xs);\n  font-weight: 700;\n}\n.vnsc-paper-trade-panel__position-side--long {\n  background: var(--vnsc-up);\n  color: #fff;\n}\n.vnsc-paper-trade-panel__position-side--short {\n  background: var(--vnsc-down);\n  color: #fff;\n}\n.vnsc-paper-trade-panel__position-entry {\n  margin-top: 4px;\n  color: var(--vnsc-text-secondary);\n}\n.vnsc-paper-trade-panel__position-empty {\n  color: var(--vnsc-text-secondary);\n}\n.vnsc-paper-trade-panel__journal {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px 12px;\n}\n.vnsc-paper-trade-panel__journal-title {\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n.vnsc-paper-trade-panel__journal-empty {\n  color: var(--vnsc-text-secondary);\n  text-align: center;\n  padding: 16px 0;\n}\n.vnsc-paper-trade-panel__journal-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 4px 0;\n  border-bottom: 1px solid var(--vnsc-border);\n}\n.vnsc-paper-trade-panel__journal-item--positive .vnsc-paper-trade-panel__journal-side {\n  color: var(--vnsc-up);\n}\n.vnsc-paper-trade-panel__journal-item--positive .vnsc-paper-trade-panel__journal-pnl {\n  color: var(--vnsc-up);\n}\n.vnsc-paper-trade-panel__journal-item--negative .vnsc-paper-trade-panel__journal-side {\n  color: var(--vnsc-down);\n}\n.vnsc-paper-trade-panel__journal-item--negative .vnsc-paper-trade-panel__journal-pnl {\n  color: var(--vnsc-down);\n}\n.vnsc-paper-trade-panel__journal-side {\n  font-size: var(--vnsc-font-xs);\n  font-weight: 700;\n}\n.vnsc-paper-trade-panel__journal-pnl {\n  font-weight: 600;\n}\n\n/* src/widget/styles/drawing.css */\n.vnsc-drawing-dock__empty {\n  padding: 16px;\n  text-align: center;\n  color: var(--vnsc-text-muted, #606060);\n}\n.vnsc-drawing-point-legend {\n  padding: 8px;\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n}\n.vnsc-drawing-point-legend__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n.vnsc-drawing-point-legend__item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 6px;\n  border-radius: var(--vnsc-radius-sm, 3px);\n  cursor: pointer;\n  transition: background var(--vnsc-transition-fast);\n}\n.vnsc-drawing-point-legend__item:hover,\n.vnsc-drawing-point-legend__item--active {\n  background: var(--vnsc-bg-tertiary, #1a1a1a);\n}\n.vnsc-drawing-point-legend__index {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: var(--vnsc-accent, #2962ff);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--vnsc-font-xs, 10px);\n  font-weight: 700;\n}\n.vnsc-drawing-point-legend__label {\n  font-size: var(--vnsc-font-sm, 11px);\n  color: var(--vnsc-text-secondary, #a0a0a0);\n}\n.vnsc-drawing-storage-toolbar {\n  display: flex;\n  gap: 4px;\n  padding: 4px 8px;\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n}\n.vnsc-drawing-storage-toolbar__button {\n  padding: 4px 8px;\n  border: none;\n  border-radius: var(--vnsc-radius-sm, 3px);\n  background: transparent;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  cursor: pointer;\n  font-size: var(--vnsc-font-sm, 11px);\n  transition: background var(--vnsc-transition-fast);\n}\n.vnsc-drawing-storage-toolbar__button:hover {\n  background: var(--vnsc-bg-tertiary, #1a1a1a);\n  color: var(--vnsc-text-primary, #e0e0e0);\n}\n.vnsc-paper-trade-panel {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 280px;\n  background: var(--vnsc-bg-primary, #0a0e14);\n  border-left: 1px solid var(--vnsc-border, #2a2a2a);\n  z-index: 50;\n  display: flex;\n  flex-direction: column;\n  font-size: var(--vnsc-font-sm, 11px);\n  color: var(--vnsc-text-primary, #e0e0e0);\n  overflow: hidden;\n}\n.vnsc-paper-trade-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n}\n.vnsc-paper-trade-panel__close-btn {\n  appearance: none;\n  border: none;\n  background: transparent;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--vnsc-font-lg, 14px);\n  cursor: pointer;\n  padding: 0;\n  transition: color var(--vnsc-transition-fast, 120ms);\n}\n.vnsc-paper-trade-panel__close-btn:hover {\n  color: var(--vnsc-text-primary, #e0e0e0);\n}\n.vnsc-paper-trade-panel__stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n}\n.vnsc-paper-trade-panel__stat-label {\n  font-size: var(--vnsc-font-xs, 10px);\n  color: var(--vnsc-text-secondary, #a0a0a0);\n}\n.vnsc-paper-trade-panel__stat-value {\n  font-weight: 700;\n  font-size: var(--vnsc-font-md, 13px);\n}\n.vnsc-paper-trade-panel__position {\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n}\n.vnsc-paper-trade-panel__position-badge {\n  padding: 2px 6px;\n  border-radius: var(--vnsc-radius-sm, 3px);\n  font-size: var(--vnsc-font-xs, 10px);\n  font-weight: 700;\n  color: #fff;\n}\n.vnsc-paper-trade-panel__position-badge--long {\n  background: #0d6b2e;\n}\n.vnsc-paper-trade-panel__position-badge--short {\n  background: #c0392b;\n}\n.vnsc-paper-trade-panel__journal {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px 12px;\n}\n.vnsc-paper-trade-panel__journal-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 4px 0;\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n}\n.vnsc-paper-trade-panel__journal-item--positive .vnsc-paper-trade-panel__journal-pnl {\n  color: #089981;\n}\n.vnsc-paper-trade-panel__journal-item--negative .vnsc-paper-trade-panel__journal-pnl {\n  color: #f23645;\n}\n.vnsc-drawing-inspector,\n.vnsc-drawing-list-panel {\n  width: min(348px, calc(100vw - 32px));\n  border-radius: var(--vnsc-radius-md, 4px);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  background: var(--vnsc-bg-secondary, #111820);\n  box-shadow: var(--vnsc-shadow-lg, 0 8px 32px rgba(0, 0, 0, 0.4));\n  color: var(--vnsc-text-primary, #e0e0e0);\n  padding: 14px;\n  display: grid;\n  gap: 14px;\n  max-height: calc(100% - 32px);\n  overflow: auto;\n  overscroll-behavior: contain;\n}\n.vnsc-drawing-inspector--embedded,\n.vnsc-drawing-list-panel--embedded {\n  position: static;\n  z-index: auto;\n  width: auto;\n  max-height: none;\n  overflow: visible;\n  padding: 0;\n  border: none;\n  background: transparent;\n  box-shadow: none;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n.vnsc-drawing-inspector--embedded .vnsc-drawing-inspector__header,\n.vnsc-drawing-list-panel--embedded .vnsc-drawing-list-panel__header {\n  display: none;\n}\n.vnsc-drawing-inspector__header,\n.vnsc-drawing-list-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n.vnsc-drawing-inspector__title {\n  display: grid;\n  gap: 4px;\n  min-width: 0;\n}\n.vnsc-drawing-inspector__title strong,\n.vnsc-drawing-list-panel__header strong {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--vnsc-text-primary, #e0e0e0);\n  letter-spacing: 0.01em;\n}\n.vnsc-drawing-inspector__title span,\n.vnsc-drawing-list-panel__header span {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--vnsc-text-muted, #606060);\n}\n.vnsc-drawing-inspector__icon,\n.vnsc-drawing-list-panel__icon {\n  appearance: none;\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  background: transparent;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  width: 28px;\n  height: 28px;\n  border-radius: var(--vnsc-radius-sm, 3px);\n  cursor: pointer;\n  transition:\n    background var(--vnsc-transition-fast),\n    color var(--vnsc-transition-fast),\n    border-color var(--vnsc-transition-fast);\n}\n.vnsc-drawing-inspector__icon:hover,\n.vnsc-drawing-list-panel__icon:hover {\n  background: var(--vnsc-bg-tertiary, #1a1a1a);\n  border-color: var(--vnsc-border, #2a2a2a);\n  color: var(--vnsc-text-primary, #e0e0e0);\n}\n.vnsc-drawing-inspector__swatches {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n.vnsc-drawing-inspector__field {\n  display: grid;\n  gap: 8px;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n.vnsc-drawing-inspector__field label {\n  display: grid;\n  gap: 8px;\n}\n.vnsc-drawing-inspector__field input[type=color] {\n  appearance: none;\n  width: 100%;\n  height: 36px;\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: var(--vnsc-radius-sm, 3px);\n  background: var(--vnsc-bg-tertiary, #1a1a1a);\n  padding: 3px;\n  cursor: pointer;\n}\n.vnsc-drawing-inspector__field input[type=range] {\n  width: 100%;\n  accent-color: var(--vnsc-accent, #2962ff);\n}\n.vnsc-drawing-inspector__field select {\n  appearance: none;\n  width: 100%;\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: var(--vnsc-radius-sm, 3px);\n  background: var(--vnsc-bg-tertiary, #1a1a1a);\n  color: var(--vnsc-text-primary, #e0e0e0);\n  padding: 8px 10px;\n  font-size: 12px;\n}\n.vnsc-drawing-inspector__actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n.vnsc-drawing-inspector__button {\n  appearance: none;\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  background: transparent;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  border-radius: var(--vnsc-radius-sm, 3px);\n  padding: 8px 10px;\n  font-size: 11.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background var(--vnsc-transition-fast),\n    border-color var(--vnsc-transition-fast),\n    color var(--vnsc-transition-fast);\n}\n.vnsc-drawing-inspector__button:hover {\n  background: var(--vnsc-bg-tertiary, #1a1a1a);\n  border-color: var(--vnsc-border, #2a2a2a);\n  color: var(--vnsc-text-primary, #e0e0e0);\n}\n.vnsc-drawing-inspector__button:disabled {\n  opacity: 0.42;\n  cursor: default;\n  transform: none;\n}\n.vnsc-drawing-inspector__button--danger {\n  grid-column: 1 / -1;\n  border-color: rgba(239, 68, 68, 0.28);\n  background: rgba(239, 68, 68, 0.1);\n  color: #fecaca;\n}\n.vnsc-drawing-inspector__button--danger:hover {\n  background: rgba(239, 68, 68, 0.18);\n  border-color: rgba(239, 68, 68, 0.38);\n  color: #fff1f2;\n}\n.vnsc-drawing-list-panel {\n  display: flex;\n  flex-direction: column;\n  max-height: min(560px, calc(100vh - 160px));\n  overflow: hidden;\n  padding: 0;\n  gap: 0;\n}\n.vnsc-drawing-list-panel--embedded {\n  gap: 0;\n  max-height: none;\n  min-height: 0;\n}\n.vnsc-drawing-list-panel--embedded .vnsc-drawing-list-panel__items {\n  padding: 0;\n}\n.vnsc-drawing-list-panel--embedded .vnsc-drawing-list-panel__empty {\n  margin: 0;\n}\n.vnsc-drawing-list-panel__header {\n  flex-shrink: 0;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.vnsc-drawing-list-panel__count {\n  background: var(--vnsc-bg-tertiary, #1a1a1a);\n  padding: 2px 6px;\n  border-radius: 999px;\n  font-size: var(--vnsc-font-xs, 10px);\n  font-weight: 700;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n}\n.vnsc-drawing-list-panel__search {\n  padding: 8px 14px;\n  border-bottom: 1px solid var(--vnsc-border, #2a2a2a);\n}\n.vnsc-drawing-list-panel__search-input {\n  width: 100%;\n  padding: 6px 10px;\n  border-radius: var(--vnsc-radius-sm, 3px);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  background: var(--vnsc-bg-tertiary, #1a1a1a);\n  color: var(--vnsc-text-primary, #e0e0e0);\n  font-size: var(--vnsc-font-sm, 11px);\n  outline: none;\n}\n.vnsc-drawing-list-panel__search-input:focus {\n  border-color: var(--vnsc-accent, #2962ff);\n}\n.vnsc-drawing-list-panel__items {\n  display: grid;\n  gap: 8px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  overscroll-behavior: contain;\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 10px 14px 12px;\n  scrollbar-width: thin;\n  scrollbar-color: var(--vnsc-border, #2a2a2a) transparent;\n}\n.vnsc-drawing-list-panel__items::-webkit-scrollbar {\n  width: 4px;\n}\n.vnsc-drawing-list-panel__items::-webkit-scrollbar-track {\n  background: transparent;\n}\n.vnsc-drawing-list-panel__items::-webkit-scrollbar-thumb {\n  background: var(--vnsc-border, #2a2a2a);\n  border-radius: 4px;\n}\n.vnsc-drawing-list-panel__empty {\n  margin: 10px 14px 12px;\n  padding: 16px 14px;\n  border-radius: var(--vnsc-radius-md, 4px);\n  border: 1px dashed var(--vnsc-border, #2a2a2a);\n  background: var(--vnsc-bg-tertiary, #1a1a1a);\n  color: var(--vnsc-text-secondary, #a0a0a0);\n  font-size: 13px;\n  line-height: 1.5;\n}\n.vnsc-drawing-list-panel__group {\n  display: grid;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n.vnsc-drawing-list-panel__group-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 6px 8px;\n  background: var(--vnsc-bg-tertiary, #1a1a1a);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: var(--vnsc-radius-sm, 3px);\n  color: var(--vnsc-text-primary, #e0e0e0);\n  font-size: var(--vnsc-font-sm, 11px);\n  font-weight: 700;\n  cursor: pointer;\n  text-align: left;\n}\n.vnsc-drawing-list-panel__group-caret {\n  font-size: 8px;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n}\n.vnsc-drawing-list-panel__group-name {\n  flex: 1;\n}\n.vnsc-drawing-list-panel__group-count {\n  background: rgba(255, 255, 255, 0.08);\n  padding: 1px 5px;\n  border-radius: 999px;\n  font-size: var(--vnsc-font-xs, 10px);\n}\n.vnsc-drawing-list-panel__item {\n  display: grid;\n  gap: 10px;\n  padding: 12px;\n  border-radius: var(--vnsc-radius-md, 4px);\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  background: var(--vnsc-bg-tertiary, #1a1a1a);\n  transition: border-color 120ms ease;\n}\n.vnsc-drawing-list-panel__item--selected {\n  border-color: var(--vnsc-accent, #2962ff);\n  box-shadow: 0 0 0 1px rgba(41, 98, 255, 0.1) inset;\n}\n.vnsc-drawing-list-panel__item--drag-over {\n  border-color: var(--vnsc-accent, #2962ff);\n  border-style: dashed;\n}\n.vnsc-drawing-list-panel__select {\n  appearance: none;\n  border: none;\n  background: transparent;\n  padding: 0;\n  text-align: left;\n  cursor: pointer;\n  display: grid;\n  gap: 4px;\n  color: inherit;\n}\n.vnsc-drawing-list-panel__label {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--vnsc-text-primary, #e0e0e0);\n  letter-spacing: 0.01em;\n}\n.vnsc-drawing-list-panel__meta {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--vnsc-text-muted, #606060);\n}\n.vnsc-drawing-list-panel__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n.vnsc-drawing-list-panel__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 9px;\n  border-radius: 999px;\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  background: var(--vnsc-bg-secondary, #111820);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--vnsc-text-secondary, #a0a0a0);\n}\n.vnsc-drawing-list-panel__icon {\n  width: auto;\n  height: auto;\n  padding: 5px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n.vnsc-drawing-list-panel__icon--delete {\n  color: #f23645;\n}\n.vnsc-long-tp-zone {\n  fill: rgba(34, 197, 94, 0.16);\n}\n.vnsc-long-sl-zone {\n  fill: rgba(239, 68, 68, 0.16);\n}\n.vnsc-short-tp-zone {\n  fill: rgba(239, 68, 68, 0.16);\n}\n.vnsc-short-sl-zone {\n  fill: rgba(34, 197, 94, 0.16);\n}\n.vnsc-rr-badge {\n  font-family:\n    \"Segoe UI Variable Text\",\n    \"Aptos\",\n    \"Segoe UI\",\n    sans-serif;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  fill: #e2e8f0;\n}\n.vnsc-drawing-inspector__icon-grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 6px;\n  margin-top: 6px;\n}\n.vnsc-drawing-inspector__icon-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  border: 1px solid var(--vnsc-border, #2a2a2a);\n  border-radius: var(--vnsc-radius-sm, 3px);\n  background: var(--vnsc-bg-tertiary, #1a1a1a);\n  font-size: 18px;\n  cursor: pointer;\n  user-select: none;\n  transition: background var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);\n}\n.vnsc-drawing-inspector__icon-cell:hover {\n  background: var(--vnsc-bg-secondary, #222222);\n  border-color: var(--vnsc-accent, #2962ff);\n}\n.vnsc-drawing-inspector__icon-cell--selected {\n  background: var(--vnsc-bg-secondary, #222222);\n  border-color: var(--vnsc-accent, #2962ff);\n  box-shadow: 0 0 0 1px var(--vnsc-accent, #2962ff);\n}\n\n/* src/widget/styles/overlays.css */\n.vnsc-tape-panel {\n  position: relative;\n  height: 100%;\n  flex-shrink: 0;\n  width: 240px;\n  z-index: 51;\n  background: var(--vnsc-bg-primary);\n  border-left: 1px solid var(--vnsc-border);\n  display: flex;\n  flex-direction: column;\n  font-size: var(--vnsc-font-sm);\n  color: var(--vnsc-text-primary);\n  overflow: hidden;\n}\n.vnsc-tape-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 8px 5px;\n  border-bottom: 1px solid var(--vnsc-border);\n  background: var(--vnsc-bg-secondary);\n  flex-shrink: 0;\n}\n.vnsc-tape-panel__filter {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 8px;\n  border-bottom: 1px solid var(--vnsc-border);\n  flex-shrink: 0;\n}\n.vnsc-tape-panel__columns {\n  display: grid;\n  grid-template-columns: 52px 70px 52px 44px 22px;\n  padding: 2px 4px;\n  color: var(--vnsc-text-muted);\n  font-size: var(--vnsc-font-xs);\n  border-bottom: 1px solid var(--vnsc-border);\n  flex-shrink: 0;\n}\n.vnsc-tape-panel__list {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.vnsc-tape-panel__row {\n  display: grid;\n  grid-template-columns: 52px 70px 52px 44px 22px;\n  height: 22px;\n  align-items: center;\n  padding: 0 4px;\n  border-bottom: 1px solid var(--vnsc-border);\n}\n.vnsc-tape-panel__row--whale {\n  background: var(--vnsc-bg-tertiary);\n  border-bottom-color: var(--vnsc-accent);\n}\n.vnsc-tape-panel__footer {\n  padding: 3px 8px;\n  border-top: 1px solid var(--vnsc-border);\n  color: var(--vnsc-text-muted);\n  font-size: var(--vnsc-font-xs);\n  flex-shrink: 0;\n}\n.vnsc-advisory-panel {\n  position: relative;\n  height: 100%;\n  flex-shrink: 0;\n  width: 260px;\n  z-index: 50;\n  background: var(--vnsc-bg-primary);\n  border-left: 1px solid var(--vnsc-border);\n  display: flex;\n  flex-direction: column;\n  font-size: var(--vnsc-font-md);\n  color: var(--vnsc-text-primary);\n  overflow: hidden;\n}\n.vnsc-advisory-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px 8px;\n  border-bottom: 1px solid var(--vnsc-border);\n  background: var(--vnsc-bg-secondary);\n}\n.vnsc-advisory-panel__body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px;\n}\n.vnsc-advisory-panel__decision {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n.vnsc-advisory-panel__decision-badge {\n  flex: 1;\n  padding: 8px 12px;\n  border-radius: var(--vnsc-radius-lg);\n  background: var(--vnsc-text-secondary);\n  color: var(--vnsc-bg-primary);\n  font-weight: 700;\n  font-size: var(--vnsc-font-lg);\n  text-align: center;\n  letter-spacing: 0.5px;\n}\n.vnsc-advisory-panel__confidence {\n  text-align: center;\n}\n.vnsc-advisory-panel__confidence-label {\n  color: var(--vnsc-text-muted);\n  font-size: var(--vnsc-font-xs);\n}\n.vnsc-advisory-panel__confidence-value {\n  font-weight: 700;\n  font-size: var(--vnsc-font-md);\n}\n.vnsc-advisory-panel__agents {\n  margin-bottom: 8px;\n}\n.vnsc-advisory-panel__agent-row {\n  border-bottom: 1px solid var(--vnsc-border);\n  padding-bottom: 8px;\n  margin-bottom: 8px;\n}\n.vnsc-advisory-panel__agent-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n.vnsc-advisory-panel__agent-name {\n  flex: 1;\n  font-size: var(--vnsc-font-md);\n  color: var(--vnsc-text-primary);\n  font-weight: 500;\n}\n.vnsc-advisory-panel__agent-weight {\n  color: var(--vnsc-text-muted);\n  font-size: var(--vnsc-font-sm);\n  margin-left: 4px;\n}\n.vnsc-advisory-panel__agent-signal {\n  font-size: var(--vnsc-font-xs);\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: var(--vnsc-radius-md);\n  background: var(--vnsc-text-secondary);\n  color: var(--vnsc-bg-primary);\n  letter-spacing: 0.5px;\n}\n.vnsc-advisory-panel__agent-chevron {\n  color: var(--vnsc-text-muted);\n  font-size: var(--vnsc-font-xs);\n}\n.vnsc-advisory-panel__agent-bar {\n  height: 4px;\n  background: var(--vnsc-border);\n  border-radius: 2px;\n  margin-top: 6px;\n  overflow: hidden;\n}\n.vnsc-advisory-panel__agent-bar-fill {\n  height: 100%;\n  border-radius: 2px;\n  transition: width 0.3s ease;\n}\n.vnsc-advisory-panel__agent-explanation {\n  margin-top: 8px;\n  font-size: var(--vnsc-font-sm);\n  color: var(--vnsc-text-secondary);\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.vnsc-advisory-panel__skeleton {\n  height: 40px;\n  background: var(--vnsc-bg-tertiary);\n  border-radius: var(--vnsc-radius-md);\n  margin-bottom: 8px;\n  animation: pulse 1.2s ease-in-out infinite;\n}\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n/* src/widget/styles/replay.css */\n\n/* src/widget/styles/floating-chart-bar.css */\n.rsc-engine-surface .vnsc-floating-bar {\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n@media (hover: hover) {\n  .rsc-engine-surface:not(:hover) .vnsc-floating-bar {\n    opacity: 0;\n    pointer-events: none;\n    transform: translateX(-50%) translateY(4px);\n  }\n}\n.rsc-engine-surface:focus-within .vnsc-floating-bar {\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateX(-50%) translateY(0);\n}\n\n/* src/widget/styles/widget.css */\n[data-chart-mode=light] .MultiChartsFooter_syncBtn {\n  background: var(--vnsc-bg-hover, rgba(0, 0, 0, 0.03));\n  border-color: var(--vnsc-border, rgba(0, 0, 0, 0.08));\n  color: var(--vnsc-text-primary, #1a1a1a);\n}\n[data-chart-mode=light] .MultiChartsFooter_syncBtn:hover {\n  background: var(--vnsc-bg-active, rgba(0, 0, 0, 0.06));\n  border-color: var(--vnsc-border-hover, rgba(0, 0, 0, 0.12));\n  color: var(--vnsc-text-primary, #1a1a1a);\n}\n[data-chart-mode=light] .MultiChartsFooter_syncBtnActive {\n  color: var(--vnsc-text-on-primary, #ffffff);\n  background: var(--vnsc-accent-subtle, rgba(99, 102, 241, 0.2));\n  border-color: var(--vnsc-accent, #6366f1);\n}\n[data-chart-mode=dark] .MultiChartsFooter_syncBtn {\n  padding: 4px 10px;\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\n  border-radius: 6px;\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));\n  color: var(--vnsc-text-secondary, #787b86);\n  cursor: pointer;\n  font-size: var(--vnsc-font-size-2xs, 10px);\n  font-weight: 500;\n  transition: all 0.15s ease;\n}\n[data-chart-mode=dark] .MultiChartsFooter_syncBtn:hover {\n  color: var(--vnsc-text-primary, #d1d4dc);\n  background: var(--vnsc-bg-active, rgba(255, 255, 255, 0.08));\n  border-color: var(--vnsc-border-hover, rgba(255, 255, 255, 0.16));\n}\n[data-chart-mode=dark] .MultiChartsFooter_syncBtnActive {\n  color: var(--vnsc-text-on-primary, #ffffff);\n  background: var(--vnsc-accent-subtle, rgba(99, 102, 241, 0.2));\n  border-color: var(--vnsc-accent, #6366f1);\n  font-weight: 600;\n  box-shadow: 0 0 10px rgba(99, 102, 241, 0.15);\n}\n.vnsc-root {\n  box-sizing: border-box;\n  overflow: hidden;\n  user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n}\n.vnsc-root input,\n.vnsc-root select,\n.vnsc-root textarea {\n  user-select: text;\n  -webkit-user-select: text;\n  -ms-user-select: text;\n}\n.vnsc-root > *,\n.vnsc-root > *::before,\n.vnsc-root > *::after {\n  box-sizing: border-box;\n}\n.vnsc-root .vnsc-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: var(--vnsc-radius-md);\n  cursor: pointer;\n  font-family: inherit;\n  font-weight: 600;\n  transition: background var(--vnsc-transition-fast), color var(--vnsc-transition-fast);\n}\n.vnsc-root .vnsc-btn:hover {\n  background: var(--vnsc-accent-hover);\n  color: #fff;\n}\n.vnsc-root .vnsc-btn:active {\n  transform: scale(0.97);\n}\n.vnsc-root .vnsc-btn:focus-visible {\n  outline: var(--vnsc-focus-ring);\n  outline-offset: var(--vnsc-focus-ring-offset);\n}\n.vnsc-root .vnsc-chip {\n  padding: 3px 8px;\n  border: 1px solid transparent;\n  border-radius: var(--vnsc-radius-md);\n  cursor: pointer;\n  font-size: var(--vnsc-font-sm);\n  font-weight: 500;\n  background: transparent;\n  color: var(--vnsc-text-secondary);\n  transition: color var(--vnsc-transition-fast), border-color var(--vnsc-transition-fast);\n}\n.vnsc-root .vnsc-chip:hover {\n  color: var(--vnsc-text-primary);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n.vnsc-root .vnsc-chip--active {\n  color: var(--vnsc-text-primary);\n  font-weight: 600;\n  border-color: rgba(255, 255, 255, 0.18);\n}\n.vnsc-root .vnsc-chip--active:hover {\n  border-color: rgba(255, 255, 255, 0.25);\n}\n.vnsc-root .vnsc-sep {\n  width: 1px;\n  height: 16px;\n  background: var(--vnsc-border);\n}\n.vnsc-root ::-webkit-scrollbar {\n  width: 6px;\n}\n.vnsc-root ::-webkit-scrollbar-track {\n  background: transparent;\n}\n.vnsc-root ::-webkit-scrollbar-thumb {\n  background: var(--vnsc-border);\n  border-radius: var(--vnsc-radius-sm);\n}\n.vnsc-root ::-webkit-scrollbar-thumb:hover {\n  background: var(--vnsc-text-muted);\n}\n.vnsc-root,\n.vnsc-root input,\n.vnsc-root select,\n.vnsc-root textarea,\n.vnsc-root button {\n  font-family: \"Inter\", var(--gc-font, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif) !important;\n}\n.vnsc-root .vnsc-sidebar-splitter {\n  position: relative;\n  width: 4px;\n  height: 100%;\n  cursor: col-resize;\n  z-index: 49;\n  background: transparent;\n  transition: background var(--vnsc-transition-fast);\n}\n.vnsc-root .vnsc-sidebar-splitter:hover {\n  background: var(--vnsc-accent, #2962ff) !important;\n}\n.vnsc-root .vnsc-sidebar-right {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--vnsc-bg-secondary);\n  border-left: 1px solid var(--vnsc-border);\n  position: relative;\n  z-index: 48;\n  min-width: 150px;\n  overflow-y: auto;\n}\n.vnsc-root .vnsc-sidebar-right .vnsc-drawing-dock,\n.vnsc-root .vnsc-sidebar-right .vnsc-paper-trade-panel,\n.vnsc-root .vnsc-sidebar-right .vnsc-advisory-panel,\n.vnsc-root .vnsc-sidebar-right .vnsc-tape-panel {\n  position: relative !important;\n  top: auto !important;\n  bottom: auto !important;\n  right: auto !important;\n  left: auto !important;\n  width: 100% !important;\n  height: auto !important;\n  flex: 1 1 0% !important;\n  min-height: 140px !important;\n  border-left: none !important;\n  border-right: none !important;\n  z-index: auto !important;\n  background: transparent !important;\n}\n.vnsc-root .vnsc-sidebar-right > div:not(:last-child) {\n  border-bottom: 1px solid var(--vnsc-border) !important;\n}\n@keyframes vnsc-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.vnsc-root .vnsc-spinner {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  animation: vnsc-spin 1s linear infinite;\n}\n.vnsc-root:fullscreen {\n  background-color: var(--vnsc-bg-primary, #0a0e14) !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  padding: 0 !important;\n}\n.vnsc-root .vnsc-locked-feature {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border: 1px solid var(--vnsc-border, rgba(255, 255, 255, 0.08));\n  border-radius: 6px;\n  background: var(--vnsc-bg-hover, rgba(255, 255, 255, 0.03));\n  color: var(--vnsc-text-primary, #d1d4dc);\n  font: inherit;\n  font-size: 12px;\n  line-height: 1.35;\n  cursor: pointer;\n  text-align: left;\n}\n.vnsc-root .vnsc-locked-feature:hover {\n  background: var(--vnsc-bg-active, rgba(255, 255, 255, 0.08));\n  border-color: var(--vnsc-border-hover, rgba(255, 255, 255, 0.12));\n}\n.vnsc-root .vnsc-locked-feature:focus-visible {\n  outline: 2px solid var(--vnsc-focus-ring, var(--vnsc-accent, #6366f1));\n  outline-offset: 2px;\n}\n.vnsc-root .vnsc-locked-feature__icon {\n  font-size: 12px;\n  line-height: 1;\n}\n.vnsc-root .vnsc-locked-feature__label {\n  white-space: nowrap;\n}\n.vnsc-root .vnsc-locked-feature__plan {\n  color: var(--vnsc-text-secondary, #787b86);\n  white-space: nowrap;\n}\n.vnsc-root .vnsc-locked-feature__price {\n  color: var(--vnsc-accent, #6366f1);\n  font-weight: 600;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
